export const EnTranslation = {
  lang: "en",
  data: {
    MANAGE_RETURNS: {
      TITLE: "Manage returns",
      SEARCH_PLACEHOLDER: "Search return...",
      CREATE_NEW: "Create new",
      DOWNLOAD_EXCEL: "Download Excel",
      COMING_SOON: "Coming soon",
      CREATE: {
        TITLE: "Create new return",
        ON_BACK: "Back to returns",
        SECTION_TITLE: "Put basket informations",
        RETURN_CREATED: "Return created",
        FORM_INVALID: "Fill in the required fields",
      },
      CREATE_ITEMS: {
        SECTION_TITLE: "Select items to return",
        SEARCH_PLACEHOLDER: "Search items",
        FILTERS: "Filters",
        SMART_SELECTION: "Smart selection",
        VIEW_ALL: "All",
        VIEW_SELECTED: "Selected",
        SAVE_AS_DRAFT: "Save as draft",
        SAVE_AND_SEND: "Save and send request",
        COLUMNS: {
          FULFILLMENT_NUMBER: "Fulfillment number",
          ORDER_ID: "Order ID",
          SKU: "SKU",
          CODE_XIII: "Code XIII",
          DELIVERY_DATE: "Delivery date",
          WAREHOUSE: "Warehouse",
          QTY_DELIVERED: "Qty delivered",
          AVAILABLE_QTY: "Available qty",
          TOT_SELECTED: "Tot selected",
          EAN: "EAN",
          STATUS: "Status",
          QTY_SELECTED: "Qty selected",
          UNIT_PRICE: "Unit price",
          TOT_PRICE: "Tot price",
          MAX_RETURNABLE: "Max returnable",
          SET_QTY: "Set qty",
        },
        NO_ITEMS_SELECTED: "Select at least one item to return",
        INVALID_QTY: "Check the quantities to return",
        STORE_CONTEXT_MISSING: "Unable to determine the store: items cannot be loaded. Reload the page or contact support.",
        PRE_VALIDATION: {
          FAILED: "The request cannot be sent: check the reported issues",
          TITLE: "Some items cannot be returned",
          AVAILABLE_QTY: "available: {{qty}}",
          LINE_REASONS: {
            UNKNOWN: "Not returnable for an unspecified reason",
            NOT_POSITIVE_QUANTITY: "The quantity must be greater than zero",
            EXCEEDS_AVAILABLE: "The quantity exceeds the returnable quantity",
            NO_AVAILABILITY_INFO: "The item is no longer available for return",
            OUTSIDE_RETURN_WINDOW: "The return window for this item has expired",
            ORDER_NOT_RETURNABLE: "The source order is not in a returnable state",
            DUPLICATE_LINE: "The same item appears more than once in the request",
            NOT_FOR_REQUESTED_CUSTOMER_OR_STORE: "The item belongs to another customer or store",
          },
          SET_ISSUES: {
            UNKNOWN: "The request was refused for an unspecified reason",
            NO_ITEMS: "The request contains no valid items",
            MULTIPLE_WAREHOUSES: "The selected items belong to different warehouses",
            WAREHOUSE_NOT_ACTIVE: "The destination warehouse is not active",
            RETURNS_DISABLED_FOR_STORE: "Returns are disabled for this store",
            AMOUNT_EXCEEDS_ROLE_LIMIT: "The return amount exceeds your approval limit",
          },
        },
        FILTER_STYLE_CODE: "Style code",
        FILTER_SIZE: "Size",
        FILTER_ORDER_ID: "Order ID",
        FILTER_DELIVERY_DATE: "Delivery date",
        FILTER_STATUS: "Status",
        FILTER_STATUS_PARTIALLY: "Partially fulfilled",
        FILTER_STATUS_TOTALLY: "Totally fulfilled",
        SMART_NO_MATCH: "No items match the entered codes",
        WAREHOUSE_LOCKED: "Selection cancelled: these items belong to a different warehouse than the one already selected",
        SMART_RESULT: "{{selected}} items selected, {{unmatched}} codes not found, {{skipped}} skipped (different warehouse)",
        SMART_MODAL: {
          TITLE: "Smart selection",
          CODE_TYPE_LABEL: "Choose the type of code you will enter:",
          STYLE_CODE: "Style code",
          CODE_XIII: "Code XIII",
          ORDER_ID: "Order ID",
          CODES_LABEL: "Enter your codes below.",
          CODES_PLACEHOLDER: "Write or paste your codes here, separated by commas or spaces.",
          APPLY: "Apply smart selection",
        },
        SAVE_MODAL: {
          TITLE: "Save and send request",
          WARNING: "If you continue you won't be able to edit your changes.",
          SEE_EDITINGS: "See your editings",
          CANCEL: "Cancel",
          CONFIRM: "Save and send request",
          COLUMNS: {
            SKU: "SKU code",
            EAN: "EAN",
            OLD_QTY: "Old qty",
            NEW_QTY: "New qty",
          },
        },
      },
      COLUMNS: {
        NAME: "Columns",
        RETURN_NAME: "Name",
        ID: "ID",
        DATE: "Date",
        CUSTOMER: "Customer",
        POINT_OF_SALE: "Point of sale",
        AGENCY: "Agency",
        PCS_DELIVERED: "Pcs delivered",
        PCS_TO_RETURN: "Pcs to return",
        TOTAL: "Total",
        RETURN_REQUEST: "Return request",
      },
      FORM: {
        BASKET_NAME: "Basket name",
        CUSTOMER: "Customer",
        REASON: "Reason of return",
        NOTES: "Notes (optional, max 300 characters)",
        BASKET_NAME_HINT: "max 200 characters",
        OPTIONAL: "optional",
        TEXT_PLACEHOLDER: "Text...",
        BASKET_NAME_PLACEHOLDER: "Insert basket name...",
        NOTES_PLACEHOLDER: "Write your notes...",
      },
      STATUS: {
        DRAFT: "Draft",
        CREATED: "Sent to ERP",
        WAITING_APPROVAL: "Waiting approval",
        APPROVED: "Approved",
        FAILED: "Failed",
        REJECTED: "Rejected",
      },
      STATUS_INFO: {
        DRAFT: "The return is still editable",
        WAITING_APPROVAL: "An intern has to approve the return",
        CREATED: "Waiting for ERP approval",
        APPROVED: "Approved by ERP",
        REJECTED: "The return has been rejected by an intern",
        FAILED: "The return has been rejected by ERP",
      },
      DETAIL: {
        BACK_TO_RETURNS: "Back to returns",
        TITLE: "Return detail",
        CUSTOMER_INFO: "Customer info",
        NAME: "Name",
        NOTES: "Notes",
        REASON: "Reason",
        RMA_NUMBER: "RMA number",
        TOT_QTY: "Tot qty",
        TOT_RETAIL: "Tot retail",
        CUSTOMER: "Customer",
        BILLING_ADDRESS: "Billing address",
        SHIPPING_ADDRESS: "Shipping address",
        VAT: "VAT",
        AGENCY: "Agency",
        DELETE_DRAFT: "Delete draft",
        SEND_REQUEST: "Send request",
        DOWNLOAD_REPORT: "Download report",
        NOTES_MODAL_TITLE: "Notes (max 300 characters)",
        NOTES_SAVED: "Notes saved",
        REQUEST_SENT: "Return request sent",
        DRAFT_DELETED: "Draft deleted",
        DELETE_FAILED: "Delete failed",
        DELETE_DRAFT_CONFIRM: "Are you sure you want to delete this draft? This action cannot be undone.",
        DELETE_RETURN: "Delete return",
        DELETE_RETURN_CONFIRM: "Are you sure you want to delete this return? This action cannot be undone.",
        RETURN_DELETED: "Return deleted",
        RESTORE_DRAFT: "Restore draft",
        DRAFT_RESTORED: "Draft restored",
        CREATED_BANNER_TITLE: "Return request approved.",
        CREATED_BANNER_BODY: "Approved by {{user}} on {{date}} • Reason: {{reason}}.",
        CREATED_BANNER_BODY_TRAIL_ONLY: "Approved by {{user}} on {{date}}.",
        REJECTED_BANNER_TITLE: "Return request rejected.",
        REJECTED_BANNER_BODY: "Rejected by {{user}} on {{date}} • Reason: {{reason}}.",
        REJECTED_BANNER_BODY_TRAIL_ONLY: "Rejected by {{user}} on {{date}}.",
        FAILED_BANNER_TITLE: "Return rejected by ERP.",
        BANNER_BODY_REASON_ONLY: "Reason: {{reason}}.",
        ITEMS: "Items",
        ITEMS_COLUMNS: {
          SKU: "SKU",
          EAN: "EAN",
          STYLE: "Style",
          COLOR: "Color",
          SIZE: "Size",
          ORDER_ID: "Order ID",
          FULFILLMENT: "Fulfillment",
          RETURN_QTY: "Qty returned",
          INVOICE_ID: "Invoice ID",
        },
        EDIT_NAME: "Edit name (max 200 characters)",
        NAME_SAVED: "Name saved",
        ADD_ITEMS: "Add items",
        EDIT_ITEMS: "Edit items",
        CLOSE_SELECT_MODE: "Close select mode",
        EDIT_SELECTED_ITEMS: "Edit selected items",
        CANCEL: "Cancel",
        GO_BACK: "Go back",
        ITEMS_SELECTED: "selected",
        ITEMS_UPDATED: "Items updated",
        SAVE_AND_EXIT: "Save and exit",
        SAVE_AND_SEND_REQUEST: "Save and send request",
        SAVE_RECAP_WARNING: "If you continue you won't be able to edit your changes.",
        SEE_QUANTITY_CHANGES: "See quantity changes",
        SEE_DELETED_ITEMS: "See deleted items",
        NO_QUANTITY_CHANGES: "No quantity changes",
        NO_DELETED_ITEMS: "No deleted items",
        APPROVE: "Approve",
        REJECT: "Reject",
        APPROVE_RETURN: "Approve return",
        REJECT_RETURN: "Reject return",
        REJECTION_REASON: "Input reason (max 200 characters)",
        APPROVAL_REASON: "Input reason (optional, max 200 characters)",
        RETURN_APPROVED: "Return approved",
        RETURN_REJECTED: "Return rejected",
        ITEMS_ADDED: "Items added to the return",
        APPROVE_RANGE_INFO: "With the confirmation of this return, according to the configured range in the store settings:",
        RETURNED_AMOUNT: "Returned amount",
        PURCHASED_AMOUNT: "Purchased amount",
        RETURNABLE_AMOUNT: "Returnable amount",
        APPROVING_RETURN: "You are approving return #{{id}}.",
        REJECTING_RETURN: "You are about to reject return #{{id}}. This action cannot be undone.",
        PRODUCT_TITLE: "Product title",
        MAX_RETURNABLE_QTY: "Max returnable qty",
        CURRENT_QTY: "Current qty",
        NEW_QTY: "New quantity",
        ALL_ITEMS_REMOVED: "All selected items will be removed.",
        ITEMS_SEARCH_PLACEHOLDER: "Search items...",
        SELECTED_ITEMS: "Selected items",
        GROUP_BY: "Group by",
        GROUP_BY_NONE: "None",
        GROUP_BY_ORDER: "Order",
        GROUP_BY_PRODUCT: "Product",
        GROUP_ORDER_HEADER: "Order {{id}}",
        GROUP_UNKNOWN: "Unknown",
        GROUP_EMPTY: "No items match the current search or filters",
      },
    },
    CULTURE: {
      TITLE_MODAL: "Select the language",
      ITALIAN: "Italian",
      ENGLISH: "English",
      FRENCH: "French",
      SPANISH: "Spanish",
      GERMAN: "German",
    },
    PRODUCTS_LIST: {
      ACTIONS: "All products actions",
      HANDLE_IMAGES: "Handle images",
    },
    PRICE_LIST_DETAIL: {
      INFORMATION: "Information",
      NAME: "Name",
      ASSOCIATED_CUSTOMERS_COUNT: "Associated customers",
      TYPE: "Type",
      PRICE_LIST_TYPE: "Price list type",
      CUSTOM_PRICE_LIST: "Custom price list",
      DEFAULT_PRICE_LIST: "Default price list",
      STORE: "Store",
      INCLUDED_VARIANTS: "Included variants",
      EXCLUDED_VARIANTS: "Excluded variants",
      PRODUCT_LIST: "Product list",
      VARIANTS: "Variants",
      BACK_TO_PRICE_LISTS: "Back to price lists",
      PARENT_PRICE_LIST: "Reference price list",
    },
    MENU: {
      UTILITIES: {
        UTILITIES: "Utilities",
        BULK_OPERATIONS: "Bulk operations",
      },
      DASHBOARD: "Dashboard",
      ORDERS: "Orders",
      CARTS: "Carts",
      PROMOTIONS: "Promotions",
      CUSTOMIZATION_REQUESTS: "Customization requests",
      AUTOMATIC_DISCOUNTS: "Automatic discounts",
      RETURNS: "Returns",
      CUSTOMER_DISCOUNTS: "Customer discount",
      STORECHANNEL_DISCOUNT: "Store-channel discounts",
      GOK_MODE: "Gok",
      DIRECT_MODE: "Direct order",
      VOUCHERS: "Vouchers",
      COMMERCIAL_AGREEMENTS: "Commercial agreements",
      CUSTOMERS_DISCOUNTS: "Customers discounts",
      AGENTS: "Agents",
      GENERAL_FIELDS: "General fields",
      AGENCY_INFO: "Agency info",
      CUSTOMER_INFO: "Customer info",
      CATEGORIES: "Customer Classification Group",
      PAYMENT_TERMS: "Payment terms",
      COMPANY_FORMS: "Company forms",
      COURIERS: "Couriers",
      DOWNLOADS: {
        DOWNLOADS: "Downloads",
        REPORTS: "Reports",
      },
      PRODUCTS: {
        NAME: "Products",
        PRODUCTS_LIST: "Products list",
        INVENTORY_VISIBILITY: "Inventory visibility",
        ASSORTMENTS: "Assortments",
        IMPORT_PRODUCTS: "Import products",
        BULK_EDITOR: "Bulk editor",
        VARIANT_BULK_EDITOR: "Variants editor",
      },
      SETTINGS: {
        NAME: "Settings",
        STORE_SETTINGS: "Store settings",
        PRICE_LIST: "Price list",
        TIERS: "Tiers",
        SALES_CAMPAIGNS: "Sales campaigns",
        TERMS_OF_SALE: "Terms of sale",
        SEASON_REFERENCE: "Season Reference",
        PACKAGE_GROUP: "Package Group",
        TRANSPORT_AGENCY: "Transport agency",
        ORDER_LABEL: "Order label (optional)",
        DEFAULT: "Default",
        EMAIL_SETTINGS: "Email settings",
        EMAIL_FOR_CHANNEL: "Email for channel",
        OVERRIDE_EMAIL_INFO:
          "Below you can specify different emails for each sales channel. If no email is specified for a channel, the default email will be used.",
        SHIPPING_COST_SETTINGS: "Shipping cost settings",
        FREE_SHIPPING_THRESHOLD: "Free shipping threshold",
        SHIPPING_COST: "Shipping cost",
        AVOID_REPLACEMENT_SHIPPING_COSTS: "No shipping costs on item exchange orders",
        AVOID_REPLACEMENT_SHIPPING_COSTS_HINT:
          "Courier costs included. Applies to carts confirmed from now on: orders already confirmed do not change.",
        RETURN_SETTINGS: "Return settings",
        RETURN_AMOUNTS_INFO: "Returned amount: €X · Purchased amount: €Y · Returnable amount: €Z.",
        RETURN_WINDOW: "Return window",
        RETURN_WINDOW_DISABLED_NOTE: "Leave empty to disable returns for this store.",
        DAYS: "Days",
        INTERNAL_RETURN_APPROVAL_LIMIT: "Internal return approval limit",
        INTERNAL_RETURN_APPROVAL_LIMIT_NOTE: "Returns above the set limit can only be approved by admins.",
        INTERNAL_RETURN_APPROVAL_LIMIT_EMPTY_NOTE: "Leave empty for no limit.",
        INTERNAL_RETURN_APPROVAL_LIMIT_STORE_OWNER: "Store owner limit — Euro (€)",
        INTERNAL_RETURN_APPROVAL_LIMIT_ADMIN: "Admin limit — Euro (€)",
        EURO: "Euro (€)",
        RETURN_NOTIFICATIONS: "Return notifications",
        RETURN_NOTIFICATIONS_DISABLED_NOTE: "Leave empty to disable all return e-mails.",
        RETURN_NOTIFICATIONS_EMAIL: "E-Mail receiving return notifications",
        NUMBER_OF_DAYS_TO_CALCULATE_THE_RE_ORDER_DATE:
          "Number of days to calculate the re-order date",
        DEFAULT_LIMIT_FOR_STYLE_COLOR_OF_MONOBRAND_STORES:
          "Default purchase limit on style-color (for sales channels that require it)",
        MINIMUM_VALUE_FOR_THE_TOTAL_ORDER_AMOUNT:
          "Minimum value of a cart to create the corresponding order (for sales channels that require it)",
        MINIMUM_REORDER_QUANTITY:
          "Minimum reorder quantity (for sales channels that require it)",
        MINIMUM_REORDER_QUANTITY_TOOLTIP:
          "This minimum quantity only applies to Customer and Customer Owner roles when they order in re-order.",
        FREE_SHIPPING_ORDER_TOTAL_THRESHOLD:
          "Free shipping order total threshold (for sales channels that require it)",
        GENERAL: "General",
        STORE_NAME: "Name",
        DISCOUNT: "Discount",
        CURRENCY: "Currency",
        SALES_SETTINGS: "Sales settings",
        PRE_ORDER_ACTIVE_FROM: "Pre-order active from",
        PRE_ORDER_ACTIVE_TO: "Pre-order active to",
        RE_ORDER_ACTIVE_FROM: "Re-order active from",
        RE_ORDER_ACTIVE_TO: "Re-order active to",
        MAX_CUSTOM_DATES: "Custom delivery date possible up to",

        BACKGROUND_IMAGE: "Backround image",
        LOGO_IMAGE: "Logo image",
        FAVICON_IMAGE: "Fav icon",
        ADD: "Add",
        CHANGE: "Change",
        SMALL_LOGO: "Small logo",

        UPLOAD_MEDIA: "Upload media",
        UPLOAD_EXCEL: "Upload Excel",
        SAVE: "Save",
        UPLOAD_FILE: "Upload file",
        UPLOAD_LINK: 'Upload link',
        VALID_URL: 'Please enter a valid URL',
        AVILABLE_FILE_SIZE: "Maximum file size",

        PRIMARY_COLOR: "Primary color",
        MAIL_NOTIFICATIONS: "E-Mail receiving shop notifications",
        MAIL_SENDER: "Shop sender e-mail",
        FOOTER_TEXT: "Footer text",
        CART_NAME_MAX_LENGTH: "Maximum length of a cart name",
        CART_NOTIFICATION_SETTINGS: "Inactive cart notification settings",
        CART_NOTIFICATION_THRESHOLD:
          "Cart notification deletion threshold in days",
        CART_NOTIFICATION_DELETION_THRESHOLD:
          "Inactive cart deletion threshold in days",
        DEFAULT_DESIGNER: "Default designer",
        KUSTOM_EMAIL: "Kustom email",
        KUSTOM_PHONE: "Kustom phone",
        KUSTOM_EMAIL_SECONDARY: "Kustom email secondary",
        KUSTOM_SETTINGS: "BasicKustom settings",
        KUSTOM_MIN_QUANTYTY_FOR_PRODUCT:
          "Minimum purchase quantity for customized product in requests",
        ENABLE_KUSTOM: "BasicKustom enabled",
        DISABLE_KUSTOM: "BasicKustom disabled",
        PLEASE_FILL_ALL_REQUIRED_FIELDS: "Please fill in all required fields",
      },
      AGENCIES: "Agencies",
      CUSTOMERS: "Customers",
      USERS: "Users",
      LOCATIONS: "Locations",
      TUTORIAL: {
        NAME: "Tutorial",
        VIDEO: "Video",
        DOCUMENTATION: "Documentation",
      },
      BY_DATE: "Delivery date",
      CUSTOM_DATE: "Custom date",
      STYLE_CODE: "Style code",
    },
    IMPORT_PRODUCTS: {
      START_SEARCH: "Insert search text to start your import",
      DESELECT_ALL: "Deselect all",
      RELOAD_PRODUCTS: "Reload products",
      SEARCH_BY: 'Search by',
      ID: "ID",
      NAME: "Name",
      SELLING_PERIOD: "Selling period",
      PRODUCTS_QUANTITY: "Products quantity",
      LOAD_MORE_DATA: "Load more data",
      THERE_IS_NO_MORE_DATA: "There is no more data",
      STATUS: {
        IMPORTED: "Imported",
        NOT_IMPORTED: "Not imported",
        IMPORTING: "Importing..",
        FAILED: "Failed",
      },
      MODAL: {
        TITLE: "Import products",
        YOU_HAVE_SELECTED: "You have selected",
        ITEMS: "items",
        ATTENTTION_YOU_ARE_IMPORTING: "Attention! You are importing",
        MESSAGE:
          "styles already imported. All changes about it and its variants will be lost. Are you sure?",
        YOU_HAVE_TO_SELECT_AT_LAST_ONE_ITEM:
          "You have to select at last one item",
        USE_CUSTOM_DISCOUNT: "Set custom discount to calculate wholesale price",
        USE_CUSTOM_DISCOUNT_INFO:
          "If you set up a custom discount, it will be used to calculate wholesale price of all in-import product variants, both for PRE Order and RE Order price calculation. If you don't set it instead, the last used percentage will be used for products already imported in the past and the current shop's base discount for products that have never been imported.",
      },
    },
    USERMENU: {
      SHOP: "Shop",
      MY_PROFILE: "My profile",
      LOGOUT: "Logout",
      SWITCH_TENANT: "Switch country",
      LOGOUT_CONFIRM: "Are you sure you want to logout?",
      CANCEL: "Cancel",
    },
    BACK_TO: {
      SALES_CAMPAIGN: "Return to the sales campaign",
      SALES_CAMPAIGNS: "Return to the sales campaigns",
    },
    GENERIC_LABEL: {
      FILTER: 'Filter',
      SELECT: "Select",
      SELECT_ALL: "Select all",
      SELECT_SIZE: "Select size",
      COPY: "Copy",
      APPROVE: "Approve",
      SALES_COMPAIGN: "Sales campaign",
      CHOOSE_FILE: "Choose file",
      BACK: "Back",
      SYNC_START: "Sync started",
      ADD_NEW: "Add new",
      ADD: "Add",
      SAVE: "Save",
      SAVE_CHANGES: "Save changes",
      "SAVE AND_SYNC_LATER": "Save and sync later",
      SAVE_AND_SYNC_NOW: "Save and sync now",
      DELETE: "Delete",
      CANCEL: "Cancel",
      CLOSE: "Close",
      TRANSFORM_INTO_DRAFT: "Convert back to cart",
      LEAVE_PAGE: "Leave page",
      ACTIONS: "Actions",
      UPLOAD: "Upload",
      IMPORT: "Import",
      DUPLICATE: "Duplicate",
      CONFIRM: "Confirm",
      SEND_CONFIRMATION_MAIL: "Resend confirmation mail",
      EDIT: "Edit",
      EDIT_ITEMS: "Edit items",
      EDIT_CART: "Edit cart",
      ACTIVATE: "Activate",
      SEND: "Send",
      RESEND: "Resend",
      DEACTIVATE: "Deactivate",
      FORM_ERROR: "Missing or incorrect data",
      YES: "Yes",
      NO: "No",
      PRINT: "Print",
      PRINT_PREVIEW: "Print preview",
      ERROR: "Error!",
      ARE_YOU_SURE: "Are you sure?",
      ARE_YOU_SURE_YOU_WANT_TO_PROCEED: "Are you sure you want to proceed?",
      DONE: "Done!",
      REMOVE: "Remove",
      BLOCKED: "Blocked",
      UNBLOCKED: "Not blocked",
      USER: "User",
      ACTIVATED: "Activated",
      DEACTIVATED: "Deactivated",
      MAN: "Man",
      WOMAN: "Woman",
      UNISEX: "Unisex",
      UNPUBLISH: "Unpublish",
      CREATE: "Create",
      LOSING_CHANGES_MESSAGE:
        "Unsaved changes will be lost. Do you want to proceed?",
      SETTINGS: "Settings",
      DETAILS: "Details",
      START_SYNC: "Start sync with ERP",
      THE_VALUE_MUST_BE_BETWEEN:
        "The value must be between {{min}} and {{max}}",
      MAX_LENGTH: "Max {{max}} characters, you have inserted {{length}}",
      ATTENTION: "Attention!",
      PREVIEW: "Preview",
      DOWNLOAD: "Download {{extension}}",
      APPLY: "Apply",
      NEXT: "Next",
      SELECT_CODE: "Select code",
      DOWNLOAD_REPORT: "Download reports",
      EXPORT_ORDERS: "Export orders",
      ONLY_WITH_STOCK_PRODUCTS: "Only available products",
      PRODUCT_TYPE: "Product type",
      REPORTS_MODAL_MESSAGE:
        "Set any filters and you will receive the report in your email inbox.",
      STORE_VARIANTS_REPORT: "Store variants report",
      CUSTOMER_REPORT: "Customer reports",
      FROM_DATE: "From",
      TO_DATE: "To",
      SALES_CAMPAIGN: "Sales campaign",
      SELECTED_ORDERS: "Selected orders",
      NO_ORDERS_SELECTED: "No orders selected",
      SELECTED: "Selected",
      EDIT_SELECTED_ORDERS: "Edit selected orders",
      DELETE_ORDERS: "Delete orders",
      CANCEL_ORDERS: "Cancel orders",
      DELETE_ORDERS_BY_EXCEL: "Delete orders by Excel",
      SUCCESS_DELETE_ORDERS: "Orders deleted successfully",
      UPLOAD_ORDERS_TEMPLATE:
        "Upload articles of your orders using the template",
      DOWNLOAD_TEMPLATE: "Download template",
      ERROR_NEGATIVE_NUMBERS:
        "It is not possible to enter negative numbers or decimals",
      INVALID_QUANTITY: "Invalid quantity",
      NAME: "Name",
      CART_QTY: "items in the cart",
      BULK_SELECTION: "Bulk selection",
      WORKING_MODE: "Select the working mode",
      SELECT_FILTERS: "Select by filters",
      SELECT_FREE_TEXT: "Select by external IDs",
      ENTER_ORDER_IDS: "Enter Order IDs",
      ENTER_ORDER_IDS_PLACEHOLDER:
        "Type or paste one or more external order IDs, separated by semicolon",
      OTHERS: "Others",
      DRAG_DROP_REORDER_COLUMNS:
        "In this table you can reorder columns via drag & drop",
      VIEW_PENDING_BULK: "View pending bulk",
      GO_BACK: "Go back",
      CART_SUMMARY: "Cart summary",
    },
    MANAGE_GENERAL_FIELDS: {
      FIELDS_TYPE: "Field type",
      VALUE_SET: "Value Set",
      TABLE: {
        VALUE: "Value",
        DECIMAL_VALUE: "Decimal value",
        CREATION_TIME: "Creation date",
        LAST_UPDATE: "Last update",
        DELETE_GF: "Delete general field",
        ARE_YOU_SURE: "Are you sure you want to delete this general field?",
        EDIT_GF: "Edit general field",
        CREATE_GF: "Create new general field",
        CODE: "Code",
        DESCRIPTION: "Description",
        ID: "ID",
        EXTERNAL_ID: "External ID",
        NAME: "Name",
        ORDER: "Order",
        COST: "Cost",
        IS_PUBLIC: "Public",
      },
    },
    TABLE: {
      ACTION: {
        NAME: "Actions",
        EDIT: "Edit",
        DELETE: "Delete",
        CREATE_NEW: "Create New",
        EXPORT: "Export",
        IMPORT: "Import",
        INVITE_USER: "Invite user",
        DUPLICATE: "Duplicate",
        VIEW_DETAILS: "View details",
        ACTIVATE: "Activate",
        DEACTIVATE: "Deactivate",
        REFRESH: "Refresh",
        ARCHIVE: "Archive",
        UPLOAD: "Upload",
        DOWNLOAD_LIST: "Download list",
        CREATE_CART_FROM_EXCEL: "Create carts from Excel",
        MANAGE_ASSORTMENT: "Manage Assortments",
      },
      FILTERS: {
        WITH_CUSTOMIZATION_REQUESTS: "With customization request",
        BY_CUSTOMIZATION_REQUESTS: "By customization request",
        FILTERS: "Filters",
        CREATOR: "Creator",
        REQUESTER: "Requester",
        CUSTOMER_REQUESTER: "Customer Requester",
        AGENCY_REQUESTER: "Agency Requester",
        DESIGNER: "Designer",
        APPROVED_BY: "Approved by",
        APPLY_FILTER: "Apply filter",
        ACTIVE_FILTERS: "Active filters",
        SEARCH: "Search",
        VISIBILITY_TYPE: "Type",
        TYPE: "Type",
        VALIDITY: "Validity",
        REORDER: "Re-order",
        PREORDER: "Pre-order",
        PRE_ORDER: "Pre-order",
        RE_ORDER: "Re-order",
        WHOLESALE_PRICE: "Wholesale price",
        NEW_WHOLESALE_PRICE: "New wholesale price",
        FROM: "From",
        TO: "To",
        RETAIL_PRICE: "Retail price",
        STOCK: "Stock",
        ASSORTMENT: "Assortment",
        STYLE_GROUP: "Style group",
        CITY: "City",
        TIER: "Tier",
        STORE: "Store",
        CUSTOMER: "Customer",
        CUSTOMER_TYPE: "Customer type",
        AGENCY: "Agency",
        ONLINE_STORES: "Online stores",
        WITHOUT_STORE: "Without store",
        POINT_OF_SALE: "Point of sale",
        POS: "Point of sale",
        ORDER_STATUS: "Order status",
        STATUS: "Status",
        PROJECT_TYPE: "Project type",
        LOCATION_TYPE: "Location type",
        REGISTERED_DATE: "Registered date",
        ROLE: "Role",
        ONLY_INCLUDED: "Only included",
        COLORS: "Colors",
        SIZE: "Size",
        SIZE_GROUP: "Size group",
        NOTES: "Notes",
        HAS_NOTES: "With notes",
        EXTERNAL_COLLECTIONS: "External collections",
        EXTERNAL_ORDER_ID: "External order ID",
        CHANNEL: "Channel",
        PRODUCTS: "Products",
        OPERATION_TYPE: "Operation type",
        CUSTOMER_AMMINISTRATIVE_STATUS: "Commercial block status",
        SHOW_ONLY_BLOCKED: "Show only blocked customer",
        SHOW_ONLY_WITH_CR: "Show orders with associated customization requests",
        CHANNEL_ID: "Channel id",
        CREATED_AFTER: "Created after",
        CREATED_BEFORE: "Creato before",
        SELECT_ORDERS: "Select orders",
        MANAGEMENT_ORDERS: "Manage orders",
        GO_BACK_TO_ORDERS: "Go back to orders",
        SELECTED_ORDERS: "Selected orders",
        NO_ORDERS_SELECTED: "No orders selected",
        SELECTED: "Selected",
        ECPORT_ORDERS: "Export orders",
        EDIT_SELECTED_ORDERS: "Edit selected orders",
        COMERCIAL_BLOCK: "Commercial block",
        COMPLETED_AT: "Completed at",
        SHOW_CR_WITH_DESIGNER_NOTIFICATION:
          "Show only customization requests with requester notification",
        ORDER_BULK_OPERATION_SCOPE: "Scope operations",
        ORDER: "Order",
      },

      CUSTOMIZATION_REQUEST: {
        TITLE: "Customization requests",
        COLUMN: {
          NAME: "Name",
          STATUS: "Status",
          CUSTOMER: "Customer",
          CHANNEL: "Channel",
          POINT_OF_SALE: "Point of Sale",
          TOTAL_WHOLESALE: "Tot. Wholesale",
          PRODUCT_NUMBER: "Product Number",
          LAST_UPDATE: "Last update",
          WITH_REQUESTER_NOTIFICATION: "With requester notification",
          LAST_UPDATE_REQUESTER: "Last update requester",
          LAST_DESIGNER_NOTIFICATION: 'Requester notification sent at',
          PROJECT: 'Project',
          NOTIFICATIONS: 'Notifications',
        },
      },

      PRICE_LIST: {
        DEFAULT_PRICE_LIST: "Default price list",
        CUSTOM_PRICE_LIST: "Custom price lists",
        CREATE_PRICE_LIST: "Create price list",
        NAME: "Name",
        PARENT_PRICE_LIST: "Parent price list",
        TYPE: "Type",
        STORE: "Store",
        ASSOCIATED_CUSTOMERS:
          "Select if you want to proceed with associating customers to this price list",
      },

      PRICE_LIST_DETAIL: {
        COLUMNS: {
          SKU: "SKU",
          PALETTE: "Palette",
          TYPE: "Type",
          PRE_ORDER: "Pre-order",
          RE_ORDER: "Re-order",
          CURRENCY: "Currency",
          DEFAULTRETAILPRICE: "Default retail price",
          DEFAULTWHOLESALEPRICE: "Default wholesale price",
          CUSTOMRETAILPRICE: "Custom retail price",
          CUSTOMWHOLESALEPRICE: "Custom wholesale price",
        },
      },

      SUPER_BULK: {
        COLUMN: {
          ID: "Id",
          USER: "User",
          OPERATION_TYPE: "Operation type",
          CREATION_TIME: "Creation time",
          START_AT: "Start at",
          CONCLUDED_AT: "Concluded at",
          STATUS: "Status",
        },
        OPERATION_TYPE: {
          UPDATING_VISIBILITY_PRE: "Updating pre-order visibility",
          UPDATING_VISIBILITY_RE: "Updating re-order visibility",
          UPDATING_VISIBILITY: "Updating visibility",
          UPDATING_PRICE: "Updating price",
          UPDATING_BLANK_CELL: "Updating blank cell",
          ASSOCIATING_TIER: "Associating tier",
          DISASSOCIATING_TIER: "Disassociating tier",
          ASSOCIATING_ASSORTMENT: "Associating assortment",
          DISASSOCIATING_ASSORTMENT: "Disassociating assortment",
          ASSOCIATING_PROMOTION: "Associating promotion",
          DISASSOCIATING_PROMOTION: "Disassociating promotion",
          UPDATE_PALETTES_STOCK_LIMITS:
            "Update purchase limits by color (for supported channels)",
        },
      },

      BULK_OPERATIONS: {
        NAME: "Operations",
        COLUMNS: {
          ID: "Id",
          TYPE: "Type",
          CREATOR: "Creator",
          CREATED_AT: "Creation date",
          SCOPE: "Scope",
          STATUS: "Status",
          ISSUE: "Issue",
          ORDER_ITEM_ID: "Order item ID",
          ORDER_ID: "Order ID",
          ORDER_NUMBER: "Order number",
          CUSTOMER_NAME: "Customer name",
          CUSTOMER_ACCOUNT: "Account Number",
          STARTED_AT: "Started at",
          CONCLUDED_AT: "Concluded at",
          PROCESSED_ORDER_ITEMS_COUNT: "Processed order items count",
          PROCESSED_WITH_ISSUES_COUNT: "Processed with issues count",
          HAS_PENDING: 'Sync pend.'
        },
        GO_TO_ORDER: 'Go to order detail',
      },

      BULK_EDIT_ORDERS_MODAL: {
        INFO_MESSAGE:
          "By using the checkboxes, you can edit multiple items at the same time. Warning: when you save, all items in this window will be saved, regardless of the selected ones.",
        ADD_NEW_ITEMS: "Add new items",
        REPLACE_ITEMS: "Replace items",
        REMOVE_ITEMS: "Remove items",
        CURRENT_DATE: "Current date",
        NEW_DATE: "New date",
        CHANGE_ITEMS_DELIVERY_DATE: "Change items delivery date",
        SUCCESS_CHANGE_ITEMS_DELIVERY_DATE:
          "Items delivery date changed successfully",
        ADD_DELIVERIES: "Add deliveries",
        ADD_DELIVERIES_DUPLICATE_DATE: "This item already has a delivery on this date",
        SUCCESS_ADD_ITEMS: "Items added successfully",
        SUCCESS_CHANGE_ITEMS_WHOLESALE_PRICE:
          "Wholesale prices changed successfully",
        INVALID_PRICE: "The wholesale price is not valid",
        CHANGE_CUSTOMER_AND_SHIPPING_ADDRESS:
          "Change customer and shipping address",
        EDIT_QUANTITY: "Edit quantity",
        EDIT_NET_PRICE: "Edit net price",
        EDIT_RETAIL_PRICE: "Edit retail price",
        CURRENT_UNIT_PRICE: "Current unit price",
        WHOLESALE_PRICE: "Wholesale price",
        NEW_UNIT_PRICE: "New unit price",
        NEW_RETAIL_PRICE: "New retail price",
        CURRENT_RETAIL_PRICE: "Current retail price",
        RETAIL_PRICE: "Retail price",
        DISCOUNT: "Discount",
        SUCCESS_REPLACE_ITEMS: "Items replaced successfully",
        SUCCESS_CHANGE_ITEMS_QUANTITY: "Items quantity changed successfully",
        SUCCESS_DELETE_ITEMS: "Items deleted successfully",
        SUCCESS_OPERATION: "Operation queued successfully",
      },

      COMMERCIAL_AGREEMENT: {
        NAME: "Commercial agreements",
        COLUMNS: {
          ID: "Id",
          NAME: "Name",
          VALID_FROM: "Valid from",
          VALID_UNTIL: "Valid until",
          DISCOUNT_PERCENTAGE: "% percentage",
          TOTAL_RETAIL_AMOUNT: "Tot. retail (€)",
          RESIDUAL_RETAIL_AMOUNT: "Tot. residual (€)",
          CUSTOMER_NAME: "Customer name",
          STATUS: "Status",
          CONSUMPTION: "Consumption",
        },
        MODAL_DELETE: {
          TITLE: "Delete commercial agreement",
          MESSAGE: "Are you sure you want to delete this commercial agreement?",
          ATTENTION_COMMERCIAL_AGREEMENT_IS_LINKED_ON_VARIOUS_CART:
            "<strong>Attention!</strong> There are {{draftOrdersCount}} carts linked to this trade agreement. By deleting this agreement, the associations will also be removed.",
        },
      },

      TERM_OF_SALE: {
        NAME: "Term of sale",
        COLUMNS: {
          ID: "Id",
          NAME: "Name",
          STATUS: "Status",
          CREATION_TIME: "Creation time",
          LAST_UPDATE_TIME: "Last update time",
        },
      },

      FULFILLMENT: {
        GROUP_ELEMENT: {
          SHIPPING_PACKAGE: "Package",
          TOTAL_QUANTITY: "Total quantity",
          TOTAL_WEIGHT: "Total weight",
        },
        COLUMNS: {
          STYLE: "Style",
          COLOR: "Color",
          SIZE: "Size",
          QUANTITY: "Qty",
          AMOUNT: "Amount",
          EAN: "EAN",
          ORDER_ID: "Order ID",
        },
      },

      PROMOTION: {
        NAME: "Promotions",
        COLUMNS: {
          ID: "Id",
          NAME: "Name",
          VALID_FROM: "Valid from",
          VALID_TO: "Valid to",
          TYPE: "Type",
          VALID_ON: "Valid on",
        },
        MODAL_DELETE_PROMOTION: {
          ARE_YOU_SURE: "Are you sure?",
          ARE_YOU_SURE_DELETE_PROMOTION:
            "Are you sure you want to delete this promotion?",
        },
        INFO_ALLERT:
          "Automatic discounts that are set will not be enabled on channels",
      },
      VOUCHERS: {
        NAME: "Vouchers",
        COLUMNS: {
          ID: "Id",
          CODE: "Code",
          DESCRIPTION: "Description",
          CONSTRAINT_TYPE: "Constraint",
          AMOUNT: "Amount",
          THRESHOLD: "Threshold",
          VALID_FROM: "Valid from",
          VALID_TO: "Valid to",
          RESIDUAL_AMOUNT: "Residual amount",
          STATUS: "Status",
        },
        MODAL_DELETE_VOUCHER: {
          ARE_YOU_SURE: "Are you sure?",
          ARE_YOU_SURE_DELETE_VOUCHER:
            "Are you sure you want to delete the customer?",
          ARE_YOU_SURE_DELETE_CUSTOMER:
            "Are you sure you want to disassociate the voucher from the customer?",
        },
        INFO_ALLERT: "Vouchers that are set up will not be enabled on channels",
      },

      PRIVILEGES_CASH: {
        COLUMNS: {
          EXTERNAL_ID: "ID",
          NAME: "Name",
          INITIAL_AMOUNT_WITH_VAT: "Initial amount with VAT",
          RESIDUAL_AMOUNT_WITH_VAT: "Residual amount with VAT",
          RESIDUAL_AMOUNT_WITHOUT_VAT: "Residual amount without VAT",
          VALID_FROM: "Valid from",
          VALID_TO: "Valid to",
          STATUS: "Status",
        },
        STATUS: {
          IMPORTABLE: "Importable",
          ALREADY_IMPORTED: "Already imported",
        },
      },

      DISCOUNT: {
        NAME: "Discounts",
      },

      CART: {
        NAME: "Carts",
        COLUMNS: {
          ID: "Id",
          NAME: "Name",
          VARIANTS: "Variants",
          POS: "Point of sale",
          TOTAL: "Total",
          TOTAL_RETAIL: "Total retail",
          DATE: "Date",
          TYPE: "Type",
          AGENCY_CODE: "Agency",
          CHANNEL_NAME: "Channel",
          PCS: "Pcs",
          SEASON_REFERENCE: "Season reference",
          NOTE: "Notes",
          EXTERNAL_ID: "External ID",
        },
        ASTERISK_MESSAGE:
          "Totals calculated on retail prices because they belong to the channels",
        MISSING_EXCEL_FILE_MESSAGE:
          "To continue, you must upload an Excel file",
        MISSING_EXCE_CODE_MESSAGE:
          "Select a code type to download the template",
        UPLOAD_DONE:
          "Operation started successfully! You will receive an email with the result of the operation.",
        MODAL_IMPORT: {
          IMPORT_CART_FROM_FILE_XLSX: "Import cart from file (XLSX)",
          CART_REPORT_UPLOADED: "Cart report uploaded",
          CUSTOMER: "Customer",
          POINT_OF_SALE: "Point of sale",
          CART_NAME: "Cart name",
          TYPE: "Type",
          ALTERNATIVE_SHIPPING_ADDRESS: "Alternative shipping address",
          PRODUCT: "Product",
          AGENCY: "Agency",
        },
        MODAL_DUPLICATE_CART: {
          DUPLICATE_CART: "Duplicate cart",
          DUPLICATE: "Duplicate",
        },
        MODAL_DELETE_CART: {
          ARE_YOU_SURE: "Are you sure?",
          ARE_YOU_SURE_DELETE_CART: "Are you sure you want to delete cart?",
        },
      },

      ADMIN_DOWNLOADS: {
        NAME: "Administrative Downloads",
        COLUMNS: {
          ID: "Id",
          NAME: "Name",
          EXTENTION: "Type",
          UPLOAD_DATE: "Upload date",
          CREATOR: "Creator",
        },
        ACTION: {
          DOWNLOAD: "Download",
          DELETE: "Delete",
          UPLOAD_FILE: "Upload file",
        },
        MODAL_DELETE_FILE: {
          ARE_YOU_SURE: "Are you sure?",
          ARE_YOU_SURE_DELETE_FILE:
            "Are you sure you want to delete this file?",
        },
      },

      ORDER: {
        NAME: "Orders",
        COLUMNS: {
          STATUS: "Status",
          PENDING_BULK: "Operations",
          OPERATIONS: "Operations",
          POINTS_OF_SALES: "Points of sales",
          AGENCY_CODE: "Agency code",
          CUSTOMER: "Customer",
          GOK: "GOK",
          REASSORTMENT: "Reassortment",
          PRODUCT_EXCHANGE: "Product exchange",
        },
      },

      ASSORTMENTS: {
        NAME: "Assortments",
        COLUMNS: {
          ID: "Id",
          TITLE: "Title",
          CHANNEL_NAME: "Channel",
          RE_ORDER: "Re-order",
          PRE_ORDER: "Pre-order",
        },
      },

      VARIANT_BULK_EDITOR: {
        NAME: "Variants editor",
        INCLUDE_BY: "Select by: ",
        INCLUDE_BY_ASSORTMENT: "Assortment",
        INCLUDE_BY_COLLECTION: "Collection",
        INCLUDE_BY_TIER: "Tier",
        SELECTED: "Selected",
        EDIT_SELECTED: "Edit selected",
        DESELECT_ALL: "Deselect all",
        YOU_HAVE_JUST_SELECTED: "You have just selected",
        NEW_VARIANTS_FROM_ASSORTMENT: "new variants from assortment",
        NEW_VARIANTS_FROM_COLLECTION: "new variants from collection",
        NEW_VARIANTS_FROM_TIER: "new variants from tier",
        YOU_CAN_SELECT_ALL_VARIANT_OF_A_GIVEN_ASSORTMENT:
          "You can select all variant of a given assortment",
        YOU_CAN_SELECT_ALL_VARIANT_OF_A_GIVEN_COLLECTION:
          "You can select all variant of a given collection",
        YOU_CAN_SELECT_ALL_VARIANT_OF_A_GIVEN_TIER:
          "You can select all variant of a given tier",
        NO_ASSORTMENT_TO_VIEW: "No assortment to view",
        NO_COLLECTION_TO_VIEW: "No collection to view",
        NO_SELECTED_VARIANTS: "No selected variants",
        ORDERS_FROM_LIST: "Orders from list",
        CONFIRM_LEAVE_PAGE: {
          ARE_YOUR_SURE: "Are you sure?",
          IF_YUO_LEAVE_PAGE_YOU_WILL_LOSE_ALL_CHANGES:
            "If you leave page you will lose all changes",
        },
        UNPUBLISH_ALL_FOR_PRE_ORDER: "Unpublish all variants for pre-order",
        ARE_YOU_SURE: "Are you sure?",
        ARE_YOU_SURE_UNPUBLISH_ALL_VARIANTS_FROM_PRE_ORDER:
          "Are you sure you want to unpublish all variants from pre-order?",
        UNPUBLISH_ALL_FOR_PRE_ORDER_WARNING:
          "This action will be applied to all products",
        MESSAGE_SUCCESS_UNPUBLISH:
          "All variants have been unpublished from pre-order",
        MESSAGE_SUCCESS_SEND_EMAIL:
          "The report of variants pre-order has been sent successfully",
        DOWNLOAD_REPORT_VARIANTS_ON_PRE_ORDER:
          "Download report of variants pre-order",
        DOWNLOAD_REPORT_VARIANTS_ON_RE_ORDER:
          "Download report of variants re-order",
        DOWNLOAD_REPORT_VARIANTS: "Download report of variants",
        DOWNLOAD_REPORTS: "Download reports",
        PUBLISHED_VARIANTS: "By publication end sale channel",
        REPORT_OF_VARIANTS: "Report of variants",
        DOWNLOAD_REPORT_OF_VARIANTS: "Download report of variants",
        ARE_YOU_SURE_DELETE_ORDERS:
          "Are you sure you want to delete this tier?",
      },

      TIERS: {
        NAME: "Tiers",
        CREATE_MODAL: {
          ADD_NEW_TIER: "Add new tier",
          EDIT_TIER: "Edit tier",
          NAME: "Name",
          DESCRIPTION: "Description",
        },
        COLUMNS: {
          ID: "Id",
          NAME: "Name",
          DESCRIPTION: "Description",
          CREATED_ON: "Created on",
          CREATED_BY: "Created by",
        },
        DELETE_MODAL: {
          TITLE: "Are you sure?",
          DESCRIPTION: "Are you sure you want to delete this tier?",
        },
        ARCHIVE_MODAL_DESCRIPTION:
          "Are you sure you want to archive this tier? The operation is not reversible.",
      },

      SEASON_REFERENCE: {
        NAME: "Season Reference",
        CREATE_EDIT: {
          NAME: "Name",
          DATE_FROM: "Valid from",
          DATE_TO: "Valid until",
        },
        TABLE: {
          ID: "External id",
          NAME: "Name",
          DATE_FROM: "Valid from",
          DATE_TO: "Valid until",
        },
        CREATE_OR_EDIT: {
          CREATE_NEW: "Create new",
          EDIT: "Edit",
          CANCEL: "Cancel",
          SAVE: "Save",
        },
        DELETE_MODAL: {
          DELETE_SR: "Delete season reference",
          SURE: "Do you want to delete this season reference?",
          DELETE: "Delete",
        },
      },

      SHOWCASES: {
        NAME: "Showcases",
        CREATE_EDIT: {
          NAME: "Name",
          DATE_FROM: "Valid from",
          DATE_TO: "Valid until",
        },
        TABLE: {
          NAME: "Name",
          STATUS: "Status",
          ACTIVE: "Active",
          INACTIVE: "Inactive",
        },
        CREATE_OR_EDIT: {
          CREATE_NEW: "Create new",
          EDIT: "Edit",
          CANCEL: "Cancel",
          SAVE: "Save",
        },
        AUTOMATIC_DISCOUNTS: {
          TITLE: "Add automatic discount",
          ARE_YOU_SURE:
            "Are you sure you want to remove the showcase from the Automatic Discount?",
          ALREADY_ADDED_TITLE: "Already added",
          ALREADY_ADDED:
            "This showcase is already associated with this Automatic Discount.",
        },
        ASSORTMENTS: {
          TITLE: "Add assortment",
          ARE_YOU_SURE:
            "Are you sure you want to remove this showcase from the assortment?",
          ALREADY_ADDED: "Showcase is already associated with this Assortment.",
        },
        DESCRIPTION: {
          NAME: "Select the Showcase for which the assortment is available:",
        },
        DELETE_MODAL: {
          DELETE_SR: "Delete Showcase",
          SURE: "Do you want to delete this ShowCase?",
          DELETE: "Delete",
        },
      },

      AGENCIES: {
        NAME: "Agencies",
        CHANGE_AGENCY_ASSOCIATION: "Change agency/points of sale association",
        FROM_AGENCY: "From agency",
        TO_AGENCY: "To agency",
        MODAL_INFO:
          "Here you can massively move the links of all points of sale (and relative carts) with one agency to another",
        COLUMNS: {
          VAT: "VAT",
          AGENCY_CODE: "Code",
          NAME: "Name",
          CITY: "City",
          ORDERS_YTD: "Orders (YTD)",
          TOTAL_YTD: "Total (YTD)",
          STATUS: "Status",
        },
        MODAL_DELETE_AGENCY: {
          ARE_YOU_SURE: "Are you sure?",
          ARE_YOU_SURE_DELETE_AGENCY: "Are you sure you want to delete agency?",
        },
        POS_UPDATE: "Updated points of sale: ",
        CARTS_UPDATE: "Updated carts: ",
      },

      CUSTOMERS: {
        NAME: "Customers",
        COLUMNS: {
          VAT: "VAT",
          ALTERNATIVE_VAT: "Alternative VAT",
          ALTERNATIVE_GLN: "Alternative GLN Number",
          NAME: "Name",
          CITY: "City",
          POS: "Pos",
          POS_PLURAL: "Pos",
          ORDERS_YTD: "Orders (YTD)",
          TOTAL_YTD: "Total (YTD)",
          STATUS: "Status",
          RELOAD_PAGE: "Reload page",
          EXTERNAL_ID: "External ID",
          VAT_NUMBER: "VAT Number",
        },
        INFO_SECTION: {
          INFO: "Customer Info",
          COMMERCIAL_INFO: "Commercial Info",
          FINANCIAL_INFO: "Financial Info",
          CUSTOMER_CLASSIFICATION: "Customer Classification",
          TAX_COMPLIANCE: "Tax & Compliance",
          PREFIX_VAT: "VAT Prefix",
          VAT_WITHOUT_PREFIX: "VAT without Prefix",
          DEFAULT_TRANSACTION_SPECIFICATION:
            "Default Transaction Specification",
          TRANSACTION_TYPE: "Transaction Type",
          IBAN: "IBAN",
          SWIFT_CODE: "SWIFT Code",
          BANK_NAME: "Bank Name",
          BANK_ACCOUNT_NUMBER: "Bank Account Number",
          BANK_ACCOUNT_ID: "Bank Account ID",
          ROUTING_NUMBER: "Routing number",
          ROUTING_TYPE: "Routing type",
          FISCAL_CODE: "Fiscal Code",
          ABI: "ABI",
          CAB: "CAB",
          BANKING_DETAILS: "Banking Details",
          SAVE_ERP: "Save and Send to ERP",
          BUSINESS_INFO: "Business Info",
          ACCOUNT_NUMBER: "Account Number",
          GENERATE: "Auto-generate",
          ACCOUNT_NUMBER_USED: "Account number already in use!",
          VAT_ALREADY_USED: "VAT already in use!",
          EMAIL_ALREADY_USED: "Email already in use!",
          CUSTOMERS_GROUP: "Customer Group",
          SALES_TAX_GROUP: "Sales Tax Group",
          COMPANY_NAME: "Company Name",
          PAYMENT_METHOD_CODE: "Payment Method Code",
          LOGISTICS_TRANSACTIONS: "Logistics & Transactions",
          PACKAGE_GROUPING_MODE: "Package Grouping Mode",
          DELIVERY_TERMS: "Delivery Terms",
          CURRENCY_CODE: "Currency Code",
          SUBJECTED_FACTORING: "Factor",
          CREDIT_LIMIT: "Credit limit",
          PAYMENT_TERMS_CODE: "Payment Terms Code",
          PAYMENT: "Payment",
          SDI_CODE: "SDI Code",
          OFFICE_PA_CODE: "Public Administration Office Code",
          PEC_EMAIL: "Certified Email (PEC)",
          CENTRAL_OF_PAYMENT: "Payment central account",
          CENTRAL_OF_PAYMENT_NUMBER: "Payment central number",
          INVOICING_ACCOUNT_NUMBER: "Invoicing account",
          COMPANY_FORM: "Company Form",
          ADMINISTRATIVEEMAIL_MISSING:
            "Contact details: Administrative email missing",
          PHONE_MISSING: "Contact details: Phone number missing",
          MOBILE_MISSING: "Contact details: Mobile phone missing",
          FAX_MISSING: "Contact details: Fax missing",
          EMAIL_MISSING: "Contact details: Email missing",
          COMMERCIALEMAIL_MISSING: "Contact details: Commercial email missing",
          PEC_MISING: "Contact details: PEC missing",
          WEBSITE_MISSING: "Contact details: Website missing",
          FACEBOOK_MISSING: "Contact details: Facebook missing",
          INSTAGRAM_MISSING: "Contact details: Instagram missing",
          TWITTER_MISSING: "Contact details: Twitter missing",
          LINKEDIN_MISSING: "Contact details: LinkedIn missing",
          MISSING_USER: "Create a user or insert an existing one",
          MISSING_CONTACTS_POS: "Missing contact details in point of sale",
          MISSING_CONTACTS_POS_FRANCE:
            "Enter at least one administrative email",
          MISSING_LOCATION_POS: "Missing address details in point of sale",
          MISSING_CHANNELS_IN_DROPDOWN:
            "For each point of sale, activate at least one store and add at least one sales channel for each active store",
          MISSING_ONLINESTORES_POS:
            "Missing online store details in point of sale",
          TOOLTIP_TAX_COMPLIANCE: "Enter a valid and unique VAT number",
          TOOLTIP_COMPANY_OWNER: "You must create/select a user",
          NOT_POSSIBLE_SAVE: "Unable to save",
          SAVE_CHANGES: "Do you want to save the changes?",
          KNOWN_AS: "Known As",
          MISSING_POS_NAME: "Missing name in at least one point of sale",
          GROUP_REPS: "Sales Representatives Group",
          SWITCH_1:
            'This customer can be assigned as "Invoicing account" for other customers',
          SWITCH_2:
            'This customer can be assigned as "Payment center account" for other customers',
          BILLING_LOCATION: "Billing Address",
          ADDRESS: "Address",
          ALTERNATIVE_ADDRESS: "Alternative Address",
          PROVINCE: "Province",
          POSTAL_CODE: "Postal Code",
          EXTERNAL_LOCATION_ID: "External Location ID",
          CITY: "City",
          COUNTRY: "Country",
          COMPANY_IDENTIFICATION: "Company Identification",
          SIREN_NUMBER: "SIREN Number",
          SIRET_NUMBER: "SIRET Number",
          GLN_NUMBER: "GLN Customer Number",
          TOOLTIP_DETAIL_CONTACTS:
            "Enter at least one contact for each type listed below",
          ADMINISTRATIVE: "Administrative",
          TYPE: "Type",
          CONTACTS_DETAIL: "Contact Details",
          VALUE: "Value",
          ANALYTICS: "Analytics",
          CLASSIFICATION_GROUP: "Customer Classification Group",
          GROUP_CODE: "Customer Group Code",
          SUB_CODE: "Customer Subgroup Code",
          SINGBOARD: "Customer Signboard",
          HOLDING: "Customer Holding",
          MISSING_FIELDS: "The following fields are not filled in",
          MISSING_FIELDS_TOOLTIP:
            "Cannot send to ERP because the following fields are not filled in:",
          MISSING_FIELDS_EMPTY:
            "It is possible to send to ERP, all required fields have been filled in ✅",
          ALREADY_SENT: "✅ Customer already sent, no changes",
          SELECT_COUNTRY: "Select a country",
          ADD_LOCATION_BEFORE_CONTACTS:
            'Fill in and save the <strong>"Billing Address"</strong> section before adding contacts',
        },
        SUMMARY: {
          ORDER_INSIGHTS: "Purchase insights",
          CARTS_ORDERS_PLACED: "Orders & Carts",
        },
        GOK: {
          NEW_GOK: "New Gok",
          EDIT_GOK: "Edit Gok",
          NAME: "Name",
          TOTAL_AMOUNT: "Total Amount",
          DISACTIVE: "Inactive",
          EMAIL: "Email contact Gok",
          MODIFY_EMAIL: "Edit Email",
          VALID_FROM: "Valid since",
          VALID_TO: "Valid until",
          RESIDUAL: "Residual",
          ORIGINAL_AMOUNT: "Original Amount",
          STATUS: "Status",
          TITLE_MODAL: "Delete Gok",
          MESSAGE: "Are you sure you want to delete this Gok?",
          CANT_ELIMINATE:
            "It is not possible to delete/change this Gok as it has already been used",
          IMPOSSIBLE: "Dates not available",
          DATE_RANGE: "A GOK already exists in the selected period. Please choose a date range that does not overlap with existing ones.",
          MODIFY_GOK_NUMBER: "Edit Gok number",
          ACTIVATE_GOK: "Gok active",
          NUMBER: "Gok Number",
          ADD_GOK_NUMBER: "Add a gok number to enable its creation",
        },
        ATTACHMENTS: {
          TITLE: "Attachments",
          NAME: "Name",
          CODE: "Code",
          COMMENTS: "Comments",
          CREATION_TIME: "Creation Date",
          TITLE_MODAL: "Delete Attachments",
          MESSAGE: "Are you sure you want to delete this Attachment?",
          VIEW_ATTACHMENTS: "View Attachments",
        },
        COMMERCIAL_BLOCK: {
          TITLE: "Customer Commercial Block",
          DESCRIPTION:
            "By activating the commercial block on the customer, nobody except users with the roles StoreOwner, StoreUser and Admin will be able to confirm the shopping cart.",
          RESTRICTION_CAUSE: "Restriction Cause",
          BLOCK_USER: "Block User",
        },
        ORDER_CONFIRMATION_EMAIL: {
          TITLE: "Order confirmation email",
          BLOCK_BY_DEFAULT: "Don't send the order confirmation email",
          DESCRIPTION:
            "When active, confirming a cart of this customer starts with \"Don't send confirmation email\" already checked. Whoever confirms can still uncheck it.",
          TOOLTIP_NOT_RECEIVED:
            "No longer receive it: the email contacts of the customer's billing address and the agency contacts.",
          TOOLTIP_STILL_RECEIVED:
            "Still receive it: whoever confirms the order (including the customer, when confirming from the shop, or an agent) and the store notification address, in Bcc.",
          TOOLTIP_EXCEPTIONS:
            "The email goes to everyone as before if whoever confirms unchecks the option, and for orders created in bulk.",
        },
        MODAL_DELETE_CUSTOMER: {
          ARE_YOU_SURE: "Are you sure?",
          ARE_YOU_SURE_DELETE_CUSTOMER:
            "Are you sure you want to delete customer?",
        },
        MODAL_IMPORT_CUSTOMER: "Import customer by Id Post Office",
        CREATE_CUSTOMER: "Create customer",
      },

      USERS: {
        NAME: "Users",
        COLUMNS: {
          NAME: "Name",
          EMAIL: "Email",
          ROLE: "Role",
          COMPANY: "Company",
          TYPE: "Type",
          STATUS: "Status",
          GOK_NUMBER: "Gok number",
        },
      },

      LOCATION: {
        NAME: "Locations",
        PLEASE_FILL_IN_ALL_REQUIRED_FIELDS:
          "Please fill in all required fields",
        PLEASE_FILL_IN_ALL_STOCK_LIMIT_FIELDS:
          "Please fill in all stock limit fields",
        PLEASE_ENABLE_AT_LEAST_ONE_STORE_AND_ITS_CHANNEL:
          "Please enable at least one store and its channel",
        PLEASE_ENABLE_AT_LEAST_ONE_CHANNEL:
          "Please select at least one sales channel for each enabled store",
        POINT_OF_SALE: "Point of Sale",
        SHIPPING_LOCATION: "Shipping location",
        CREATE_MODAL: {
          CREATE_NEW_POINT_OF_SALE: "Create new point of sale",
          CREATE_NEW_SHIPPING_ADDRESS: "Create new shipping address",
        },
        COLUMNS: {
          NAME: "Name",
          CITY: "City",
          STORES: "Stores",
          ORDERS_YTD: "Orders (YTD)",
          TOTAL_YTD: "Total (YTD)",
          COUNTRY: "Country",
          ADDRESS: "Address",
        },
        MODAL_DELETE_POS: {
          ARE_YOU_SURE: "Are you sure?",
          ARE_YOU_SURE_DELETE_POINT_OF_SALE:
            "Are you sure you want to delete point of sale?",
        },
        MODAL_DELETE_SA: {
          ARE_YOU_SURE: "Are you sure?",
          ARE_YOU_SURE_DELETE_SHIPPING_ADDRESS:
            "Are you sure you want to delete shipping address?",
        },
      },

      PRODUCT_LIST: {
        NAME: "Product list",
        COLUMNS: {
          STYLE: "Style",
          NAME: "Name",
          WHOLE_SALE: "Pre-order wholesale",
          RETAIL: "Pre-order retail",
          ALL_IMAGES_HIDDEN: "Hidden images",
          IMAGES_VISIBILITY_INFO:
            "By enabling this option, product variant images will not be shown to the customer in any section of the app (such as product list, detail page, or order confirmation screens). This setting takes priority over the visibility configured for individual variant images, which can be managed in each variant’s detail page.",
          STOCK: "Stock",
          RE_ORDER: "Re-order",
          PRE_ORDER: "Pre-order",
        },
        PRICE: "Price",
        VARIANTS: "Variants",
        INCLUDED: "Included",
        SELECTED: "selected",
        BY_PRODS: "By products",
        BY_DATE: "Delivery date",
      },

      VARIANT: {
        COLUMNS: {
          SKU: "SKU",
          SIZE: "Size",
          COLOR: "Color",
          STOCK_QTY: "Stock (q.ty)",
          RE_ORDER: "Re-order",
          PRE_ORDER: "Pre-order",
          STOCK_LIMIT: "Stock limit",
        },
      },
      SALES_CAMPAIGNS: {
        COLUMNS: {
          NAME: "Name",
          CAMPAIGN_VALIDITY: "Campaign validity",
          REORDER_VALIDITY: "Re-order validity",
          STORE_REORDER_START: "Store Re-Order start",
          APPLY_REORDER_SPENDING_LIMIT_ONLY_TO_AUTOMATIC_DISCOUNT_ITEMS:
            "Apply re-order spending limit only to automatic discount items",
          STORE_REORDER_END: "Store Re-Order end",
          UNLIMITED_REORDER: "Unlimited Re-Order Variants",
          UNLIMITED_REORDER_TOOLTIP:
            "By selecting these variants, you allow unlimited re-order for them.",
          LIMITED_REORDER_PIECES: "Limited Re-Order Pieces Variants",
          LIMITED_REORDER_PIECES_TOOLTIP:
            "By selecting these variants, you apply the maximum pieces re-order percentage limit for them.",
          PERCENTAGE: "Percentage of Re-Order for this campaign",
          REORDER_PERCENTAGE: "Re-Order percentage",
          REORDER_PIECES_PERCENTAGE: "Maximum pieces re-order percentage per variant",
          PREORDER_SPENDING_LIMIT: "Pre-order spending limit",
          PREORDER_PERCENTAGE: "Pre-order spending percentage",
          PREORDER_SPENDING_LIMIT_TOOLTIP: "Maximum pre-order spend allowed on each selected variant, computed as this percentage of the spend on the same variant in the previous campaign.",
          PREORDER_TIER_PERCENTAGES: "Pre-order spending percentage by tier",
          PREORDER_TIERS_DESCRIPTION: "The percentage applies to the points of sale of the tier. Tiers without a percentage and points of sale without a tier: no limit.",
          PREORDER_TIER: "Tier",
          PREORDER_TIER_ARCHIVED: "Archived",
          PREORDER_TIER_NO_LIMIT: "No limit",
          PREORDER_TIERS_SAVE_FIRST: "Save the campaign to set the percentages by tier.",
          PREORDER_TIERS_EMPTY: "No tier on the pre-order channel of this store: the pre-order spending limit does not apply.",
          PREORDER_TIERS_SEARCH: "Search tiers...",
          PREORDER_BASELINE_CAMPAIGN: "Previous campaign",
          SELECT_PREVIOUS_CAMPAIGN: "Select a previous campaign",
          PREORDER_AVAILABLE_VARIANTS: "Available variants",
          PREORDER_AVAILABLE_VARIANTS_TOOLTIP: "Select the variants subject to the limit: only the selected ones are constrained by the percentage; the others stay unlimited in pre-order.",
          INSERT_PERCENTAGE: "Enter percentage",
          DESCRIPTION: "Description",
          START_DATE: "Start date",
          END_DATE: "End date",
          SHOP_SELLING_PERIOD_START: "Sales in the store start",
          SHOP_SELLING_PERIOD_END: "Sales in the store end",
          DELIVERY_PERIOD_START: "Delivery start",
          DELIVERY_PERIOD_END: "Delivery end",
        },
        ERROR_MODAL: {
          TITLE: "Error",
          DESCRIPTION: "Please fill in all the required fields",
        },
        CREATE_MODAL: {
          EDIT_SALE_CAMPAIGN: "Edit sales campaign",
          ADD_NEW_SALE_CAMPAIGN: "Add sales campaign",
        },
        DELETE_MODAL: {
          TITLE: "Are you sure?",
          DESCRIPTION: "Are you sure you want to delete this sales campaign?",
        },
        RULE: {
          COLUMN: {
            ID: "Id",
            NAME: "Name",
            ROLES_BYPASSING: "Roles bypassing",
            TIER: "Tier",
            LAST_MODIFICATION_TIME: "Last modification time",
            STATUS: "Status",
          },
        },
      },
      REPORTS: {
        NAME: "Reports",
        COLUMNS: {
          ID: "Id",
          NAME: "Name",
          TYPE: "Type",
          CREATOR: "Creator",
          COMPLETED_AT: "Completed at",
        },
      },
    },

    SALES_CAMPAIGNS: {
      NAME: "Name",
      VALIDITY: "Validity",
      COMMERCIAL_RULES: "Commercial rules",
      PRE_ORDER: "Pre-order",
      RE_ORDER: "Re-order",
      VARIANT_UNLIMITED_REORDER_TAG_ADDED: "Variant added to unlimited re-order.",
      VARIANT_UNLIMITED_REORDER_TAG_REMOVED: "Variant removed from unlimited re-order.",
      VARIANT_UNLIMITED_REORDER_TAG_ERROR: "Could not update the variant tag. Please try again.",
      VARIANT_UNLIMITED_REORDER_SAVED: "Unlimited re-order variants saved successfully.",
      VARIANT_PREORDER_LIMITED_SAVED: "Pre-order variants saved successfully.",
      VARIANT_PREORDER_LIMITED_ERROR: "Could not save pre-order variants. Please try again.",
      VARIANT_UNLIMITED_REORDER_NOTHING_TO_SAVE: "No changes to save for unlimited re-order variants.",
      UNLIMITED_REORDER_TAG_NOT_FOUND: "Unlimited re-order tag not found. Contact support.",
      VARIANT_LIMITED_REORDER_PIECES_SAVED: "Limited re-order pieces variants saved successfully.",
      VARIANT_LIMITED_REORDER_PIECES_TAG_ERROR: "Could not update the limited re-order pieces variant tag. Please try again.",
      LIMITED_REORDER_PIECES_TAG_NOT_FOUND: "Limited re-order pieces tag not found. Contact support.",
      NEW_RULE: "New rule",
      DELETE_ASSORTMENT_SUCCESSFULLY: "Assortment deleted successfully",
      DELETE_CONSTRAINT_PACKAGE_SUCCESSFULLY:
        "Constraint package deleted successfully",
      CREATE_CONSTRAINT_PACKAGE_SUCCESSFULLY:
        "Constraint package created successfully",
      UPDATE_CONSTRAINT_PACKAGE_SUCCESSFULLY:
        "Constraint package updated successfully",
      ENABLED_CONSTRAINT_VALUE_SUCCESSFULLY:
        "Constraint value enabled successfully",
      DELETE_CONSTRAINT_VALUE_SUCCESSFULLY:
        "Constraint value deleted successfully",
      CREATE_CONSTRAINT_VALUE_SUCCESSFULLY:
        "Constraint value created successfully",
      UPDATE_CONSTRAINT_VALUE_SUCCESSFULLY:
        "Constraint value updated successfully",
      DELETE_FILTER_SUCCESSFULLY: "Filter deleted successfully",
      CREATE_FILTER_SUCCESSFULLY: "Filter created successfully",
      UPDATE_FILTER_SUCCESSFULLY: "Filter updated successfully",
      UPDATE_RULE_SUCCESSFULLY: "Rule updated successfully",

      RULES: {
        CONSTRAINT_VALUE_NOT_ENABLED:
          "Constraint cannot be enabled for this assortment as it is already active on another assortment",
        CONSTRAINT_VALUE_INFO_MESSAGE:
          "This constraint will trigger on every cart tied to this business rule.",
        CONSTRAINT_VALUE_ENABLED: "Constraint value enabled",
        NO_ASSORTMENTS:
          "No assortment configured, add an assortment to manage constraints",
        NO_CONSTRAINT_PACKAGE:
          "You have not yet entered any package restrictions on this assortment",
        NO_CONSTRAINT_VALUE:
          "Activate this functionality to insert the value constraint on this assortment",
        NO_CONSTRAINT_FILTER:
          "You can set filters to determine the items with which to calculate the wholesale total",
        CONSTRAINTS_CONFIGURATION: "Constraints configuration",
        TITLE: "Rules",
        RULE: "Rule: {{ruleName}}",
        NAME: "Name",
        TIER: "Tier",
        ROLES_BYPASSING: "Roles bypassing",
        ADD_ASSORTMENT: "Add assortment",
        ADD_CONSTRAINT: "Add constraint",
        ADD_RULE: "Add rule",
        CONSTRAINTS_PACKAGE: "Constraints package",
        QUANTITY: "Quantity",
        STYLES_CODE: "Products",
        CONSTRAINT_VALUE: "Constraint value",
        PERCENTAGE: "Percentage",
        TYPE: "Type",
        CONDITION: "Condition",
        VALUE: "Value",
        VALUE_RULE_WHEN_CALCULATE_TOTAL_WHOLESALE_INFORMATION:
          "The wholesale value of the items belonging to this assortment, compared to the total wholesale of the cart, must be greater than or equal to:",
        VALUE_RULE_INFORMATION:
          "Filters to determine the order items on which to evaluate the value constraint:",
        ADD_OR_REMOVE: "Add or remove",
        ADD_FILTER: "Add filter",
        ACTIVATE: "Activate rule",
        DISABLE: "Disable rule",
      },
      TYPE: {
        WHERE_STYLE_GROUP: "Where style group",
        WHERE_SIZE_GROUP: "Where size group",
      },
      CONDITION: {
        IS: "is",
        IS_NOT: "is not",
      },
    },
    PICK_LIST: {
      TO_INCLUDE: "To include",
      INCLUDED: "Included",
      VARIANTS_SELECTED: "variants selected: {{quantity}}",
      ALL: "all",
      SELECTED_ALL: "Selected all",
      CLICK_FOR_OPEN_REPORT: "Click for open report",
      INCLUDE: "Include",
      EXCLUDE: "Exclude",
      VARIANTS: "Variants {{quantity}}",
      SUCCESS_VARIANTS_DISASSOCIATE:
        "{{quantity}} variants disassociated successfully",
      SUCCESS_VARIANTS_ASSOCIATE:
        "{{quantity}} variants associated successfully",
      NO_OTHER_DATA: "No other data",
      NO_DATA_FOUND: "No data found",
      SELECT_ALL_MODAL: {
        TITLE: "Select all",
        MESSAGE:
          "<strong>Warning!</strong> Selecting this mode will select all the products and variants available for the selected filters. <br> You can still exclude products and variants from the selection list.",
        NOT_SHOW_AGAIN: "Do not show again",
        CONFIRM: "Confirm",
      },
      SELECT_ALL_CANCELED: "Select all canceled",
      REPORT_SELECTED_MODAL: {
        TITLE: "Report selected",
        NOT_SELECTED: "No variant or color product has been selected yet",
        YOU_ARE_SELECTING: "You are selecting {{quantity}} {{what}}",
        YOU_ARE_EXCLUDING: "You are excluding {{quantity}} {{what}}",
        PRODUCT_STYLE_COLOR: "product-color",
        VARIANTS: "variants",
        YOU_ARE_SELECTING_ALL_VARIANTS_FOR_THIS_FILTERS:
          "You are selecting all variants for these filters",
        YOU_ARE_SELECTING_THE_ENTIRE_CATALOGUE_AVAILABLE:
          "You are selecting the entire catalogue available for these filters",
        FROM_THE_SELECTION_YOU_ARE: "From the selection you are",
        EXCLUDING_PRODUCTS_STYLE_COLOR: "excluding {{quantity}} product-colors",
        EXCLUDING_VARIANTS: "excluding {{quantity}} variants",
        NOT_VARIANT_OR_PRODUCT_STYLE_COLOR_HAS_BEEN_SELECTED_YET:
          "No variant or color product has been selected yet",
      },
      SAVE_INCLUDE_EXCLUDE_MODAL: {
        ARE_YOU_SURE: "Are you sure?",
      },
    },
    COMMERCIAL_AGREEMENT_DETAIL: {
      CONTINUE_WITHOUT_COMMERCIALAGREEMENT: "Continue without selection",
      BACK_TO_COMMERCIAL_AGREEMENTS: "Back to commercial agreements",
      CREATE_NEW_COMMERCIAL_AGREEMENT: "Create new commercial agreement",
      COMMERCIAL_AGREEMENT: "Commercial agreement: {name}",
      COMMERCIAL_AGREEMENT_INFO: "Commercial agreement info",
      NAME: "Name",
      VALID_FROM: "Valid from",
      VALID_UNTIL: "Valid until",
      DISCOUNT_PERCENTAGE: "% discount",
      TOTAL_RETAIL_AMOUNT: "Max spent (retail value, €)",
      CUSTOMER: "Customer",
      CHANNEL: "Channel",
      ERRORS: {
        COMPILE_ALL_REQUIRED_FIELDS: "Please fill in all required fields",
      },
    },
    TERM_OF_SALE_DETAIL: {
      BACK_TO_TERMS_OF_SALE: "Back to terms of sale",
      CREATE_NEW_TERM_OF_SALE: "Create new term of sale",
      TERM_OF_SALE: "Term of sale",
      NAME: "Name",
      SET_AS_ACTIVE: "Set as active",
      TERMS_AN_CONDITIONS_BY_LANGUAGE: "Terms and conditions by language",
      PLEASE_SELECT_A_DEFAULT_LANGUAGE:
        "Select a default language using the action menu next to the name of the selected language",
      PLEASE_WRITE_A_TERM_OF_SALE_FOR_THE_DEFAULT_LANGUAGE_OR_SELECT_ANOTHER_DEFAULT_LANGUAGE:
        "Please write a term of sale for the default language or select another default language",
      PLEASE_ENTER_A_VALID_TERM_OF_SALE_NAME:
        "Please enter a valid term of sale name",
      TERM_OF_SALE_UPDATE_SUCCESS: "Term of sale updated successfully",
      TERM_OF_SALE_CREATE_SUCCESS: "Term of sale created successfully",
      NAME_ALREADY_EXISTS: "Name already exists",
      ENTER_THE_TERM_OF_SALE: "Enter the term of sale",
      NAME_REQUIRED: "Name required",
      NAME_INVALID: "Name invalid",
      TERM_OF_SALE_DELETE_SUCCESS: "Term of sale deleted successfully",
      ARE_YOU_SURE: "Are you sure?",
      ARE_YOU_SURE_DELETE_TERM_OF_SALE:
        "Are you sure you want to delete term of sale?",
      ERROR_IS_APPLIED_TO_ORDERS:
        "This term of sale cannot be changed or deleted as it has been associated with one or more orders",
    },
    TIER_DETAIL: {
      BACK_TO_TIERS: "Back to tiers",
      CREATE_NEW_TIER: "Create new tier",
      NAME: "Name",
      INFORMATION: "Information",
      DESCRIPTION: "Description",
      INCLUDE_VARIANTS: "Include variants",
      INCLUDED_VARIANTS: "Included variants",
      ASSOCIATE_VARIANTS: "Associate variants",
      DISASSOCIATE_VARIANTS: "Disassociate variants",
      PLEASE_FILL_ALL_REQUIRED_FIELDS: "Please fill in all required fields",
      TIER_UPDATE_SUCCESS: "Tier updated successfully",
      TIER_CREATE_SUCCESS: "Tier created successfully",
      VARIANTS_DISASSOCIATED_SUCCESS: "Variants disassociated successfully",
      VARIANTS_ASSOCIATED_SUCCESS: "Variants associated successfully",
      REMOVE_POS_FROM_TIER:
        "Are you sure you want to remove point of sale from the tier?",
      POS_ALREADY_ASSOCIATED: "Point of sale already associated with the tier",
      OPTION_DESCRIPTION:
        "By activating this option, the stores with this associated tier will see not only the variants of this tier, but also those without any associated tier, for the set sales channel.",
      INFO_ALLERT: {
        INCLUDE_VARIANTS:
          "Select the variants to include in the tier, and then click save to update the tier.",
        INCLUDED_VARIANTS:
          "These are the variants included in the tier. Select the variants you want to untier, and then click save to update the tier.",
      },
      DETAIL: "Detail",
      ASSOCIATED_VARIANTS: "Associated variants",
      ARCHIVED_TIER: "Archived tier #{{tierName}}",
      WORK_IN_PROGRESS_MESSAGE:
        "Here you will be able to view the variants that were associated with this tier. We are working for you.",
      CHANNEL: "Channel",
      ARE_YOU_SURE_SAVE_STORE_POINTS_OF_SALE:
        "Are you sure you want to associate the selected points of sale with the current tier?",
      SELECTED_STORE_POINTS_OF_SALE: "Selected points of sale",
      STORE_POINTS_OF_SALE_SAVED: "Points of sale saved successfully",
    },
    LOCATION_DETAIL: {
      POINT_OF_SALE_INFO: "Point of Sale info",
      BACK_TO_POS: "Back to points of sale",
      ADDRESS_INFO: "Address info",
      PURCHASE_STATS: {
        NAME: "Purchase stats",
        TOTAL_CUSTOMER_REVENUE: "Total customer revenue",
        FROM_PRE_ORDER: "From pre-order",
        FROM_RE_ORDER: "From re-order",
        TOTAL_MARGIN: "Total margin",
        TOTAL_ORDERS: "Total orders",
        AVERAGE_ORDER_VALUE: "Average order value",
      },
      SUMMER_STOCK_LIMIT: "Summer stock limit",
      WINTER_STOCK_LIMIT: "Winter stock limit",
      SUMMER_START_MONTH: "Summer start month",
      WINTER_START_MONTH: "Winter start month",
      SUMMER_START_DAY: "Summer start day",
      WINTER_START_DAY: "Winter start day",
      STOCK_LIMIT: "Stock limit",
      THE_WAREHOUSE_LIMIT_MUST_BE_SET_FOR_THE_CHANNELS:
        "The warehouse limit must be set for the channels",
      ONLINE_STORES_ENABLED: "Online stores enabled",
      USE_NAME_IN_ORDER_HEADER: "Use the point of sale name on the order slip",
      BACK_TO_LOCATIONS: "Back to locations",
      NAME: "Name",
      TIER: "Tier",
      AGENCY: "Agency",
      CHANNEL: "Channel",
      YOU_CANT_EDITINFO_ABOUT_ADDRESS:
        "You can't edit info about address if it is awaiting approval for a store!",
      YOU_CANT_ACTIVEATE_THIS_ADDRESS_IF_ITS_CUSTOMER_IS_NOT_APPROVED:
        "You can't activate this address if its customer is not approved!",
      MISSING_STOCK_LIMIT:
        "Warning! To activate the address on the Plug&Sell channel, you must first complete the stock limit section!",
      ERROR_MODAL: {
        TITLE: "Attention!",
        DESCRIPTION: "Missing fields to save changes, complete data to proceed",
      },
    },
    CONTACT: {
      NAME: "Contact",
      NEW_CONTACT: "New contact",
      EDIT_CONTACT: "Edit contact",
      CONTACT_INFO: "Contact info",
    },
    USER_DETAIL: {
      USER_INFO: "User info",
      REGISTERED_SINCE: "Registered since",
      NAME_SURNAME: "Name surname",
      NAME_SURNAME_ERROR: "Name and surname required",
      EMAIL_ERROR: "Email required",
      ROLES_ERROR: "Roles required",
      STORE_ERROR: "Store required",
      CUSTOMER_ERROR: "Customer required",
      AGENCY_ERROR: "Agency required",
      USER_ROLE: "User role",
      AGENCY: "Agency",
      CUSTOMER: "Customer",
      BACK_TO_USERS: "Back to users",
      MY_PROFILE: "My profile",
      INVITE_USER: "Invite user",
      SEND_INVIATION: "Send invitation",
      USER_STATUS: "User status",
      RESEND_INVITATION: "Resend invitation",
      INVITATION_RESENT_COMPLETED: "Invitation resent completed",
      INVITATION_RESENT_ERROR: "Invitation resent error",
      MODAL_CONFIRM: {
        ARE_YOU_SURE: "Are you sure?",
        ARE_YOU_SURE_YOU_WANT_TO_DEACTIVATE_THIS_USER:
          "Are you sure you want to deactivate this user?",
      },
    },
    WORK_IN_PROGRESS_TITLE:
      "We are working for you: extraordinary maintenance from {{fromHour}} on {{fromDate}}. We will be back online at {{toHour}} on {{toDate}}",
    ORDER_DETAIL: {
      EXTRA_COSTS_INFO:
        "Here you can customize shipping and/or personalization costs. If not set, the related costs will be filled according to the default settings. For example, if you do not want to charge shipping costs for this cart, enter 0 in the corresponding field.",
      COURIER_COSTS_INFO:
        "The shipping costs associated with the courier {{transportAgencyName}} of €{{transportAgencyCost}} are currently being applied.",
      CUSTOMIZATION_COSTS: "Customization costs",
      MANAGE_EXTRA_COSTS: "Manage extra costs",
      BULK_OPERATIONS_STATUS_SYNCING:
        "This order is currently being updated ({{processingCount}} operations in queue). All operations are temporarily disabled until synchronization is complete.",
      BULK_OPERATIONS_STATUS_SYNCING_2:
        "This order is currently being updated. All operations are temporarily disabled until synchronization is complete.",
      BULK_OPERATIONS_STATUS_AWATING:
        "This order has {{processingCount}} operations waiting in queue.",
      HAS_OPERATION_PENDING_MESSAGE:
        "Sorry! This order can no longer be modified because one of the queued jobs has already started. Please return to edit the order once all queued jobs have been completed and refresh the page to view the details.",
      STATS: {
        TOTAL_WHOLESALE: "Total wholesale",
        TOTAL_RETAIL: "Total retail",
        TOTAL_NET: "Total net",
        TOTAL_NET_IVA: "Total net (taxes included)",
        VAT_MARKUP: "RE",
        VAT: "VAT",
        TOTAL_ORDERED: "Total ordered",
        TOTAL_DISCOUNT: "Tot. discount on wholesale",
        TOTAL_PIECES: "Total pieces",
        TOTAL_MARGIN: "Total margin",
        TOTAL_COST: "Total cost",
        TOTAL_CUSTOMER_DISCOUNT: "Customer discount",
        TOTAL_COMMERCIAL_DISCOUNT: "Commercial discount",
        TOTAL_FINANCIAL_DISCOUNT: "Financial discount",
        TOTAL_STORECHANNEL_DISCOUNT: "StoreChannel discount",
        TOTAL_AGREEMENT_DISCOUNT: "Comm. agr. discount",
        TOTAL_AUTO_DISCOUNT: "Automatic discounts",
        TOTAL_VOUCHER_AMOUNT: "Voucher value",
        TOTAL_DISCOUNT_PERCENTAGE_FROM_RETAIL: "Discount from retail",
        DISCOUNT: "Discount",
        TOTAL_SERVICES: "Total services",
        SHIPPING_COST: "Shipping cost",
        SHIPPING_COST_COURIER: "Courier shipping cost",
        SHIPPING_COST_SET: "Set shipping cost",
        SOME_ORDERITEMS_HAS_NO_COST:
          "Some order items have no specified cost, thus this feature is unavailable.",
        PENDING_OPERATION:
          "You cannot perform operations on the cart as there are line item uploads from an Excel file in process.",
        CHOOSE_EXCEL_PROPS_TITLE: "Choose Properties",
        CHOOSE_EXCEL_PROPS:
          "Choose the columns to display in the Excel sheet dedicated to order lines",
        CHOOSE_DOWNLOAD_TYPE: "Choose the download type",
        DOWNLOAD_TYPE_MESSAGE:
          "Once the process is completed, you will receive an email at your address with the attached file once available",
        CUSTOM_DATE: "Custom Date",
        EDIT_CUSTOM_DATE: "Customize Date",
        NO_CUSTOM_DATE: "Date not customizable",
        SELECTED_ITEMS: "Selected order lines",
        REQUESTED_SALES_PRICE: "Requested sales price",
        COLUMNS: {
          IMAGE: "Image",
          NAME: "Columns",
          SKU: "SKU",
          COLOR: "Color",
          COLOR_CODE: "Color Code",
          COLOR_NAME: "Color Name",
          SIZE: "Size",
          UNIT_WHOLESALE: "Unit Wholesale",
          UNIT_NET: "Unit Net",
          UNIT_COST: "Unit Cost",
          UNIT_MARGIN: "Unit Margin",
          TOTAL_RETAIL: "Total Retail",
          TOTAL_WHOLESALE: "Total Wholesale",
          TOTAL_NET: "Total Net",
          TOTAL_COST: "Total Cost",
          TOTAL_MARGIN: "Total Margin",
          TOTAL_DISCOUNT_PERCENTAGE_FROM_RETAIL:
            "Total discount percentage from retail",
          TOTAL_DISCOUNT_PERCENTAGE: "Total Discount Percentage from Wholesale",
          CUSTOMER_DISCOUNT: "Customer Discount",
          AGREEMENT_DISCOUNT: "Agreement Discount",
          FINANCIAL_DISCOUNT: "Financial Discount",
          STORECHANNEL_DISCOUNT: "Inventory Discount",
          DISCOUNT_BY_QTY: "Discount by Quantity",
          DISCOUNT_BY_VALUE: "Discount by Value",
          COMMERCIAL_DISCOUNT: "Commercial Discount",
          MARGIN_PERCENTAGE: "Margin Percentage",
          QTY: "Quantity",
          EAN: "EAN",
          SIZE_GROUP: "Size Group",
          PRODUCT_CODE: "Product Code",
          PRODUCT_TITLE: "Product Title",
          DATE: "Date",
          ORDERED_QTY: "Ordered Quantity",
          CANCELED_QTY: "Canceled Quantity",
          NOT_FULFILLED_QTY: "Quantity Not Fulfilled",
          FULFILLED_QTY: "Fulfilled Quantity",
          FULFILLMENT_STATUS: "Fulfillment Status",
          GROUP_GENERAL: "General",
          GROUP_UNITARY: "Unitary (€)",
          GROUP_TOTALS: "Totals (€)",
          GROUP_PERCENT: "Percentages (%)",
          GROUP_FULFILLMENT: "Fulfillment",
          STYLE_GROUP: "Style Group",
          NOTE: "Note",
          VARIANT_CODE: "Variant Code",
          DELIVERY_DATE: "Delivery Date",
          REPLACE_EAN: "Replace EAN",
          CANCELLATION_REASON: "Cancellation reason",
        },
      },
      UPLOADS: {
        UPLOADED:
          "File upload completed! An email will notify you the completion of the operation.",
        TITLE: "Uploads",
        MESSAGE1:
          "Here you can upload items to your cart via excel files (.xlxs, .xls). In the Code column, to identify the variant, you can enter either a list of EAN codes or a list of SKU codes.",
        MESSAGE1_1:
          'The "Requested Price" column is optional and can be used to specify a desired selling price in order to calculate the commercial discount on the order line.',
        MESSAGE2: 'In the "Code" column, my file will contain codes:',
        MESSAGE3: "Do you want to upload the file:",
        OPERATION_ERRORS_DETAILS: "Operation error detail",
        DEFAULT_ERROR_MESSAGE: "An error occurred while processing the file.",
        COLUMNS: {
          ID: "Id",
          CREATED_BY: "Created by",
          CREATED_ON: "Created on",
          STARTED_ON: "Started on",
          CONCLUDED_ON: "Concluded on",
          STATUS: "Status",
          FILE_ROW_INDEX: "File row",
        },
      },
      FULFILLMENT: {
        FULFILLMENTS: "Fulfillments",
        TITLE: "Fulfillment #{{fulfillmentNumber}}",
        FULFILLMENT_STATUS: "Fulfillment status",
        FULFILLMENT_DATE: "Fulfillment date",
        COURIER: "Courier",
        TRACKING_NUMBER: "Tracking number",
        TRACK_DELIVERY: "Track delivery",
        DOWNLOAD_DELIVERY_NOTE: "Download delivery note",
        SHIPPED: "Shipped",
        DELIVERED: "Delivered",
      },

      ORIGINAL_MODIFIED_INFORMATION:
        "Information changed, original: {{originalValue}}",
      COMMERCIAL_BLOCK_INFO:
        "A commercial block is active on the current customer.",
      NO_CART_CONF: "This cart cannot be confirmed.",
      PAYMENT_TERM: "Payment term",
      ALREADY_FULFILLED_QUANTITY: "Items from plant orders",
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_CUSTOMER_IS_NOT_APPROVED:
        "You can't confirm this cart because customer is not approved",
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_POINT_OF_SALE_IS_NOT_APPROVED:
        "You can't confirm this cart because point of sale is not approved",
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_HAS_NOT_ITEMS:
        "You can't confirm this cart because has not items",
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_LOWER_CART_VALUE:
        "You cannot confirm this cart because the cart total is less than the minimum value allowed in this shop",
      SOME_ORDER_ITEMS_IS_NOT_AVAILABLE_FOR_CURRENT_REQUESTED_QUANTITY:
        "Some order items is not available for current requested quantity",
      PREORDER_NO_BASELINE: 'No reference spend in the previous campaign for the selected variants: no pre-order budget to display.',
      PREORDER_ADMITTED: 'Pre-order within the spending limit ({{percentage}}%) for the selected variants. Spent {{used}} of {{max}} - {{remaining}} remaining.',
      PREORDER_NOT_ADMITTED_NO_BASELINE: 'Pre-order over the spending limit ({{percentage}}%) for the selected variants. (Variants not purchased in the previous campaign: cannot be reordered.)',
      PREORDER_NOT_ADMITTED: 'Pre-order over the spending limit ({{percentage}}%) for the selected variants. Spent {{used}} of {{max}} - exceeded by {{exceeded}}.',
      REORDER_ADMITTED:
        'This cart is a Re-Order within the "{{campaignName}}" sales campaign. Maximum re-order allowed: {{maxPrice}} ({{percentage}}%) - Remaining available: {{remaining}}.',
      REORDER_NOT_ADMITTED:
        'Attention! This cart is a Re-Order within the "{{campaignName}}" sales campaign. Maximum re-order allowed: {{maxPrice}} ({{percentage}}%) - Exceeded by: {{exceeded}}.',
      REORDER_ADMITTED_INTERNAL_USER:
        "As an internal user, you can still proceed with the confirmation.",
      REORDER_NOT_ADMITTED_FOR_CUSTOMER_EXTERNAL_USER:
        'Attention! You can\'t confirm this cart. Contact customer service at the email address "{{shopEmail}}" to solve the problem.',
      GOK_NOT_ADMITTED:
        "Attention! This cart has exceeded the maximum limit of {{totalAmount}}. Remaining available amount:{{residualAmount}} - Exceeded by: {{exceeded}}.",
      SUMMARY: "Summary",
      ORDER_ITEMS: "Items details",
      ORDER_TYPE: "Type of order",
      REORDER_TYPE: "Re-order type",
      ORDER_STATUS: "Order status",
      CHANNEL_NAME: "Channel name",
      CHANNEL: "Channel",
      CUSTOMER: "Customer",
      CUSTOMER_LOCATION: "Billing location",
      POINT_OF_SALE: "Point of Sale",
      AGENT: "Agent",
      AGENCY: "Agency",
      USER: "User",
      USER_EMAIL: "User email",
      SHIPPING_ADDRESS: "Shipping address",
      CREATED_ON: "Created on",
      CONFIRMED_ON: "Confirmed on",
      DELIVERY_DATE: "Delivery date",
      EXTERNAL_ID: "External ID",
      REASON: "Reason",
      ORDER_REASON: "Order reason",
      MANUAL_DISCOUNT: "Manual discount",
      CUSTOMIZATION_REQUEST: "Customization request",
      NAME: "Name",
      AMOUNT: "Amount",
      NOTE: "Note",
      SELECT_ACTION_TYPE: "Select action type",
      BACK_TO_ORDERS: "Back to orders",
      BACK_TO_CARTS: "Back to carts",
      SAVED_NOTE: "Saved note",
      ESTIMATED_DELIVERY_DATE: "Estimated delivery date",
      DELETE_ORDER: "Delete order",
      CANCEL_ORDER: "Cancel order",
      RESEND_ORDER_CONFIRMATION: "Resend order confirmation",
      ARE_YOU_SURE_YOU_WANT_TO_DELETE_SELECTED_ORDERS:
        "Are you sure you want to delete selected orders?",
      ADD_ITEMS: "Add items",
      EDIT_ITEMS: "Edit items",
      EDIT_SELECTED: "Edit selected",
      DELETE_NOT_FULFILED_ITEMS: "Delete not fulfilled items",
      ARE_YOU_SURE_YOU_WANT_TO_DELETE_SELECTED_ITEMS:
        "Are you sure you want to delete following items?",
      CLOSE_SELECT_MODE: "Close select mode",
      SUCCESS_RESEND_ORDER_CONFIRMATION:
        "Resend of order confirmation was successful",
      INVOICING_NUMBER_FULL_NAME: "Invoice account number",
      CENTRAL_PAYMENT_NUMBER_FULL_NAME: "Central payment number",
      DISCOUNT: {
        DISCOUNT_AMOUNT: "Additional discount",
        DESCRIPTION_COMMERCIAL_DISCOUNT:
          "This discount will be applied to the selected items",
        DESCRIPTION_FINANCIAL_DISCOUNT:
          "This discount will be applied to each item of the cart",
      },
      MODAL: {
        ARE_YOU_SURE: "Are you sure?",
        CONFIRM: "Confirm",
        ARE_YOU_SURE_YOU_WANT_TO_DELETE: "Are you sure you want to delete?",
        ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_CART:
          "Are you sure you want to delete this cart?",
        ARE_YOU_SURE_YOU_WANT_TO_REMOVE_DISCOUNT:
          "Are you sure you want to remove discount?",
        ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_VARIANT:
          "Are you sure you want to remove this variant?",
        ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_SELECTED_VARIANTS:
          "Are you sure you want to remove these selected variants?",
        SET_MAXIMUM_QUANTITY_FOR_THIS_SELECTED_VARIANTS:
          "Attention! By confirming, the relative maximum available quantity will be set for each selected variant.",
      },
      MODAL_EDIT_ORDERITEM: {
        EDIT_ORDER_ITEM: "Edit order item",
        ORDER_QTY: "Order qty",
        MAXIMUM_QUANTITY_AVAILABLE_FOR_THIS_VARIANT_ON_DATE:
          "Maximum quantity available for this variant on date",
        IS: "is:",
        YOU_ARE_BUYING_THIS_VARIANT_WHIT_BLANCK_CELL_OPTION:
          "You are buying this variant with blank cell option",
        MAX_AMOUNT_EXCEEDED: "Max amount exceeded",
        MINIMUM_ONE_PIECE: "Minimum one piece",
        THE_QUANTITY_OF_THE_VARIANT_MUST_BE_A_MULTIPLE_OF:
          "The quantity of the variant must be a multiple of:",
        THE_QUANTITY_ENTERED_IS_LESS_THAN_THE_MINIMUM_ALLOWED:
          "The quantity entered is less than the minimum allowed",
        THE_MINIMUM_ORDER_QUANTITY_OF_THE_VARIANT_IS:
          "The minimum order quantity of the variant is:",
        LOSE_CUSTOM_DELIVERY_DATES:
          "By changing the quantities of this order item, you will lose the custom dates you set! Remember to reset it when confirming your order!",
      },
      MODAL_ORDER_NAME_CHANGE: {
        CHANGE_ORDER_NAME: "Change order name",
      },
      MODAL_HANDLE_DATE: {
        HANDLE_DATE_BUTTON: "Manage dates",
        HANDLE_DATE: "Manage original delivery request date on order items",
        OVERWRITE_ORIGINAL_DATE:
          "Use this date to overwrite the original delivery request date on the selected order items. In this way, checks on the quantities available for the relevant items will be carried out on this new date. Attention! By changing this date, any customized delivery dates will be lost!",
      },
      MODAL_SHIPPING_VARIANTS_DATE_: {
        LIST_VARIANTS_FROR_DELIVERY_DATE: "List variants for delivery date",
      },
      BUTTONS: {
        EDIT: "Edit order info",
        ADD_DISCOUNT_FINANCIAL: "Add financial discount",
        ADD_DISCOUNT_COMMERCIAL: "Add commercial discount",
        REMOVE_DISCOUNT_FINANCIAL: "Remove financial discount",
        REMOVE_DISCOUNT_COMMERCIAL: "Remove commercial discount",
        DISCOUNT_OPTIONS: "Discount options",
        CONFIRM_ORDER: "Confirm order",
        CONTINUE: "Continue shopping",
        DUPLICATE_CART: "Duplicate cart",
        SAVE_NOTE: "Save note",
        RENAME_ORDER: "Rename order",
        REMOVE_CUSTOM_DATE: "Remove custom date",
        SKIP_AUTOMATIC_DISCOUNT: "Ignore automatic discounts",
        SKIP_CUSTOMER_DISCOUNT: "Ignore customer discounts",
        ACTIVATE_AUTOMATIC_DISCOUNT: "Activate automatic discounts",
        ACTIVATE_CUSTOMER_DISCOUNT: "Activate customer discounts",
        ACTIVATE_STORECHANNEL_DISCOUNT: "Activate store-channel discounts",
        SKIP_STORECHANNEL_DISCOUNT: "Ignore store-channel discounts",
        OPTIONS_ITEMS: "Options items",
        REMOVE_ITEMS: "Remove items",
        SET_MAXIMUM_QUANTITY: "Set maximum quantity",
        COMMERCIAL_AGREEMENT: "Commercial agreement",
        HANDLE_NOTE_BUTTON: "Manage note",
        EDIT_ORDER_HEADER: "Edit order header",
        CONFIRM_CART:
          "By enabling this option, all carts imported from the file will be automatically confirmed and converted into orders.",
        OPTIONS: "Options",
      },
      MODAL_CONFIRMATION_MAIL: {
        TITLE: "Send confirmation email",
        SEND: "Send",
        ACTIVATE_MAIL: "Enter custom recipients",
        TO: "TO",
        CC: "CC",
        CCN: "BCC",
        TOOLTIP_MSG:
          "If you do not enter custom recipients, the confirmation email will be sent to the default addresses",
        ADD: "Add",
        SNACKBAR_MESSAGE: "Input value is not a valid e-mail",
      },
      MODAL_ACTIVATE_AUTOMATIC_DISCOUNT: {
        TITLE: "Activate automatic discounts",
        DESCRIPTION:
          "Are you sure? Continuing will activate any automatic discounts for the current cart.",
      },
      MODAL_ACTIVATE_CUSTOMER_DISCOUNT: {
        TITLE: "Activate customer discounts",
        DESCRIPTION:
          "Are you sure? Continuing will activate customer discount for the current cart.",
      },
      MODAL_SKIP_AUTOMATIC_DISCOUNT: {
        TITLE: "Ignore automatic discount",
        DESCRIPTION:
          "Are you sure? Continuing will ignore the automatic discounts for this specific cart.",
      },
      MODAL_SKIP_CUSTOMER_DISCOUNT: {
        TITLE: "Ignore customer discount",
        DESCRIPTION:
          "Are you sure? Continuing will ignore any customer discount for the current cart.",
      },
      MODAL_ACTIVATE_STORECHANNEL_DISCOUNT: {
        TITLE: "Activate store-channel discounts",
        DESCRIPTION:
          "Are you sure? Continuing will activate any store-channel discounts (Invincibile) for the current cart.",
      },
      MODAL_SKIP_STORECHANNEL_DISCOUNT: {
        TITLE: "Ignore store-channel discount",
        DESCRIPTION:
          "Are you sure? Continuing will ignore the store-channel discounts (Invincibile) for this specific cart.",
      },
      SHOW_ONLY_UNAVAILABLE:
        "Show only items with available quantity less than the requested one",
      ADD_MANUAL_DISCOUNT_MANUAL: "Enter % additional discount",
      ADD_MANUAL_DISCOUNT_CALCULATED:
        "Calculate from % discount desired by retail",
      ADD_MANUAL_DISCOUNT_CALCULATED2: "Calculate from desired unit wholesale",
      ADD_MANUAL_DISCOUNT_CALCULATED3: "Calculate from desired margin %",
      INSERT_PERCENTAGE: "Enter percentage",
      INSERT_DESIRED_WHOLESALE: "Enter desired wholesale",
      HIDE_CANCELLED: "Hide cancelled order items",
      COMMERCIAL_DISCOUNT_APPLIED:
        "Commercial discount applied on {{orderItemsCount}} order {{itemsTranslation}}",
      COMMERCIAL_DISCOUNT_INSUFFICIENT: 'The discount entered must be greater than the default retail discount for the selected items. To apply a discount lower than the current one, first remove the existing discount and then apply the new one.',
      ITEM: "item",
      ITEMS: "items",
      SOME_ORDERITEMS_HAS_NO_COST:
        "Some items in the cart do not have a specified cost, so this feature is not available",
      PENDING_OPERATION:
        "You cannot carry out operations on the cart as there are order line uploads via Excel file being processed.",
      PENDING_BULK_OPERATIONS: "This order has {{count}} operations pending.",
      CHOOSE_EXCEL_PROPS_TITLE: "Choose properties",
      CHOOSE_EXCEL_PROPS:
        "Choose the columns to display in the Excel sheet dedicated to order items",
      CUSTOM_DATE: "Custom date",
      EDIT_CUSTOM_DATE: "Customize date",
      NO_CUSTOM_DATE: "Date not customizable",
      SELECTED_ITEMS: "selected order items",
      ALERT_CART_SHIPPING_COST:
        "To this cart, shipping costs of <strong>{{shippingCost}}</strong> (VAT excluded) will be applied; to get them for free, you still need to add <strong>{{threshold}}</strong>.",
      ALERT_CART_SHIPPING_COST_NO_COST:
        "To this cart, shipping costs will be applied. To get them for free, you still need to add <strong>{{threshold}}</strong>.",
      ALERT_CART_SHIPPING_COST_WITH_VOUCHER:
        "If you use a voucher, you will not be charged.",
      COLUMNS: {
        IMAGE: "Image",
        NAME: "Columns",
        SKU: "Sku",
        COLOR: "Color",
        COLOR_CODE: "Color code",
        COLOR_NAME: "Color name",
        SIZE: "Size",
        UNIT_WHOLESALE: "Unit wholesale",
        UNIT_RETAIL: "Unit retail",
        GENDER: "Gender",
        UNIT_NET: "Unit net",
        UNIT_COST: "Unit cost",
        UNIT_MARGIN: "Unit margin",
        TOTAL_RETAIL: "Tot. retail",
        TOTAL_WHOLESALE: "Tot. wholesale",
        TOTAL_NET: "Tot. Net",
        TOTAL_COST: "Tot. cost",
        TOTAL_MARGIN: "Tot. margin",
        TOTAL_DISCOUNT_PERCENTAGE_FROM_RETAIL: "Disc. from retail",
        TOTAL_DISCOUNT_PERCENTAGE: "Disc. from wholesale",
        CUSTOMER_DISCOUNT: "Customer disc.",
        AGREEMENT_DISCOUNT: "Comm. agr. disc.",
        FINANCIAL_DISCOUNT: "Financial disc.",
        STORECHANNEL_DISCOUNT: "Store-channel disc.",
        DISCOUNT_BY_QTY: "Disc. by qty",
        DISCOUNT_BY_VALUE: "Disc. by value",
        COMMERCIAL_DISCOUNT: "Commercial disc.",
        MARGIN_PERCENTAGE: "Margin",
        QTY: "Qty",
        EAN: "EAN",
        SIZE_GROUP: "Size group",
        PRODUCT_CODE: "Product code",
        PRODUCT_TITLE: "Product name",
        DATE: "Date",
        ORDERED_QTY: "Qty ordered",
        CANCELED_QTY: "Qty canceled",
        NOT_FULFILLED_QTY: "Qty not fulfilled",
        FULFILLED_QTY: "Qty fulfilled",
        FULFILLMENT_STATUS: "Fulfillment status",
        GROUP_GENERAL: "General",
        GROUP_UNITARY: "Unitary (€)",
        GROUP_TOTALS: "Totals (€)",
        GROUP_PERCENT: "Percent (%)",
        GROUP_FULFILLMENT: "Fulfillment",
        STYLE_GROUP: "Style group",
        NOTE: "Notes",
        CUSTOMIZATION_REQUEST: "Customization request",
      },
    },
    REGISTRATION: {
      WELCOME: "Welcome to",
      REGISTER_NEW: "Register a new",
      BACK_TO_HOME: "Back",
      LOGOUT: "Logout",
      CUSTOMER: "Customer",
      CUSTOMER_INFO: "Customer info",
      AGENCY: "Agency",
      AGENCY_INFO: "Agency info",
      INFO_SETUP: "Setup general info",
      STEPPER: {
        REQUIRED_INFOTO_CREATE:
          "To create a new customer without sending it to the ERP, the required information is: ",
        REQUIRED_INFOTO_CREATE2:
          "Account Number (Tab: Customer Info), Company Name (Tab: Customer Info), Known As (Tab: Customer Info), Billing Address (Tab: Customer Info), Administrative email (Tab: Customer Info), at least one point of sale (Tab: Shipping Addresses).",
        REQUIRED_INFOTO_CREATE3:
          "Remember! You can create the point of sale directly from the billing data and it will not be duplicated in the ERP. From the Shipping Addresses step you can then save the data.",
        ADD_NEW: "Add new",
        CONTACT_INFO: "Contact info",
        ADD_CONTACT_INFO: "Add contact info",

        PAYMENT_INFO: "Payment info",
        ADD_PAYMENT_INFO: "Add payment info",

        POINT_OF_SALE: "Point of sales",
        NEW_POINT_OF_SALE: "New point of sale",
        ADD_POINT_OF_SALE: "Add a point of sale",
        ENABLED_ONLINE_STORE: "Enabled online store",
        USE_BILLING: "Use billing location",
        FINANCIAL_STATUS: "Financial status",
        COMPANY_FINANCIAL_STATUS: "Company financial status",

        FINISH_REGISTRATION: "Finish registration",
        FINISH_REGISTRATION_TEXT:
          "Once the registration request has been sent, it will be taken care of.",
        SEND_REGISTRATION_REQUEST: "Send registration request",

        NEXT_STEP: "Next step",
        PREV_STEP: "Previous step",
        SEND_REQUEST: "Send request",
        OWNER: "Owner",
        OWNER_SUB: "Company owner",
        SEND_USER_INVITATION: "Send invitation email to the owner",
        POS_WITHOUT_STORE:
          "You must enable each store for at least one online store and corresponding channel",
        FORWARDED_REQUEST:
          "Your request has been forwarded to customer service",
        USER: {
          EXISTING: "Set an existing user",
          NEW: "Create a new user",
          SELECT_USER: "Select user",
          EXISTING_EMAIL: "E-mail already exists",
        },
      },
    },
    PRODUCT_DETAIL: {
      IMAGES_VISIBILITY_ACTION: "Hide images of this product",
      IMAGES_VISIBILITY_INFO:
        "By enabling this option, product variant images will not be shown to the customer in any section of the app (such as product list, detail page, or order confirmation screens). This setting takes priority over the visibility configured for individual variant images, which can be managed in each variant’s detail page.",
      IMAGES_VISIBILITY: "Images visibility",
      BACK_TO_PRODUCTS_LIST: "Back to products list",
      STYLE_CARD: "Style card",
      NAME: "Name",
      CODE: "Code",
      GENDER: "Gender",
      DESCRIPTION: "Description",
      PRODUCT_DESCRIPTION: "Product description",
      OPEN_IN_BULK: "Open in variants editor",
      COLOR: "color",
      COLORS: "colors",
      SETTINGS_PRODUCT: "Purchase settings",
      SETTING_BASICKUSTOM: "BasicKustom settings",
      MESSAGE_FOR_MAKE_PRODUCT_CUSTOMIZABLE:
        "To make this product customizable, select a reference palette",
      MESSAGE_FOR_MAKE_PRODUCT_CUSTOMIZABLE_WITH_PLAYERS:
        "Set this flag if you want to give the user the option to add player-related information to this product",
      BUY_MULTIPLIER: "Purchase multiplier for sales channels: {{channels}}",
      BUY_MINIMUM_PER_ORDER:
        "Minimum purchase quantity (for sales channels that require it)",
      ADD_ORDER_ITEMS: "Add order items",
      ORDER_ITEM_WITHOUT_WHOLESALE_PRICE:
        "Warning! Some selected variants do not have a defined wholesale price and cannot be added.",
      VARIANTS: {
        NAME: "Variants",
        COLUMNS: {
          VARIANT: "Variant",
          NEW_QTY: "New quantity",
          QTY: "Qty",
          SKU: "Sku",
          WHOLE_SALE: "Wholesale",
          RE_ORDER: "Re-order",
          PRE_ORDER: "Pre-order",
        },
      },
      IMPORT_STATUS: {
        NAME: "Import status",
        START: "Start",
        END: "End",
        ERROR: "The following error occurred: ",
        RESTART_IMPORT: "Restart import",
        MODAL_TEXT:
          "Attention! All changes about this product and its variants will be lost. Are you sure?",
        RETAIL_DISCOUNT_PERCENTAGE: "% discount from retail",
        LAST_RETAIL_DISCOUNT_PERCENTAGE: "Last base discount used",
      },
      MODAL_DELETE: {
        ARE_YOU_SURE: "Are you sure?",
        ARE_YOU_SURE_TO_REMOVE_STOCK_LIMIT:
          "Are you sure you want to remove the stock limit?",
        ARE_YOU_SURE_TO_REMOVE_MINIMUM_PRE_ORDER:
          "Are you sure you want to remove the minimum pre-order?",
        ARE_YOU_SURE_TO_REMOVE_MINIMUM_RE_ORDER:
          "Are you sure you want to remove the minimum re-order?",
        ARE_YOU_SURE_TO_REMOVE_ALL_LIMITS:
          "Are you sure you want to remove all limits?",
        FOR: "for",
        STYLE_COLOR: "style-color",
        STYLE_COLORS: "style-colors",
      },

      SETTING_LIMIT: "Setting constraints",
      SETTING_STOCK_LIMIT: "Setting stock limit",
      SETTING_MINIMUM_PRE_ORDER: "Setting minimum pre-order",
      SETTING_MINIMUM_RE_ORDER: "Setting minimum re-order",
      ADD_OR_EDIT_STOCK_LIMIT: "Add/edit stock limit",
      ADD_OR_EDIT_MINIMUM_PRE_ORDER: "Add/edit minimum pre-order",
      ADD_OR_EDIT_MINIMUM_RE_ORDER: "Add/edit minimum re-order",
      REMOVE_STOCK_LIMIT: "Remove stock limit",
      REMOVE_MINIMUM_PRE_ORDER: "Remove minimum pre-order",
      REMOVE_MINIMUM_RE_ORDER: "Remove minimum re-order",
      REMOVE_ALL_LIMITS: "Remove all limits",
      MODAL_LIMIT: {
        STOCK_LIMIT: "Stock limit",
        MINIMUM_QTY_PRE_ORDER: "Minimum pre-order",
        MINIMUM_QTY_RE_ORDER: "Minimum re-order",
        SETTING_STOCK_LIMIT: "Setting stock limit",
        SETTING_MINIMUM_PRE_ORDER: "Setting minimum pre-order",
        SETTING_MINIMUM_RE_ORDER: "Setting minimum re-order",
        LIMIT_ENABLED_FOR_CHANNELS: "Limit enabled for channels: {{channels}}",
        THE_QUANTITY_INSERTED_IS_NOT_VALID_MINIMUM_VALUE_IS_TWO:
          "The quantity inserted is not valid. Minimum value is two",
      },
    },
    PRODUCT_AND_VARIANT: {
      REORDER: "Reorder",
    },
    TAG_MANAGER: {
      NAME: "Tag manager",
    },
    MEDIA_CONTAINER: {
      START_SYNC: "Start images sync",
      NAME: "Media",
      VISIBLE_IMAGE: "Visible image",
      SET_AS_COVER: "Set as cover",
      NO_MEDIA_TO_VIEW: "No media to view",
      UPLOAD_MEDIA: "Upload media",
      SHOW_ALL_MEDIA: "Show all media",
      HIDE_ALL_MEDIA: "Hide all media",
    },
    BULK_MEDIA_EDIT: {
      SHOW: "Show",
      HIDE: "Hide",
      INFO: "Show or hide all media (Product and Variants)",
      NO_PRODUCT_SELECTED: "No product selected",
      MESSAGE_SUCCESS_VISIBILE_1:
        "All images of the selected products have been made visible",
      MESSAGE_SUCCESS_VISIBILE_2:
        "All images of product and variants have been made visible",
      MESSAGE_SUCCESS_HIDE_1:
        "All images of the selected products have been made invisible",
      MESSAGE_SUCCESS_HIDE_2:
        "All images of product and variants have been made invisible",
    },
    VARIANT_DETAIL: {
      BACK_TO_PRODUCT_DETAIL: "Back to product detail",
      VARIANT: "Variant",
      SELECT_VARIANT: "Select variant",
      COLOR: "Color",
      SIZE: "Size",
      SKU_CODE: "SKU code",
      EAN_CODE: "EAN code",
      AVAILABLE_QTY: "Stock quantity",
      COST: "Cost",
      BLANK_CELLS_SETTINGS: "Blank cells settings",
      BLANK_CELLS_END_DATE: "Blank cells end date",
      BLANK_CELLS_DELIVERY_DATE: "Blank cells delivery date",
      TIERING: "Tiering",
      TIER_DESCRIPTION: "Select the levels for which the product is available:",
      EXTERNAL_COLLECTIONS_ID: "External collections ID",
      FROM: "From",
      TO: "To",
      DETAIL: "Detail",
      LABELS: "Labels",
      PURPOSES: "Purposes",
      TEAMS: "Teams",
      CATEGORIES: "Categories",
      PRICING: "Pricing",
      RE_ORDER: "Re-order",
      PRE_ORDER: "Pre-order",
      WHOLE_SALE_PRICE_NO_VAT: "Wholesale price (no VAT)",
      SUGGESTED_RETAIL_PRICE_VAT: "Suggested retail price (with VAT)",
      PERCENTAGE_DISCOUNT_OF_RETAIL: "% discount of retail",
    },
    VISIBILITY: {
      NAME: "Visibility",
      PUBLISH_ON_PRE_ORDER: "Publish on pre-order",
      PUBLISH_ON_RE_ORDER: "Publish on re-order",
      BLOCK_AUTOMATIC_PUBLISH_ON_RE_ORDER:
        "Block automatic publication on re-order",
      AUTOMATIC_PUBLISH_DESCRIBE:
        "If deactivated, when the variant has re-order quantity available, it will be published automatically",
    },
    ASSORTMENT_DETAIL: {
      NAME: "Assortment",
      BACK_TO_ASSORTMENTS: "Back to assortments",
      ASSORTMENT_CARD: "Assortment card",
      ASSORTMENT_NAME: "Name",
      ID: "ID",
      EDIT_ORDER: "Edit order",
      DESCRIPTION: "Description (optional)",
      TIERING: "Tiering",
      TIER_DESCRIPTION:
        "Select the tier for which the assortment is available:",
      CHANNEL: "Channel",
      SELECT_THE_CHANNEL_FIRST: "Select the channel first",
      CHANNEL_DESCRIPTION:
        "Select the channels for which the assortment is available:",
      INCLUDE_PRODUCTS: {
        NAME: "Include products",
        MANUAL: "Manual (static)",
        AUTOMATED: "Automatic (dynamic)",
        PROPERTY: {
          CODE: "Code",
          SIZE: "Size",
          COLOR: "Color",
          TIER: "Tier",
          PRICE: "Price",
          BRAND: "Brand",
          GENDER: "Gender",
          SEASON: "Season",
          TAG: "Tag",
          CATEGORY: "Category",
          LABEL: "Label",
          EXTERNAL_COLLECTION_ID: "External collection id",
          PRODUCT_CODE: "Product code",
        },
        OPERATOR: {
          EQUALS: "Equals",
          NOT_EQUALS: "Not equals",
          GREATER_THAN: "Greater than",
          LESS_THAN: "Less than",
          GREATER_OR_EQUAL: "Greater or equal",
          LESS_OR_EQUAL: "Less or equal",
          CONTAINS: "Contains",
          NOT_CONTAINS: "Not contains",
          STARTS_WITH: "Starts with",
          ENDS_WITH: "Ends with",
        },
        GENDER: {
          MAN: "Man",
          WOMAN: "Woman",
          UNISEX: "Unisex",
        },
      },
      ASSORTMENT_PRODUCTS: "Assortment products",
      ASSORTMENT_INFO_1:
        "The order of this list affects how the products are showed in the 4Shop product list.",
      ASSORTMENT_INFO_2:
        "To edit products order, first you have to save any changes about assortment variants including or assortment automatic rules.",
      UNDO_PRODUCTS_ORDER: "Undo products order",
      SAVE_PRODUCTS_ORDER: "Save products order",
      FEATURED: "Featured",
      ORDER: "Order",
      MANAGE_ORDER_TITLE: "Manage Assortments Order",
      MANAGE_ORDER_DESCRIPTION: "Drag and drop assortments to reorder them, or edit order values directly in list view.",
      LIST_VIEW: "List",
      DRAG_VIEW: "Drag & Drop",
      SAVE_ORDER: "Save Order",
      SELECT_CHANNEL_TO_MANAGE: "Select a channel to manage assortment order",
      MANAGE_ORDER_SAVE_SUCCESS: "Assortment order saved successfully",
      SELECT_CHANNEL_FIRST: "Please select a channel filter first",
      SELECTED: "selected",
      REORDER: "Reorder",
      REORDER_TITLE: "Reorder Assortments",
      DUPLICATE_ORDER_WARNING: "Two or more assortments have the same order value. Please fix before saving.",
      SEARCH_ASSORTMENT: "Search assortment...",
      MANAGE_MODAL_SELECT_DESCRIPTION: "Select the assortments you want to reorder for this channel",
      CLEAR_ALL_ORDERS: "Clear all orders",
    },
    AUTOMATED_INCLUDES: {
      ALL_CONDITION: "All condition",
      ANY_CONDITION: "Any condition",
      PROPERTY: "Property",
      OPERATOR: "Operator",
      VALUE: "Value",
    },
    BULK_EDITOR_DETAIL: {
      CHOOSE_PROPS: "Choose the properties to edit",
      BACK_TO_SELECT_VARIANTS: "Back to select variants",
      EDIT_INFO:
        "You can edit multiple variants at the same time by selecting them. Hold down the Shift button to select groups of variants faster.",
      COLUMNS: {
        COLOR: "Color",
        SIZE: "Size",
        SKU: "SKU",
        RE_ORDER: "Re-order",
        PRE_ORDER: "Pre-order",
        AUTO_RE_ORDER: "Block auto Re-order",
        BLANK_CELLS_END: "Blank cells end",
        BLANK_CELLS_DELIVERY: "Blank cells delivery",
        TAGS: "Tags",
        TIERS: "Tiers",
        PRICES: "Prices",
      },
      RECAP_MODAL: {
        TITLE: "Confirm changes",
        MESSAGE: "You are about to update {{count}} variants. Review the changes below before saving.",
        NO_CHANGES: "No changes detected.",
        VARIANTS: "variants",
        CHANGE: "Change",
      },
    },
    SUPER_BULK_EDITOR_DETAIL: {
      CREATE_OPERATION: "Create operation",
      MANUAL_CODE: "Manual",
      AUTO_CODE_BY_ASSORTMENT: "By assortment",
      LIST_OPERATION: "List operation",
      SELECT_THE_TYPE_OF_CODE: "Select the type of code",
      SELECT_TYPE_OF_CODE_DESC:
        "In this section, select the type of codes you will enter to obtain the list of variants on which to carry out the operations.",
      BEFORE_SELECT_THE_TYPE_OF_CODE: "Before select the type of code",
      INSERT_CODES: "Insert codes",
      INSERT_CODES_DESC:
        'In this section enter a list of codes based on the type previously selected, separating them with a ";" or by carriage return for each code.',
      REPORT_VALIDATION: "Report validation",
      BEFORE_INSERT_CODES_AND_VALIDATED: "Before insert codes and validated",
      TOTAL_VARIANTS_INVOLVED: "Total variants involved",
      CREATE_OPERATION_DESC:
        "In this section choose the operation that will be performed on the list of variants involved.",
      SELECT_OPERATION: "Select operation",

      REPORT_VALIDATION_MODAL: {
        TITLE: "Report validation",
        VALIDATING: "Validating...",
        ALERT_MESSAGE:
          "Some codes entered are not correct ({{numberOfCodesInvalid}}), to continue, remove or correct them",
      },

      COLUMNS: {
        CODE: "Code",
        VARIANTS_NUMBER: "Variants number",
        STATUS: "Status",
        INSERTED: "Inserted",
        INTERPRETED: "Interpreted",
      },
      BUTTONS: {
        EDIT_CODES: "Edit codes",
        UNDO_EDITS: "Undo edits",
        ADD_ROW: "Add row",
        VALIDATE: "Validate",
      },

      CODE_TYPE: {
        BASIC_COLLECTION: "Collection",
        PRODUCT_CODE: "Product",
        PRODUCT_TEAM: "Product team",
        PRODUCT_COLOR: "Product color",
        SKU_CODE: "SKU",
      },

      CODE_TYPE_TOOLTIP: {
        BASIC_COLLECTION: "Basic collection id, Ex. 12345",
        PRODUCT_CODE:
          "Product code, first 7 characters of SKU code, Ex. 35124DW",
        PRODUCT_TEAM:
          "Team product code, first 10 characters of SKU code, Ex. 35124DWACF or 35124DW***",
        PRODUCT_COLOR:
          "Color product code, first 13 characters of SKU code, Ex. 35124DW***A00 or 35124DW A00",
        SKU_CODE: "Code 19, Ex. 35124DW***A00L***** or 35124DW A00L",
      },

      ALERT: {
        NO_VARIANTS_FOUND_PLEASE_CHECK_THE_CODES:
          "No variants found, please check the codes",
        OPERATION_CREATED_SUCCESSFULLY:
          "Operation #{{operationId}} created successfully",
      },

      OPERATION_LABELS: {
        VISIBLE_IN_RE_ORDER: "Visible in re-order",
        VISIBLE_IN_PRE_ORDER: "Visible in pre-order",
        BLOCK_AUTOMATIC_PUBLISH_ON_RE_ORDER:
          "Block automatic publication on re-order",
        BLANK_CELLS_END_DATE: "Blank cells end date",
        BLANK_CELLS_DELIVERY_DATE: "Blank cells delivery date",
        INCLUDE_IN_TIER: "Include in tier",
        EXCLUDE_FROM_TIER: "Exclude from tier",
        INCLUDE_IN_ASSORTMENT: "Include in assortment",
        EXCLUDE_FROM_ASSORTMENT: "Exclude from assortment",
        INCLUDE_IN_PROMOTION: "Include in promotion",
        EXCLUDE_FROM_PROMOTION: "Exclude from promotion",
        PALETTES_STOCK_LIMITS: "Stock limit set: ",
      },

      DETAIL_OPERATION_MODAL: {
        TITLE: "Operation detail #{{operationId}}",
        MESSAGE:
          "The <strong>operation #{{operationId}}</strong> created by <strong>{{userName}}</strong> on <strong>{{date}}</strong> is in state: <strong>{{status}}</strong>",
        OPERATION_REQUESTED: "Operation requested: ",
        ERROR_FOUND: "Error found: ",
        ERRORS_FOUND: "Errors found: ",

        COLUMNS: {
          VARIANT_SKU: "Variant SKU",
          ERRORS: "Errors",
        },
      },
    },
    SUPPORT_BUTTON: {
      LABEL: "HELP",
      TITLE: "Fill the fields to send a support request",
      SUCCESS_MESSAGE: "Request sent successfully!",
      OBJECT: "Object",
      MESSAGE_BODY: "Message",
      BROWSE_FILE: "Browse...",
      FEEDBACK_MESSAGE_0: "Ticket created with id #",
      FEEDBACK_MESSAGE: "We will answer to your request with an email to",
      SEND_REQUEST: "Send request",
      CHOOSE_FILE: "Choose file",
    },
    PROMOTION_DETAIL: {
      NAME: "Automatic discount",
      EVALUATE_REQUIREMENTS_CONSIDERING_ENTIRE_ORDER:
        "Evaluate requirements considering the entire order",
      NEW_PROMOTION: "New automatic discount",
      BACK_TO_PROMOTIONS: "Back to automatic discounts",
      PROMOTION_NAME: "Name",
      CODE: "Code",
      VALIDITY: "Validity",
      VALID_FROM: "Valid from",
      VALID_UNTIL: "Valid until",
      VALID_ON: "Valid on",
      REQUIREMENTS_AND_DISCOUNT: "Requirements and discount",
      MINIMUM_QUANTITY: "Minimum quantity",
      MINIMUM_VALUE: "Minimum value",
      FROM: "From",
      TO: "To",
      DISCOUNT: "Discount",
      INCLUDE_VARIANTS: "Include variants",
      INCLUDED_VARIANTS: "Included variants",
      MESSAGE:
        "Some variant cannot be selected because it is already present in another promotion of the same type",
      VARIANTS: "Variants",
      ERROR_APPLICATION_RANGE: {
        RANGE_IS_INCORRECT_FROM_MUST_BE_LESS_THAN_TO:
          'The range is incorrect. "From" must be less than "To"',
        THE_INTERVAL_OVERLAPS_WITH_ANOTHER_INTERVAL:
          "The interval overlaps with another interval",
        THE_VALUE_FRO_THE_DISCOUNT_MUST_BE_BETWEEN_1_AND_100:
          "The value for the discount must be between 1 and 100",
        THE_VALUE_FOR_TO_MUST_BE_GREATER_THAN_0_OR_EMPTY:
          'The value for "To" must be greater than 0 or empty',
      },
      INFO_APPLICATION_RANGE: {
        THIS_INPUT_WHITEOUT_VALUE_WILL_BE_CONSIDERED_AS_INFINITY:
          "This input whiteout value will be considered as infinity",
      },
    },
    VOUCHER_DETAIL: {
      NAME: "Voucher",
      NEW_VOUCHER: "New voucher",
      NEW_VOUCHER_FOR: "New voucher for",
      BACK_TO_VOUCHERS: "Back to vouchers",
      VOUCHER_NAME: "Name",
      VALIDITY: "Validity",
      CUSTOMER_TO_APPLY: "Customers to assign voucher to",
      CUSTOMER_APPLIED: "Customers who have been awarded the voucher",
      ADD_CUSTOMER: "Add customer",
      CUSTOMER: "Customer",
      SELECTED: "Selected",
      DESELECT_ALL: "Deselect all",
      NO_CUSTOMER_SELECTED: "No customer selected",
      EXPIRED_VOUCHER: "The selected voucher is expired!",
      EDIT_DESCRIPTION: "Edit description",
      RESIDUAL_AMOUNT: "Residual amount",
      SELECT_AT_LEAST_ONE_CUSTOMER: "Select at least one customer",
      FILL_IN_ALL_REQUIRED_FIELDS: "Fill in all required fields",
      CHANGE_VOUCHER: "Change voucher",
      APPLICABLE_AS_PARTIAL_PAYMENT: "Applicable as partial payment",
      APPLICABLE_AS_PARTIAL_PAYMENT_MESSAGE:
        "If enabled, the voucher will be applicable to an order even if its remaining amount cannot cover the discounted wholesale total of the order.",
    },
    ASSIGN_VOUCHER: {
      SELECT_VOUCHER: "Select the voucher you want to apply to the order",
      SELECTION_MESSAGE: "Applying this voucher, the order total will be ",
    },
    AGENCY_DETAIL: {
      TABS: {
        SUMMARY: "Summary",
        CHECK_IN: "Check-in",
        CUSTOMERS: "Customers",
        ORDERS: "Orders",
        AGENTS: "Agents",
      },
      PLEASE_INSERT_AGENCY_CODE_FOR_ALL_ACTIVE_STORES:
        "Please insert agency code for all active stores",
      AGENCY_CODES: "Agency codes",
      BACK_TO_AGENCIES: "Back to agencies",
      AGENCY_INFORMATION: "Agency information",
      VAT: "VAT",
      FISCAL_CODE: "Fiscal code",
      AGENCY_CODE: "Agency code",
      AGENCY_NAME: "Agency name",
      AGENCY_FORM: "Agency form",
      CANT_EDIT: {
        MESSAGE:
          "You can't edit info about agency because it is awaiting approval!",
      },
      SEND_TO_ERP: "Send to ERP",
      CONTACT_INFO: "Contact information",
      MODAL_ERP: {
        ARE_YOU_SURE: "Are you sure?",
        ARE_YOU_SURE_YOU_WANT_TOSEND_TO_ERP:
          "Are you sure you want to send to ERP?",
        SEND: "Send",
      },
    },
    ADDRESS_INFO: {
      SEARCH: "Search",
      ADDRESS: "Address",
      ALTERNATIVE_ADDRESS: "Alternative address",
      LABEL: "Search address",
      BILLING_LABEL: "Search billing address",
      STREET: "Street",
      NUMBER: "Number",
      COUNTRY: "Country",
      PROVINCE: "Province",
      CITY: "City",
      ZIP_CODE: "Zip code",
    },
    CONTACT_INFO: {
      DELETE_MODAL: {
        ARE_YOU_SURE: "Are you sure?",
        ARE_YOU_SURE_YOU_WANT_TO_DELETE: "Are you sure you want to delete?",
        DELETE: "Delete",
      },

      ADD_MODAL: {
        TITLE: "Add contact",
        TYPE: "Type",
      },

      EDIT_MODAL: {
        TITLE: "Edit contact",
      },

      INVALID_VALUE: "Invalid value for the selected contact type",

      CONTACT_TYPE: {
        ADMINISTRATIVE: "Administrative",
        COMMERCIAL: "Commercial",
        EMAIL: "Email",
        PEC: "PEC",
        PHONE: "Phone",
        FAX: "Fax",
        MOBILE: "Mobile",
        WEBSITE: "Website",
        SOCIAL: "Social",
        FACEBOOK: "Facebook",
        TWITTER: "Twitter",
        INSTAGRAM: "Instagram",
        LINKEDIN: "Linkedin",
      },
    },
    CUSTOMER_DETAIL: {
      BACK_TO_CUSTOMERS: "Back to customers",
      TABS: {
        SUMMARY: "Summary",
        CHECK_IN: "Check-in",
        LOCATIONS: "Locations",
        ORDERS: "Orders",
        DISCOUNTS: "Discounts",
        USERS: "Users",
        VOUCHERS: "Vouchers",
        SETTINGS: "Settings",
      },

      ALLERT: {
        MESSAGE:
          "You can't edit info about customer because it is awaiting approval!",
      },

      SEND_TO_ERP: "Send to ERP",

      CARDS: {
        COMPANY_INFO: "Company info",
        CONTACT_INFO: "Contact info",
        COMPANY_FINANCIAL_STATUS: "Company financial status",
        PAYMENT_INFO: "Payment info",
        COMMERCIAL_AGREEMENT: "Commercial agreement",
        CUSTOMER_DISCOUNT: "Customer discount",
        CUSTOMER_COMMERCIAL_BLOCK: "Customer commercial block",
        BASIC_KUSTOM_DISCOUNT: "Basic Kustom discount",
      },

      STATUS: {
        COMPLETED: "Completed",
        NOT_COMPLETED: "Not completed",
      },

      MODAL_ERP: {
        ARE_YOU_SURE_YOU_WANT_TO_SEND_TO_ERP:
          "Are you sure you want to send to ERP?",
        MESSAGE:
          "By confirming the registry will be saved and transmitted to ERP",
        SEND: "Send",
      },

      MODAL_SAVE: {
        ARE_YOU_SURE: "Are you sure?",
        MESSAGE:
          'Attention! saving the change to the customer, it will be set with the status "to approved"',
      },

      COMPANY_INFO: {
        PREFIX_VAT: "Prefix VAT",
        VAT_WHITHOUT_PREFIX: "VAT without prefix",
        FISCAL_CODE: "Fiscal code",
        COMPANY_NAME: "Company name",
        AUTOCOMPLETE: "Autocomplete",
        COMPANY_FORM: "Company form",
        COMPANY_CATEGORIES: "Company categories",
        ITALIAN_DIGITAL_INVOICING_SYSTEM: "Italian Digital Invoicing System",
        SDI_CODE: "SDI code",
        OFFICE_PA_CODE: "Office PA code",
        PEC_EMAIL: "PEC email",
        ERROR_YOU_CAN_NOT_ENTER_BOTH_PA_CODE_AND_SDI_CODE:
          "You can not enter both PA code and SDI code",
        ERROR_CODE_MUST_BE_ALPHANUMERIC_CHARACTERS_WITHOUT_SPACES_AND_SPECIAL_CHARACTERS:
          "{{codeName}} Code must be {{numCharacters}} alphanumeric characters without spaces and special characters",
      },

      FINANCIAL_STATUS: {
        ENTERPRISE_BOOL: "Enterprise",
        MASTER_DATA_BOOL: "Master data",
        ACTIVITY_BOOL: "Activity",
        REQUEST_NEW_REPORT: "Request new report",
        NO_DATA_TO_SHOW:
          "No existing report, request a new report by clicking the button below",
        COLUMNS: {
          DATE: "Date",
          CLASS: "Class",
          RISK_DESCRIPTION: "Risk description",
          CREDIT_LIMIT: "Credit limit",
          SCORE: "Score",
          REPORT: "Report",
        },
        REFRESH_MODAL: {
          ARE_YOU_SURE: "Are you sure?",
          EACH_REFRESH_HAS_A_COST: "Each refresh has a cost",
          REFRESH: "Refresh",
        },
        PRINT: "Print",
        SHARE: "Share",
        VIEW_REPORT: "View report",
      },

      PAYMENT_INFO: {
        CHANNEL_PAYMENTS_TERM_INFO:
          "Here you can add a specific payment term for each sales channel. If a payment term is not specified for a channel, the default payment term will be used.",
        ADD_PAYMENT_TERM: "Add payment term",
        CHANNEL_PAYMENTS_TERM: "Channel payments term",
        PAYMENT_TERM: "Payment term",
        DEFAULT_PAYMENT_TERM: "Default payment term",
        CHANNEL: "Channel",
        BANCK_INFO: "Bank info",
        ABI: "ABI",
        CAB: "CAB",
        SWIFT: "SWIFT",
      },

      COMMERCIAL_AGREEMENT: {
        COMMERCIAL_ALLOWANCE: "Commercial allowance",
      },

      COMMERCIAL_BLOCK: {
        COMMERCIAL_BLOCK: "Commercial block",
        INFO: "By activating the commercial block on the customer, no one except users with storeOwner, storeUser and admin roles will be able to confirm the cart.",
        BLOCKED_BY: "Blocked by: {{name}}",
        ALERT_COMMERCIAL_BLOCK_FROM_ERP:
          "This trading block was implemented by the erp",
      },
    },
    STATUS_LABLE: {
      CREATED_ON: "Created on",
      BY: "By",
      LAST_UPDATE_ON: "Last update on",
      STATUS: "Status",
      FOR_CURRENT_STORE: "For current store",
    },
    STATUS: {
      ALL: "All",
      ENABLED: "Enabled",
      GOK: "GOK",
      IS_DIRECT: "Direct order",
      NOT_GOK: "Not GOK",
      VALID: "Valid",
      INVALID: "Invalid",
      TOAPPROVE: "To approve",
      COMMERCIALBLOCKED: "Blocked",
      APPROVED: "Approved",
      APPROVED_BY_REQUESTING_USER: "Approved by requesting",
      APPROVED_GRAPHICALLY: "Approved graphically",
      REJECTED: "Rejected",
      ORDERED: "Ordered",
      EVO: "Evo",
      SUBLI: "Subli",
      BLOCKED: "Blocked",
      PARTIALLY_FULFILLED: "Partially fulfilled",
      ONHOLD: "On hold",
      BILLING: "Billing",
      SHIPPING: "Shipping",
      CUSTOMER: "Customer",
      AGENCY: "Agency",
      ADMIN: "Admin",
      UNASSIGNED: "Unassigned",
      ACTIVE: "Active",
      INVITED: "Invited",
      DISABLED: "Disabled",
      DRAFT: "Draft",
      DRAFT_WITHOUT_NOTIFICATION: "Draft",
      DRAFT_WITH_NOTIFICATION: "Draft with notification",
      CREATED: "Created",
      CONFIRMED: "Ready for fulfillment",
      FAILED: "Failed",
      RE_ORDER: "Re-order",
      RESTOCK: "Restocking",
      ITEMEXCHANGE: "Item exchange",
      PRE_ORDER: "Pre-order",
      BY_VALUE: "By value",
      BY_QUANTITY: "By quantity",
      BOTH: "Both",
      EXTERNAL_ID: "External ID",
      UNCONSTRAINED: "Unconstrained",
      BY_ORDER_TOTAL_AMOUNT: "Minimum expense",
      BY_ORDER_TOTAL_QUANTITY: "Minimum quantity",
      DELIVERED: "Delivered",
      SHIPPED: "Shipped",
      PENDING: "Pending",
      CANCELLED: "Cancelled",
      CONCLUDED: "Fulfilled",
      PARTIAL: "Partial",
      EXPIRED: "Expired",
      INACTIVE: "Inactive",
      AWAITING_PROCESSING: "Awaiting processing",
      TO_BE_PROCESSED: 'To be processed',
      PROCESSING: "Processing",
      PROCESSED: "Processed",
      PROCESSED_WITH_ERRORS: "Processed with errors",
      PROCESSING_FAILURE: "Processing failure",
      PROCESSED_WITH_ISSUES: "Processed with issues",
      ARCHIVED: "Archived",
      SYNCING: "Syncing",
      SINGLE_ORDER: "Single order",
      MULTIPLE_ORDERS: "Multiple orders",
    },
    PROJECT_TYPE: {
      ALL: "All",
      SUBLI: "Subli",
      EVO: "Evo",
    },
    CHANGES_HANDLER: {
      DATE_UNSAVE_CHANGES: "Unsave changes",
      UNDO: "Undo",
      SAVE: "Save",
      IF_YOU_HAVE_PENDING_CHANGES_YOU_WILL_LOSE_THEM:
        "If you have pending changes you will lose them",
    },
    CART: {
      ERROR_DIALOG: {
        TITLE: "Unavailable items",
        UPDATE_DATES: "Update dates",
        UPDATE_DATES2: "Update dates and remove unavailable variants",
        UPDATE_DATES3: "Update dates only",
        UPDATE_DATES4: "Update dates and remove unpublished variants",
        INVALID_DATES: "Invalid dates",
        VARIANT_UNAVAILABLE: "Variants unavailable",
        DELETE_ITEMS: "Remove unavailable",
        LIMIT: "Limit",
        STOCK_QTY: "Stock qty",
        ORDERED_QTY: "Ordered qty",
        AVAILABLE_QTY: "Available qty",
        CART_QTY: "Cart qty",
        POS_LIMIT: "Point of sale limit",
        SKU: "Sku code",
        COLOR: "Color",
        PRODUCT: "Product",
        SIZE: "Size",
        NEW_DATE: "New date",
        MESSAGE1:
          "The following items are no longer available for requested delivery date but they are available for a new date.",
        MESSAGE1_REORDER: "The following items have expired delivery date.",
        MESSAGE1_REORDER2: "The following items have expired delivery dates.",
        MESSAGE2: "Do you want to update delivery dates?",
        MESSAGE3:
          "Some order items are no longer published or available. These will be removed from the cart!",
        MESSAGE4:
          "Attention! You have exceeded the limit for the following style-color combinations. Please review your cart to be able to confirm it.",
        MESSAGE5:
          "Attention! You have exceeded the limit for the current point of sale! Please review your cart to be able to confirm it.",
        MESSAGE6: "Do you want to update delivery date?",
        MESSAGE_MIN_QTY_PER_ORDER:
          "Attention! Some items in the order do not reach the minimum quantity required for that specific style-color!",
        MINIMUM: "Minimum",
        ERROR_REASON: "Error reason",
        REASON: {
          REQUESTED_QTY_NOT_AVAILABLE: "Requested qty not available",
          VARIANT_NOT_AVAILABLE_IN_YOUR_TIER:
            "Variant not available in your tier",
          VARIANT_NOT_AVAILABLE_IN_YOUR_CHANNEL:
            "Variant not available in your channel",
          VARIANT_NO_LONGER_VISIBLE: "Variant no longer visible",
          BLANK_CELL_DATE_NO_LONGER_ACTIVE: "Blank cell date no longer active",
        },
      },
      ATTENTION: "Attention!",
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_CUSTOMER_IS_NOT_APPROVED:
        "You can't confirm this cart because customer is not approved",
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_POINT_OF_SALE_IS_NOT_APPROVED:
        "You can't confirm this cart because point of sale is not approved",
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_LOWER_CART_VALUE:
        "You cannot confirm this cart because the cart total is less than the minimum value allowed in this shop",
      THIS_CART_NOT_AVAILABLE: "This cart is not available",
      NO_PRODUCTS_IN_CART: "No products in cart",
      COMMERCIAL_BLOCK_INFO:
        "A commercial block is active on the current customer.",
      NO_CART_CONF: "This cart cannot be confirmed.",
      DETAILS: {
        CUSTOMER: "Customer",
        GENERAL_INFO: "General info",
        DELIVERY_INFO: "Delivery info",
        POS: "Point of sale",
        BILLING_ADDRESS: "Billing address",
        SEASON_REFERENCE: "Season reference",
        GOK: "GOK",
        SHIPPING: "Shipping to",
        OVERVIEW: "Overview",
        ALTERNATIVE: "Select alternative address",
        REMOVE_CUSTOM: "Remove custom delivery date",
        SET_CUSTOM: "Set custom delivery date",
        INVALID_SELECTION_FOR_CUSTOM_DATES:
          "You cannot set the same custom delivery dates for the same SkuCodes ordered with different suggested delivery dates",
        CUSTOM_DATES: "Custom delivery dates",
        SELECT_ALL: "Select all",
        DESELECT_ALL: "Deselect all",
        SHIPPING_UPDATED: "Shipping address updated",
        NO_OTHER_SHIPPING_ADDRESS_AVAILABLE:
          "No other shipping address available",
        VARIANTS_ALREADY_ORDERED_WITH_REORDER_DATE:
          " items not added because already in cart with expired date. Go to the cart to manage them.",
        PLEASE_SAVE_OR_CANCEL_YOUR_ORDER_CHANGES:
          "Please save or cancel your order changes",
        STYLE_COLOR_QUANTITY_NOT_RESPECTED_MINIMUM:
          "One or more order items do not meet the minimum order quantity",
        TOTAL_COST: "Total Cost",
        TOTAL_MARGIN: "Total Margin",
        TOTAL_DISCOUNT_PERCENTAGE_FROM_RETAIL:
          "Total Discount Percentage from Retail",
        NOTE: "Note",
        DIRECT: "Direct",
      },
      CONTROLLERS: {
        DELETE: "Delete cart",
        DUPLICATE: "Duplicate cart",
        NOTES: "Notes",
        PRINT: "Print",
        ACTIONS: "Actions",
        CONFIRM_ORDER: "Confirm order",
        OPEN_IN_BACKOFFICE: "Open in backoffice",
        CANCEL_CHANGES: "Cancel changes",
        SAVE_CHANGES: "Save changes",
        EDIT_QTY: "Edit quantity",
        COMMERCIAL_AGREEMENT: "Commercial agreement",
        VIEW_IN_BACK_OFFICE: "View cart in Back Office",
      },
      SELECTORS: {
        SHIPPING: {
          TITLE: "Shipping to",
          TEXT: "Shipping address",
          INPUT: "Select shipping address",
          DELIVERY_DATES: "Shipping delivery dates",
        },
        DELIVERY: "Delivery date",
        PRICE: {
          TITLE: "Totals",
          TOT_WHOLESALE_GROSS: "Wholesale Gross",
          TOT_DISCOUNT: "Discount",
          TOT_DISCOUNT_PERC: "Discount %",
          COMM_AGR_DISCOUNT_PERC: "Comm. agr. discount %",
          TOT_WHOLESALE_NET: "Wholesale Net",
          TOT_RETAIL_NET: "Retail",
          TOTAL_CART: "Tot. cart",
        },
        ADDING_INFO:
          "You are adding {{totalPcs}} units, with a total wholesale value of €{{totalWholesale}}",
        ADDING_INFO_LOADING: "You are adding...",
        QUANTITY: "Quantity",
        DISCOUNT: {
          TITLE: "Your discount",
          TEXT: "Your discount",
        },
        PAYMENT: {
          TITLE: "Payment",
          SUB_TITLE: "Payment term",
        },
        BILLING: {
          TITLE: "Billing info",
          SUB_TITLE_CUSTOMER: "Customer",
          SUB_TITLE_ADDRESS: "Billing address",
        },
      },
      PRODUCT: {
        TITLES: {
          NAME: "Product name",
          WHOLESALE: "Tot. wholesale",
          QUANTITY: "Tot. quantity",
        },
        DOT_MENU: {
          REMOVE: "Remove",
          REMOVE_LINE: "Set the row qty to 0",
        },
        ERRORS: {
          UNAVAILABLE: "size unavailable",
          UNAVAILABLES: "sizes unavailable",
        },
      },
      CHECKOUT: {
        YOUR_ORDER: "Your Order",
        HAS_BEEN_CONFIRMED: "has been Confirmed",
        POINT_OF_SALE: "Point of sale",
      },
      PROMOTION: "Promotions used",
      ORDER_NOTES: "Order notes",
    },
    ON_BACK: {
      MODAL: {
        TITLE: "Attention!",
        MESSAGE:
          "You have unsaved changes. Do you want to leave the page without saving?",
        LEAVE_PAGE: "Exit",
        CONTINUE: "Continue",
      },
    },
    FINANTIAL_RISK: {
      FINANTIAL_RISK_CURRENT: "Current financial risk",
      FINANTIAL_RISK_PREVIUS: "Previous financial risk",
      CLASS: "Class",
      SCORE: "Score",
      DESCRIPTION: "Description",
      SUMMARY: "Summary",
      CREDIT_LIMIT: "Credit limit",
      INSOLVENCY: "Insolvency",
      COMPANY_INSOLVENCY: "Company insolvency",
      PROTESTI: "Protests",
      PREJUDICIALS: "Prejudicials",
      NAME: "Name",
      LEGAL_FORM: "Legal form",
      TAX_CODE: "Tax code",
      VAT_CODE: "VAT code",
      COMPANY_NUMBER: "Company number",
      EMAIL: "Email",
      COUNTRY: "Country",
      COMPANY_REG_NUMBER: "Company reg. number",
      PUBLIC_REG_SECTION: "Public reg. section",
      INCORPORATION_DATE: "Incorporation date",
      REA_REGISTRATION_DATE: "REA registration date",
      STATUS: "Status",
      STATUS_DESCRIPTION: "Status description",
      EMPLOYESS: "Employees",
      TURNOVER: "Turnover",
      ACTIVITY_CODE: "Activity code",
      ACTIVITY_DESCRIPTION: "Activity description",
      COMPANY_DETAILS: "Company details",
      STATUS_AND_KEY_FIGURES: "Status and key figures",
      ACTIVITY_DETAILS: "Activity details",
      TELEPHONE: "Telephone",
      ADDRESS: "Address",
      LAST_RATING_CHANGE_AT: "Last rating change at",
      TYPE: "Type",
    },
    IMPORT_PRODUCT_MODAL: {
      RETAIL_DISCOUNT_PERCENTAGE: "Percentage discount from retail",
      DISCOUNT_REQUIRED: "Discount required",
      MAX_DISCOUNT_ALLOWED: "Max discount allowed {{value}}%",
    },
    LOCALIZED_TEXT_EDITOR: {
      ACTIONS: "Az",
      ACTION: {
        SET_DEFAULT: "Set default",
      },
      DEFAULT_LANGUAGE: "Default language",
    },
    OPERATION_LOG: {
      TITLE: "Operations log from ERP for {{value}}",
      OPERATION_LOGS: "Operation logs",
      ORDER: "order #{{value}}",
      FULFILLMENT: "fulfillment #{{value}}",
      LOG_DESCRIPTION: "Log description",
      COLUMNS: {
        CREATION_DATE: "Creation date",
        OPERATION_TYPE: "Operation type",
        OUTCOME: "Outcome",
      },
      OPERATION_TYPE_STATUS: {
        CONFRIMED_ORDER: "Confirmed order",
        FULFILLMENT_CANCELED: "Fulfillment canceled",
        ORDER_ITEMS_INSERTED: "Order items inserted",
        ORDER_ITEMS_UPDATED: "Order items updated",
        ORDER_UPDATED: "Order updated",
        SERVICE_ITEM_INSERTED: "Service item inserted",
        SERVICE_ITEM_UPDATED: "Service item updated",
        SERVICE_ITEM_DELETED: "Service item deleted",
        FULFILLMENT_CREATED: "Fulfillment created",
        FULFILLMENT_UPDATED: "Fulfillment updated",
        FULFILLMENT_PACKAGE_CREATED: "Fulfillment package created",
        FULFILLMENT_PACKAGE_ITEM_CREATED: "Fulfillment package item created",
        ORDER_HEADER_UPDATED: "Order header updated",
        BULK_ADD_ITEMS: "Items added",
        BULK_CHANGE_QTY: "Quantity changed",
        BULK_REPLACE_ITEMS: "Items replaced",
        BULK_CHANGE_WHOLESALE: "Prices changed",
        BULK_CHANGE_DELIVERY_DATE: "Delivery date changed",
        WEBHOOK_NOTIFICATION: "Webhook forwarded to ERP",
        ORDER_SYNC_STATUS: "Order status updated",
        CHANGE_CUSTOMER_OR_POS: "Changed customer/point of sale",
        BULK_CANCEL_ORDER: "Orders canceled",
        BULK_OPERATION_ROLLBACK: "Operation Rollback",
        BULK_REMOVE_ITEMS: "Items removed",
      },
      OUTCOME_STATUS: {
        SUCCESS: "Success",
        FAILED: "Failed",
      },
    },
    CUSTOMIZATION_REQUEST: {
      EXCEL_IMPORT: {
        UPLOAD_FROM_EXCEL: "Upload from Excel",
        MODAL_TITLE: "Upload variants from Excel",
        INSTRUCTIONS: "One file for the whole request — one row = one garment. Download it, write the quantity in QTY, and leave NUMBER and JERSEY TEXT empty for garments without personalization. To personalize a garment, add a row filling in NUMBER and/or JERSEY TEXT and repeating STYLE CODE, CR STYLE NAME, COLOR and SIZE — with QTY set to 1. You can add sizes that are not listed, as long as they exist for that product. Leave QTY empty on the sizes you do not want to order. Do not rename or duplicate the headers, do not change the pre-filled SIZE GROUP, and keep NUMBER formatted as text so values like 07 are not altered by Excel.",
        INSTRUCTIONS_TEAMS: "Same team on more than one product? Copy the rows and change CR STYLE NAME and COLOR.",
        UPLOAD: "Upload",
        FILE_REJECTED: "File not accepted",
        UPLOAD_FAILED: "The file could not be read",
        REVIEW_TITLE: "Review imported variants",
        REVIEW_SUBTITLE: "Check the data read from the file, correct it if needed, then confirm.",
        REPORT: "{{total}} rows read · {{imported}} imported · {{ignored}} left empty",
        WARNINGS_TITLE: "To be checked",
        SAVE_SUCCESS: "Imported data saved ({{count}} sizes)",
        PARTIAL_SAVE: "Partial save",
      },
      CREATE_NEW_CART: "Create new cart from CR",
      PLAYERS: "Players info",
      NO_PLAYERS:
        "No player information was entered for this customization request",
      NO_PLAYERS_TO_EDIT: "There are no players to edit for this product.",
      TITLE: "Customization Request: {{name}}",
      SUCCESSFULLY_SAVED: "Configuration saved successfully",
      HEADER: {
        TITLE: "Title",
        CUSTOMER: "Customer",
        REQUESTER: "Requester",
        CUSTOMER_REQUESTER: "Customer Requester",
        AGENCY_REQUESTER: "Agency Requester",
        DESIGNER: "Designer",
        POINT_OF_SALE: "Point of Sale",
        CUSTOMIZATION_REQUEST_CREATION: "CR. Creation",
        PERSONALIZED_COST: "Customization cost",
        SHIPPING_COST: "Shipping cost",
        DISCOUNT: "Discount percentage that will be applied to the cart",
        ENDORSEMENT_REQUESTER: "Requester approval",
        ENDORSEMENT_DESIGNER: "Designer approval",
        ENDORSEMENT_COMMERCIAL: "Commercial approval",
        ORDER_CREATED: "Order created",
        REQUEST_REJECTED: "Rejected",
        APPROVED_BY_AT: "Approved by {{name}} on {{date}}",
        REJECTED_BY_AT: "Rejected by {{name}} on {{date}}",
        PENDING: "Pending",
        SUPPORT_PHONE: "Support phone",
        POS_PHONE: "POS phone",
        SUPPORT_EMAIL: "Support email",
        TOTAL_QUANTITY: "Total quantity",
        DELIVERY_DATE: "Delivery date",
        LAST_DESIGNER_NOTIFICATION: "Last designer notification",
        TITLE_UPDATED_SUCCESSFULLY: "Title updated successfully",
        REQUESTER_UPDATED_SUCCESSFULLY: "Requester updated successfully",
        DESIGNER_UPDATED_SUCCESSFULLY: "Designer updated successfully",
        POINT_OF_SALE_UPDATED_SUCCESSFULLY:
          "Point of Sale updated successfully",
        ARE_YOU_SURE_DUPLICATE:
          "Are you sure you want to duplicate the customization request",
      },

      REQUESTER_APPROVAL: {
        CHOOSE_TITLE: "Do you want to enter your team's players' information?",
        CHOOSE_DONT_CUSTOMIZE: "No, I don't want to customize",
        CHOOSE_CUSTOMIZE:
          "Yes, I want to enter my players' names and numbers (optional)",
        HOW_MANY: "How many players do you want to enter?",
        SIZES_TITLE:
          "Enter the quantities for each product. Remember, you have a minimum of {{min}} pieces for each product",
        EXTRA_SIZES_TITLE: "Enter extra quantities that are not customized",
        EXTRA_SIZES_TITLE2: " (optional)",
        EXTRA_SIZES_TITLE3:
          ". There are {{n}} products for which you haven't reached the minimum purchase quantity ({{min}} pieces). Enter quantities to reach the minimum purchase for each product.",
        PLAYERS_TITLE:
          "Select a font and enter, for each player, name (optional) and number (mandatory), and select the size for each item you want to link to that player.",
        NUMBER: "Number",
        JERSEY_TEXT: "Name",
        DUPLICATE_PRODUCT: "Duplicate product",
        DUPLICATE_ARE_YOU_SURE:
          "Are you sure you want to duplicate this product in your customization request? If yes, enter the product name in the request and confirm",
        SHOW_PLAYERS_INFO: "Show players' info",
        FONTS: "Fonts",
      },

      NEW_REQUESTER_APPROVAL: {
        MODAL_TITLE: "Customization request approval",
        MODAL_SUBTITLE:
          "Define product quantities and optional additional customizations.",
        ALERT_INFO:
          "This request includes multiple products. To complete the request, you need to enter quantities for each product. Customizations are optional. Remember, you have a minimum of {{min}} pieces for each product.",
        PRODUCTS: "Products",
        INCOMPLETE: "Incomplete",
        COMPLETE: "Complete",
        TOTAL_PIECES: "Total pieces",
        TOTAL_PIECES_RECAP_TITLE: "Quantity summary",
        TOTAL_PIECES_PER_PRODUCT_TITLE: "Quantity summary per product",
        CUSTOMIZED: "Customized",
        WITH_CUSTOMIZATION: "With customization",
        WITHOUT_CUSTOMIZATION: "Without customization",
        QUANTITY_WITHOUT_CUSTOMIZATION:
          "Product quantity without customization",
        SIZE: "Size",
        QUANTITY: "Quantity",
        WS_UNIT: "WS unit",
        CUST_UNIT: "Cust. Unit",
        WS_TOT: "WS tot",
        INSERT: "Insert",
        CUSTOMIZATION: "Product quantity with customization",
        FONTS: "Fonts",
        LOADING_FONTS: "Loading fonts...",
        NUMBER: "Number",
        NAME: "Name",
        ADD_PLAYER: "Add Player",
        IMPORT_PLAYERS: "Import players",
        IMPORT_PLAYERS_HINT:
          "Import number and name from already configured players",
        IMPORT_LAST_CUSTOMIZATION: "Import last customization",
        IMPORT_LAST_CUSTOMIZATION_TOOLTIP:
          "If present, you can import the number and name of the last players entered",
        SAVE_APPROVAL: "Save approval",
        CHECK_QUANTITIES_AND_PLAYERS:
          "Check the quantities and players entered before proceeding with the confirmation",
        NO_SUMMARY_ROWS: "No summary rows.",
        BACK_TO_CUSTOMIZATION_REQUEST: "Back to customization request",
        SIZE_GROUP: {
          ADULT: "Adult",
          YOUTH: "Youth",
          KIDS: "Kids",
        },
      },

      GRAPHICAL_APPROVAL: {
        COLOR_NAME: "Color name",
        COLOR_NAME_TOOLTIP:
          "Example: club name {{currentYear}} + purpose (match, training...)",
        COLOR_NAME_ERROR:
          "This color name is already used for another product.",
      },

      ACTION: {
        APPROVE: "Approve",
        EDIT_CUSTOMIZATION_REQUEST_NAME: "Edit customization request name",
        EDIT_CR_PRODUCT_NAME: "Edit product name in the CR",
        BACK: "Back",
        NEXT: "Next",
        APPROVE_GRAPHICALLY: "Approve Graphically",
        APPROVE_COMMERCIAL: "Approve Commercially",
        LOCK_CONFIGURATOR: "Lock Configurator",
        UNLOCK_CONFIGURATOR: "Unlock Configurator",
        REJECT: "Reject",
        DELETE: "Delete",
        DOWNLOAD_REPORT: "Download report",
        DOWNLOAD_COLOR_REPORT: "Download color report",
        DOWNLOAD_STORE_ORDERS_ITEMS_REPORT: "Download order lines report",
        DOWNLOAD_STORE_ORDERS_REPORT: "Download orders report",
        DOWNLOAD_POINTS_OF_SALE_REPORT: "Download points of sale report",

        DUPLICATE_CUSTOMIZATION_REQUEST: "Duplicate customization request",
        CUSTOMIZATION_REQUEST_ENDORSEMENT: "Customization request approval",
        DELETE_CUSTOMIZATION_REQUEST: "Delete customization request",
        REJECT_CUSTOMIZATION_REQUEST: "Reject customization request",
        INSERT_REJECTION_REASON: "Insert rejection reason",
        ARE_YOU_SURE: "Are you sure?",
        ARE_YOU_SURE_YOU_WANT_TO_LOCK_CONFIGURATOR:
          "Are you sure you want to lock the configurator?",
        ARE_YOU_SURE_YOU_WANT_TO_UNLOCK_CONFIGURATOR:
          "Are you sure you want to unlock the configurator?",
        ARE_YOU_SURE_YOU_WANT_TO_DELETE:
          "Are you sure you want to delete the customization request?",

        DELIVERY_DATE: "Delivery Date",
        FINANCIAL_DISCOUNT: "Financial Discount",
        ADDITIONAL_CUSTOMIZATION_COST:
          "Customization cost on this request (optional)",
        CUSTOMIZATION_REQUEST_APPROVED_SUCCESSFULLY:
          "Customization request approved successfully",
        CONFIGURATOR_LOCKED_SUCCESSFULLY: "Configurator locked successfully",
        CONFIGURATOR_UNLOCKED_SUCCESSFULLY:
          "Configurator unlocked successfully",
        CUSTOMIZATION_REQUEST_REJECTED_SUCCESSFULLY:
          "Customization request rejected successfully",
        CUSTOMIZATION_REQUEST_DELETED_SUCCESSFULLY:
          "Customization request deleted successfully",
        CUSTOMIZATION_REQUEST_DUPLICATED_SUCCESSFULLY:
          "Customization request duplicated successfully",
        REVERT_TO_DRAFT: "Revert to draft",
        REVERT_TO_DRAFT_SUCCESSFULLY:
          "The status of the customization request has been modified successfully",
        NOTIFY_DESIGNER_READY: "Notify Designer",
        DESIGNER_NOTIFIED_SUCCESSFULLY: "Designer notified successfully",
      },
      DETAIL: {
        BACK_TO_CUSTOMIZATION_REQUESTS: "Back to customization requests",
        ORDER: "Order",
        GO_TO_ORDER: "Go to order",
        READ_ONLY_BANNER: "This request is not yours: you can view it in read-only mode, but you cannot edit or delete it.",
        DETAIL: "Details",
        TIMELINE: "Timeline",
        MEDIA: "Media",
        CHANNEL_NAME: "Channel Name",
        STATUS: "Status",
        CONFIGURATOR_LOCKED: "Configurator Locked",
        CUSTOMIZED_PRODUCTS: "Customized Products",
        ADD_PRODUCT: "Add Product",
        SELECT_PRODUCT: "Select Product",
      },
      MEDIA: {
        FILE_NAME: "File name",
        USER_NAME: "User name",
        USER_ROLE: "User role",
        DOCUMENT_GRAPHICAL_APPROVAL: "Documents graphical approval",
        DOWNLOAD_DOCUMENT: "Download document",
        ATTACHMENTS_OF_CUSTOMIZATION_REQUEST:
          "Attachments of customization request",
        DOWNLOAD_ALL: 'Download all',
      },
      UPLOAD_FILE: {
        ERROR_FILE_MAX_SIZE:
          "<strong>Error! </strong> The file exceeds the maximum allowed size of {{maxSize}}",
        ERROR_FILE_TYPE:
          "<strong>Error! </strong> The file type is not allowed, the allowed types are: {{allowedTypes}}",
        ATTACH_DOCUMENT: "Attach document",
        ATTACH_IMAGE: "Attach image",
        ATTACHMENT: "Attachment",
        BROWSE: "Browse",
        CHOSE_DOCUMENT: "Choose document",
        CHOSE_IMAGE: "Choose image",
      },

      CUSTOMIZATION_PRODUCT: {
        PRODUCT_DELETED_SUCCESSFULLY: "Product deleted successfully",
        PERSONALIZE: "Customize",
        COLOR_NAME: "Color Name",
        COLOR_CODE: "Color Code",
        START_3D_VIEWER: "Start 3D viewer",

        SKU: "Style code",
        PRODUCT_NAME: "Style name",
        TEMPLATE_ID: "Template ID",
        ID: "ID",
        WHOLESALE_TOTAL_PRICE: "Wholesale tot.",

        TABLE: {
          SIZE: "Size",
          QUANTITY: "Quantity",
          WHOLESALE_UNIT_PRICE: "Wholesale unit",
          CUSTOMIZATION_UNIT_PRICE: "Customization unit",
          WHOLESALE_TOTAL_PRICE: "Wholesale tot.",
        },
      },

      TIMELINE: {
        CUSTOMIZATION_REQUEST_CREATED: "Customization request created",
        CUSTOMIZATION_REQUEST_REJECTED: "Customization request rejected",
        PRODUCT_ADDED: "Product added",
        PRODUCT_DELETED: "Product deleted",
        POINT_OF_SALE_UPDATED: "Point of sale updated",
        CONFIGURATOR_LOCKED: "Configurator locked",
        CONFIGURATOR_UNLOCKED: "Configurator unlocked",
        STATUS_RESET_TO_DRAFT: "Status reset to draft",
        APPROVED_BY_REQUESTER: "Approved by requester",
        APPROVED_GRAPHICALLY: "Approved graphically",
        APPROVED_COMMERCIAL: "Approved commercially",
        DEFAULT_DESIGNER_ASSIGNED: "Default designer assigned",
        DESIGNER_REASSIGNED: "Designer reassigned",
        REQUESTER_REASSIGNED: "Requester reassigned",
        CUSTOMER_REQUESTER_REASSIGNED: "Customer requester reassigned",
        AGENCY_REQUESTER_REASSIGNED: "Agency requester reassigned",
        MESSAGE_ADDED: "Message added",
        MEDIA_ADDED: "Media added",
        DESIGNER_NOTIFIED: "Designer notified",
        ORDER_ISSUED: "Customization request ordered",
        BY: "by {{name}}",
        HIDE_MESSAGE_FROM_REQUESTER: "Hide message from requester",
        READ_MORE: "Read more",
        READ_LESS: "Read less",
        FOR_CR_PRODUCT: "for product: #{{value}}",
        REQUESTING_NEW_DESIGN: "with new design request",
        TRANSLATE_MESSAGE: "Translate message",
        SHOW_ORIGINAL_MESSAGE: "Show original message",
      },
      CONFIGURATOR: {
        BACK_TO_CUSTOMIZATION_REQUEST: "Back to customization request",
        PRODUCT_CONFIGURATOR: "Product configurator #{{sku}} - {{title}}",
      },
      INHERIT_OR_RESET_SIZES_FROM_CR: "Reuse or reset sizes from CR",
      INHERIT_OR_RESET_SIZES_FROM_CR_DESCRIPTION:
        "Do you want to reuse sizes from the previous customization request or reset them?",
      RESET_SIZES: "Reset sizes",
      INHERIT_SIZES: "Reuse sizes",
    },
    //cross translate
    DUPLICATE_CART: {
      TITLE: "Duplicate cart",
      CUSTOMER: "Customer",
      POINT_OF_SALES: "Point of sales",
      CART_NAME: "Cart name",
      ALTERNATIVE_SHIPPING_ADDRESS: "Alternative shipping address",
      SUCCESS_CART_DUPLICATED: "Cart duplicated successfully",
      ERROR_CART_DUPLICATED: "Error while duplicating one or more products",
      DUPLICATE_CART: "Duplicate cart",
      SET_REQUEST_DELIVERY_DATE: "Set request delivery date",
      AGENCY: "Agency",
      CART_DUPLICATED_PARTIALLY: "Cart duplicated partially",
      CART_NOT_DUPLICATED: "Cart not duplicated",
      VARIANTS_NOT_ADDED: "Variants not added",
      VARIANT: "Variant",
      VARIANT_NOT_AVAILABLE: "Variant not available",
      QUANTITY_INSUFFICIENT: "quantity insufficient",
      REQUESTED_QUANTITY: "requested quantity",
      AVAILABLE_QUANTITY: "available quantity",
      MANUAL_DISCOUNT: "Include applied manual discounts",
      PENDING_FULFILLMENT: "Duplicate only unfulfilled order items",
      OPTION_DUPLICATE_ORDER: "Duplicate order options",
      INCLUDE_CUSTOM_DELIVERIES: "Include custom deliveries",
      SKIP_CHECKS: "Exclude visibility and quantity controls",
    },
    CHANNEL: {
      BROWSE: "Browse",
      TITLE: "Channel",
    },

    CONFIRM_CART_MODAL: {
      TITLE: "Confirm cart",
      SUB_TITLE: "You are confirming cart",
      ATTENTION_THIS_CUSTOMER_HAVE_A_COMMERCIAL_BLOCK_ACTIVE:
        "This client has active trade blocking. Are you sure you want to confirm the order anyway?",
      YOU_HAVE_VOUCHERS_AVAILABLE_THAT_YOU_CAN_APPLY_TO_THIS_CART:
        "You have vouchers available that you can apply to this cart",
      NO_ENTERED_ATTACHMENTS: "No attachments entered",
      SELECT_VOUCHER: "Select voucher",
      RESIDUAL_VOUCHER_VALUE: "Residual voucher value: {{value}}",
      TOTAL_CART: "Total cart: {{value}}",
      TERMS_AND_CONDITIONS: "Terms and conditions",
      ACCEPT_TERMS_AND_CONDITIONS: "I accept the terms and conditions",
      NO_VOUCHERS_AVAILABLE: "No vouchers available",
      VOUCHERS_UNAVAILABLE: "Voucher functionality temporarily unavailable",
      CONFIRM: "Confirm",
      COMMERCIAL_AGREEMENT: "Commercial agreement",
      YOU_HAVE_COMMERCIAL_AGREEMENTS_AVAILABLE_THAT_YOU_CAN_APPLY_TO_THIS_CART:
        "You have commercial agreements available that you can apply to this cart",
      SELECT_COMMERCIAL_AGREEMENT: "Select commercial agreement",
      DISCOUNT: "Discount",
      COMMERCIAL_AGREEMENT_ID_IS_NOT_VALID:
        "The commercial agreement previously associated with this cart is no longer valid. Select another one or remove the old one",
      REMOVE_COMMERCIAL_AGREEMENT: "Remove commercial agreement",
      YOU_DONT_HAVE_COMMERCIAL_AGREEMENTS_AVAILABLE_THAT_YOU_CAN_APPLY_TO_THIS_CART:
        "You have no commercial agreements available that you can apply to this cart",
      SAVE: "Save",
      MANAGE_DELIVERY_DATES: "Manage delivery dates",
      OPTION_TITLE: "Confirm options",
      EXCLUDE_CONTROLS: "Exclude controls on visibility and quantity",
      INFO_EXCLUDE_CONTROLS:
        "By excluding the controls on visibility and quantity, the cart will be confirmed without checking the availability of the products and the visibility of the commercial rules",
      DONT_SENT_EMAIL: "Don't send confirmation email",
      POPULATE_DEFAULT_RECIPIENTS: "Populate with default recipients",
    },

    PAGINATION: {
      ITEM_FOR_PAGE: "Items per page",
      PAGE: "Page",
      OF: "of",
    },

    EVALUATE_CART_SALE_CAMPAIGN_CONSTRAINT: {
      COMMERCIAL_RULES: "Commercial rules",
      ALERT: {
        TITLE: "Attention!",
        MESSAGE:
          'The commercial rule "{{commercialRuleName}}" for the sales campaign "{{saleCampaignName}}" has been activated on this cart.',
        MORE_INFO: "Show details",
        CLICK_HERE_FOR_MORE_INFO: "Click here to show details",
        CART_NOT_CONFIRMABLE:
          "A business rule is active on this cart for which one or more constraints are not satisfied",
        FOR_CONFIRM_CART:
          ",in order to confirm it, all constraints must be satisfied.",
        ROLE_BYPASS:
          "Your role allows you to confirm the cart even if not all constraints are satisfied.",
        CONSTRAINTS_IS_SATISFIED:
          "A business rule is active on this cart and its constraints are satisfied",
      },

      MODAL: {
        DETAIL_COMMERCIAL_RULE:
          "Detail commercial rule: {{commercialRuleName}}",
        MISSING_ITEMS_OF_PRODUCTS:
          "You are missing {{missingNumberOfItems}} pieces among the products: {{stylesCode}}",
        VALUE_CONSTRAINT_NOT_REACHED:
          "The items in this assortment do not meet the minimum percentage compared to the total wholesale, considering also the previous orders placed in the current sales campaign (total wholesale {{computedTotalWholesaleForMatchedItems}}€, corresponding to {{computedPercentageOfTotalWholesaleForMatchedItems}}%, while the threshold is {{constrainedTotalWholesaleMinimumPercentage}}%; missing €{{missingWholasale}})",
        VALUE_CONSTRAINT_REACHED: "Satisfied value constraint",
        VALUE_CONSTRAINT:
          "({{computedTotalWholesaleForMatchedItems}}€, corresponding to the {{computedPercentageOfTotalWholesaleForMatchedItems}}%)",
        ALL_PACKAGE_CONSTRAINTS_ARE_SATISFIED: "Package constraints satisfied",
        CONSTRAINTS_ON_ASSORTMENT:
          "Constraints on assortment: {{assortmentName}}",
      },
    },

    CUSTOM_SHIP_DATES: {
      ITEMS_WITH_NO_STOCK1: "Some dates were not added: ",
      ITEMS_WITH_NO_STOCK2: " items have no available stock quantity",
      TITLE: "Custom ship dates",
      SELECT_ALL: "Select all",
      UNSELECT_ALL: "Unselect all",
      BULK_PERSONALIZED_DATE: "Customize delivery dates ({{numberOfItems}})",
      VIEW_SELECTION: "({{n}}) items selected",
      CUSTOM_DATE: "Custom date",
      DATE_NOT_SELECTABLE: "Date not selectable",
      REMOVE_ALL_CUSTOM_DATES: "Remove custom dates",
      DATE_OVER_MAX_DATE:
        "One or more items have a custom date that exceeds the maximum customization date set in this store",
      REQUESTED_DATE_OVER_MAX_DATE:
        "One or more selected items are not customizable because the original requested delivery date exceeds the maximum customization date set in this store",
      ON: "on",
      FROM: "from",
      TO: "to",
      ADD_NEW_DATE: "Add new date",
      EDIT_DATE: "Edit date",
      DATE: "Date",
      QTY: "Q.ty",
      ERROR_THE_SUM_OF_THE_QUANTITIES_FOR_CUSTOM_DATES_IS_GREATER_THAN_THE_QUANTITY_ORDERED:
        "Error! The sum of the quantities for the custom dates is greater than the quantity ordered",
      ERROR_THE_SUM_OF_THE_QUANTITIES_FOR_CUSTOM_DATES_IS_LESS_THAN_THE_QUANTITY_ORDERED:
        "Error! The sum of the quantities for the custom dates is less than the quantity ordered",
      ERROR_THERE_ARE_DUPLICATE_DATES: "Error! There are duplicate dates",
      ERROR_THE_CURRENT_DATE_IS_OVER_THE_MAX_DATE:
        "Error! The current date is greater than the maximum date",
      INFO_MODAL_TITLE: "New method for customizing delivery dates",
      INFO_MODAL_CONTENT:
        "Customizing the delivery dates of items within a cart is now available via the order confirmation window (see screenshot below). It will no longer be possible to carry out this operation using the actions used up to now.",
      OK: "I understood",
      COL_ORDER_ITEM: "Order item",
      N_ORDER_ITEMS: "N° order items",
      ORIGINAL_DATE: "Original date",
    },

    CUSTOMIZATION_REQUEST_CREATOR: {
      PERSONALIZE: "Customize",
      BACK: "Back",
      CONFIRM: "Confirm",
      REQUEST_CONFIGURATION: "Request new design",
      DOWNLOAD_THUMBNAIL: "Download thumbnail",
      SAVE: "Save",
      CHANGE_TEMPLATE: "Change Template",
      CREATED_SUCCESSFULLY: "Customization request created successfully",
      PRODUCT_ADDED_SUCCESSFULLY: "Product added successfully",
      STEP_1: {
        TITLE: "New Customization",
        MESSAGE:
          "Do you want to create a new customization request or use an existing one?",
        NEW_CR: "New Request",
        EXISTING_CR: "Existing Request",
      },
      STEP_2: {
        TITLE: "New Customization Request",
        SELECT_REQUESTER:
          "Select at least one requester. You may select a customer and/or an agent",
        SELECT_REQUESTER_2:
          "As an agency user, you can also link this customization request to a customer",
        SELECT_REQUESTER_3:
          "As a customer user, you can also link this customization request to an agent, if your store is managed by an agency",
        TITLE_REQUEST: "Request Title",
        TITLE_REQUEST_TOOLTIP: "Example: club name {{currentYear}}.",
        COMMENTS: "Product name in the request",
        COMMENTS_TOOLTIP: "Example: club name + purpose (match, training...)",
        POS_PHONE: "Point of Sale Phone Number",
        POS_PHONE_TOOLTIP: "Phone number associated with the point of sale. If already on file, it will be pre-filled.",
        POS_PHONE_EXAMPLES_TITLE: "Examples by country:",
      },
      STEP_3: {
        TITLE: "Select Customization Request",
        SELECT_REQUEST: "Select Request",
      },
      STEP_4: {
        TITLE: "Select a Base Template",
        DESCRIPTION: "Customization Request: {{name}}",
      },
      STEP_5: {
        TITLE: "Request Configuration for Customization: {{name}}",
        DESCRIPTION: "Template #{{expiviId}}",
      },
      STEP_6: {
        TITLE: "Configuration for Request: {{name}}",
        DESCRIPTION: "Template #{{expiviId}}",
      },

      CONFIGURATION_MESSAGE: {
        PLACEHOLDER: "Describe the product you would like to request",
        MESSAGE_OF_REQUEST: "Message of the request",
        ATTACHMENTS: {
          TITLE: "Attachments",
          ADD: "Add Attachment",
        },
      },

      VALIDATION: {
        AT_LEAST_ONE_REQUESTER:
          "Please select at least one requester (Customer or Agency)",
        REQUESTERS_MUST_BE_DIFFERENT:
          "Customer requester and Agency requester must be different users",
        PHONE_REQUIRED: "Phone number is required",
      },
    },
    BASIC_KUSTOM_REQUESTER: {
      CUSTOMER: "Customer",
      AGENT: "Agent",
      CUSTOMER_REQUESTER: "Customer Requester",
      SELECT_AGENCY: "Select Agency",
      SELECT_AGENT: "Select Agent",
      THIS_POINT_OF_SALES_DOES_NOT_HAVE_ANY_AGENCY:
        "This point of sale does not have any agency",
      SECTION_CLIENTE: "Customer",
      SECTION_USER: "User",
      POINT_OF_SALE: "Point of Sale",
    },

    //SHOP TRANSLATE

    POS_STOCK_INFO: {
      TITLE: "Point of sale stock info",
      LOADING: "Loading stock info..",
      ORDERABLE_QTY: "Orderable quantity for current point of sale",
      ORDERABLE_QTY2: "In the current cart you can add more",
      CART_QTY: "Quantity in the current cart",
      TOTAL: "Total",
    },
    COMMON: {
      SET: "Set",
      SAVE: "Save",
      MIN: "Min",
      MAX: "Max",
      FROM: "From",
      TO: "To",
      SHOW: "Show",
      ONLY: "only",
      IN: "in",
      SHOW_ONLY: "Show only",
      SHOW_MORE: "Show more",
      SUGG_RETAIL: "Sugg. retail",
      SEARCH: "Search",
      DATES_CHECKBOX: "Show only weeks with available products",
      DELIVERY_DATES: "Delivery dates",
      PCS: "pcs",
      WHOLESALE: "Wholesale",
      SUGGESTED: "Suggested",
      VALID: "Valid",
      TYPE: "Type",
      EXPAND_ALL: "Expand all",
      COLLAPSE_ALL: "Collapse all",
      PRODUCTS: "Products",
      COMMERCIAL_BLOCK_ACTIVE: "Commercial block active",
      MAN: "Man",
      WOMAN: "Woman",
      UNISEX: "Unisex",
    },
    HEADER: {
      PRE_ORDER: "Pre-order",
      RE_ORDER: "Re-order",
      MY_CARTS: "My carts",
      CART: "Cart",
      CARTS: "Carts",
      SELECT_CHANNEL: "Select channel",
    },
    ACCOUNT_POPUP: {
      MY_ACCOUNT: "My account",
      BACK_OFFICE: "Back-office",
      LOGOUT: "Logout",
      SWITCH_TENANT: "Switch country",
      CHANGE_LINGUAGE: "Change language",
      SHOW_ONLY_RETAIL_PRICES: "Show only retail prices",
    },
    DIALOGS: {
      USE_TIER_FILTER: "Set a filter based on tier settings",
      NO_TIER: "Information not linked to any tier",
      SELECT_TIER: "Information linked to a specific tier",
      ARE_YOU_SURE_YOU_WANT_TO_CONFIRM_THIS_CART_BLOCKED:
        "Attention! this client has active trade blocking. Are you sure you want to confirm the order anyway?",
      DO_YOU_WANT_TO_LOGOUT: "Do you want to logout?",
      DO_YOU_WANT_TO_DELETE_THIS_CART: "Do you want to delete this cart?",
      DO_YOU_WANT_TO_CONFIRM_THIS_ORDER: "Do you want to confirm this order?",
      DO_YOU_WANT_TO_DELETE: "Do you want to delete",
      CREATE_NEW_CART: "Create new cart",
      CREATE_CART: "Create cart",
      EDIT_CART: "Edit cart",
      COPY_CART: "Copy cart",
      TYPE_A_NEW_CART_NAME: "Type...",
      AGENCY: "Agency",
      NEW_CART_NAME: "Cart name",
      NO_SEASON_REFERENCE_AVAILABLE: "No season reference available",
      CANT_CONFIRM_THIS_ORDER: "Can't confirm this order",
      CANCEL: "Cancel",
      CONFIRM: "Confirm",
      SAVE: "Save",
      GOK_MODE: "GOK",
      GOK_CART: "Gok cart",
      CREATE_PRICE_LIST: "Create price list",
      EDIT_PRICE_LIST: "Edit price list",
      DELETE_PRICE_LIST: "Delete price list",
      DELETE_PRICE_LIST_CONFIRM:
        "Are you sure you want to delete this price list?",
      ASSOCIATE_CUSTOMERS: "Associate customers",
    },
    FOOTER: {
      COPYRIGHT: "Copyright BasicGroup 2025",
      PRIVACY_POLICY: "Privacy policy",
      TERMS: "Terms and conditions",
      TERMS_NOT_FOUND: "Terms and conditions not found",
      FOR_CLUBS: "For clubs",
      NO_DATA: "No data available, please contact the administrator.",
      RESET: "Reset password",
      TEXT: "BasicItalia S.r.l. - Strada della Cebrosa 106, 10100 Torino, Italy - P.IVA e CF IT1234567890",
      BUTTON: "Help",
    },
    CART_POPUP: {
      CLOSE: "Close",
      PIECES: "Pieces",
      PRODUCTS: "Products",
      RE_ORDER_CARTS: "RE-ORDER",
      PRE_ORDER_CARTS: "PRE-ORDER",
      SELECTED_CURRENT:
        "The selected Cart is the cart you are currently shopping with",
      SELECTED: "Selected",
      NAVIGATE: "Go to cart",
      WHOLESALE_PRICE: "Wholesale price",
      CREATED: "Created",
      DELIVERY_DATES: "Delivery on",
      CONTROLLERS: {
        DELETE: "Delete selected cart",
        CREATE: "Create new cart",
        GO_TO_CHECKOUT: "Go to checkout",
        NO_CARTS: "No carts, please create new.",
      },
    },
    FILTERS: {
      STRATEGIC: "Strategic",
      PROMO: "On promo",
      CUSTOMIZABLE: "Customizable",
      AVAILABLE_NOW: "Available now",
      GENDER: "Gender",
      SIZE_GROUP: "Size group",
      STYLE_GROUP: "Style group",
      COLLECTIONS: "Collections",
      COLORS: "Colors",
      CATEGORY: "Category",
      PURPOSE: "Purpose",
      ASSORTMENTS: "Assortments",
      TEAM: "Team",
      SEASON: "Season",
      AVAILABILITY: "Availability",
      WHOLESALE_PRICE: "Wholesale",
      SUGGESTED_RETAIL_PRICE: "Suggested retail",
      NO_DATA: "No data",
      TAGS: "Tags",
      APPLAY_FILTERS: "Apply filters",

      CLEAR_ALL: "Clear all",
    },
    SIZE_GROUPS: {
      ADULT: "Adult",
      YOUTH: "Youth",
      KID: "Kid",
      INFANT: "Infant",
    },
    SIZES_TABS: {
      LIMIT: "Limit",
      COLOR: "Color",
      PRICE: "Price",
      DOT_MENU: {
        COPY: "Copy",
        PASTE: "Paste",
        CLEAR_ALL: "Clear all",
        REMOVE_ALL: "Remove all",
      },
      ADD: "Add to cart",
      TOT_PCS: "Tot pcs.",
      MAX_QTY_REACHED: "Max quantity reached",
      QTY_NOT_AVAILABLE: "Quantity not available",
    },
    BREADCRUMBS: {
      HOME: "Home",
      RE_ORDER: "re-order",
      PRE_ORDER: "pre-order",
      CATALOG: "Catalog",
    },
    HOME: {
      SHOP: {
        CATALOG: "Explore all catalog",
        BROWSE: "Browse by",
      },
      CATEGORIES: {
        TITLE: "Categories",
        TEXT: "Shop by categories \n and place your order in just a few clicks",
        BUTTON: "Browse the entire catalog",
      },
      VIDEO: {
        TITLE: "What's new this season?",
        TEXT: "Find out what we have for you this season: key products, new technologies and more",
      },
      COLLECTIONS: {
        TITLE: "Assortments",
        TEXT: "Explore our wide range of assortments, carefully selected for you.",
        EXPLORE: "Discover all assortments",
      },
      PRODUCTS: {
        TITLE: "Our strategic products",
        TEXT: "Find out what are the key products you must have for next season",
        BUTTON: "Shop strategic",
        ADD_TO_CART: "Add to cart",
      },
      PROMOTIONS: {
        TITLE: "Promotions",
        EXPLORE: "Discover all the promotions",
      },
      SHOWCASE: {
        ALL: "All",
        EXPLORE: "Explore the {{name}} catalog",
        SHOP_NOW: "Shop now",
        DISCOVER_MORE: "Discover all products for {{name}}",
      },
    },
    PRODUCTS: {
      LIST: {
        FILTERS: "Filters",
        ACTIVE_FILTERS: "Active filters",
        BROWSE_BY: "Browse by",
        ITEMS: "Items",
        ORDER_BY: "Order by",
        NO_PRODUCTS: "No products",
        NO_ASSORTMENTS: "No assortments",
        VIEW: "View",
        GRID: "Grid",
        LIST: "List",
      },
      DETAIL: {
        ERROR_VARIANTS_ALREADY_PRESENT:
          "The following variants are already in the cart with a different requested delivery date than the selected one ({{date}}):",
        STYLE_COLOR_QUANTITY_LIMIT_EXCEEDED:
          "You are exceeding style-color quantity limit",
        STYLE_COLOR_QUANTITY_NOT_RESPECTED_MINIMUM:
          "You are trying to add one or more items that do not meet the minimum order quantity",
        PROMO: {
          ORDER: "Order",
          MORE_OF: "Additional article to have the",
          MORE_MORE_OF: "More items to have the",
          MORE_OF_VALUE: "€ More items, to get the",
          DISCOUNT: "Discount",
          QUANTITY: "Quantity",
          PRICE: "Price",
          VIEW_PROMO: "View promo",
          TITLE: "Promotions",
          PROMOTION_NAME: "Name",
          RANGE: "Validity range",
          TYPE: "Promo type",
          VALIDITY_PERIOD: "Validity period",
          ITEM_IN_YOUR_CART: "Pieces in your cart",
          VALUE_IN_YOUR_CART: "Value in your cart",
          INFO_ALLERT:
            "Attention! Promotions will not be applied on variants that have a channel discount",
        },
        INFO: {
          SHOP_SELLING_PERIOD: "Shop selling period",
          PRICE_LIST: "Price list",
        },
        ADDITIONAL: {
          PRODUCT_DESCRIPTION: "Product description",
          PRODUCT_INFO: "Product info",
          PURPOSE: "Purpose",
          DESCRIPTION: "Description",
          SEASON: "Season",
          GENDER: "Gender",
        },
        CS: {
          TITLE: "Colors ans sizes",
          DELIVERY_DATE: "Delivery \n date",
          PLACEHOLDER: "Search color",
        },
        CONTROLLERS: {
          CLEAR_ALL: "Clear all quantities",
          ADD_ALL: "Add quantities to cart",
          COMPRESS: "Compress",
          EXPAND: "Expand",
        },
        NO_AVAILABLE: {
          TEXT: "This product is non longer available on pre-order. Please to on re-order catalog to place your order",
          BUTTON: {
            PRE_ORDER: "Shop product on pre-order",
            RE_ORDER: "Shop product on re-order",
          },
        },
        SAME: "Styles in the same assortment",
        SIMILAR: "Similar styles in other assortments",
        NO_VARIANTS_PUBLISHED:
          "NO VARIANTS PUBLISHED FOR THE CURRENT SIZE GROUP IS AVAILABLE FOR THE SELECTED DATE",
        ERROR_QUANTITY:
          "Attention! Requested quantity not available. Maximum quantity available set",
      },
      CARD: {
        WHOLESALE: "Wholesale",
        RETAIL: "Retail",
        AVAILABILITY: "pieces available",
      },
    },
    ORDER_CHECKOUT: {
      LIMITED_REORDER_PIECES_VIOLATION_TITLE: "Limited re-order pieces limit exceeded",
    },
    ERRORS: {
      TITLE: "Error message",
      PRODUCT_LOADING: "Error occurred while product loading",
      INVALID_ORDER: "Order is invalid",
      DEFAULT_MESSAGE: "Sorry something went wrong. Please try again later",
    },
    COLLECTION_CARD: {
      SHOP_ASSORTMENT: "Shop assortment",
    },
    PROMOTION_CARD: {
      SHOP_PROMO: "Shop promo",
    },

    VARIANT_GRID: {
      CUSTOMER_DISCOUNT: "The customer you're buying for has a discount of",
      USE_ACTION: "Use action",
      USING_PERC: "applying the discount of",
      ADD_DELIVERY_WITH_STOCK: "Add a delivery with stock qty",
      ADD_DATE_WITH_STOCK: "Add date with stock qty",
      QTY_AVAILABLE_IN_STOCK: "Qty av. in stock",
      USE_OLD_VERSION: "Use previous version",
      USE_NEW_VERSION: "Use the new version",
      NEW_SIZE_GRID_NOTICE:
        "The new size grid is available. From here you can choose which version to use.",
      A_CUSTOM_DELIVERY: "a custom delivery",
      REORDER_SECTION: "re-order section",
      SELECT_COLORS: "Select colors to view dates and quantities",
      ADD_DELIVERY: "Add custom delivery",
      ON_DATE: "On this date",
      COLORS: "Colors",
      PCS_ORDERED: "Pcs ordered",
      CUSTOM_ADD: "Custom Add",
      ADD_QTY: "Add qty",
      SELECT_CUSTOM_DELIVERY: "Select your custom delivery",
      ADD_ITEMS_CUSTOM: "Add items with custom options",
      CANT_MANAGE_DATES: "You can't manage delivery dates in",
      DISCOUNT_APPLIED_ALL:
        "The discount will be applied to every item you are adding, including those for which quantities were already entered.",
      DIFF_PRICE_WARNING:
        "You are adding items with different price, so you can't set desired wholesale price to calculate the discount.",
      PERCENTAGE: "Percentage",
      DISCOUNT_NAME: "Discount name",
      DISCOUNT_TYPE: "Discount type",
      DESIRED_WHOLESALE: "Desired wholesale",
      DISCOUNT_PCT: "Discount percentage",
      CLEAR_QUANTITY: "Clear quantity",
      ADD_ALL: "Add all",
      ADD: "Add",
      PRE_COMPILE_WITH_AVAILABLE_QTY: "Prefill with available quantities",
      PRECOMPILE: "Prefill",
      COPY: "Copy input values",
      PASTE: "Paste copied values",
      COPIED: "Copied values!",
      PASTED: "Pasted values!",
      ADD_AVAILABLE_QUANTITY: "Add available quantity",
      QTY_AVAILABLE: "Quantity available",
      QTY_IN_CART: "Quantity in cart",
      THERE_ARE_NO_AVAILABLE_QUANTITIES_TO_ADD:
        "There are no available quantities to add",
      MAX_QTY_REACHED: "Max quantity reached",
      QTY_NOT_AVAILABLE: "Quantity not available",
      QTY_NOT_AVAILABLE_BY_CLICKING_SAVE_THE_VARIANT_WILL_BE_REMOVED:
        'Quantity not available. By clicking "Save" the variant will be removed.',
      LIMIT_EXCEEDED_FOR_PALETTE: "Exceeded limit for palette: {{paletteCode}}",
      HAVE_BEEN_PRECOMPILED_CLICK_ON_ADD_TO_ADD_THEM_TO_YOUR_CART:
        'Color <b>{{colorCode}}</b> quantities have been precompiled. Click on "Add" to add them to your cart.',
      HAVE_BEEN_PRECOMPILED_CLICK_ON_ADD_TO_ADD_THEM_TO_YOUR_CART_ALL:
        'Available quantities have been precompiled. Click on "Add all" to add them to your cart.',
      INPUTS_RESET_TO_ZERO: "Inputs reset to 0.",
      ITEMS_ADDED_TO_CART: "<b>{{sumQtyAdded}}</b> items added to cart.",
      NO_QUANTITIES_TO_ADD: "There are no quantities to add.",
      RESET_QUANTITIES_INPUTS: "Reset quantity input",
      NO_COLORS_FOUND: "No colors found",
      NO_COLORS_FOUND_HINT: "To see the variants, create a cart and make sure there is an active sales campaign.",
      NO_AVAILABLE_DATES: "No available delivery dates",
      CHOOSE_DELIVERY_DATE: "Delivery date",
      DATES: "({{numberDate}} availables)",
      SUGG_RETAIL: "Sugg retail",
      MAX: "Max",
      SUGG: "Sugg",
      PROMOTION_TABLE: "Show promotions",
      PRICE_TABLE: "Show prices",
      PRICE_TABLE_TITLE: "Price table",
      PROMOTION_TABLE_TITLE: "Promotion table",
      BY_VALUE: "By value purchased",
      BY_QUANTITY: "By quantity purchased",
      QUANTITY: "Quantity",
      MIN_QTY_ERROR: ' The minimum quantity is not met',
    },

    MODAL_ATTENTION_CHANGE_ORDER_QTY: {
      LOSE_CUSTOM_DELIVERY_DATES:
        "By changing quantities, you will lose the custom dates you set! Remember to reset it when confirming your order",
      ARE_YOU_SURE: "Are you sure?",
      CONFIRM: "Confirm",
    },

    PROMOTION_STEPS: {
      ITEMS_IN_THE_CART: "Items in the cart {{products}}",
      PROMOTION_DISCOUNT: "Promotion discount {{discount}}%",
      ADD_PCS_FOR_REACH_PROMO_DISCOUNT:
        "Add {{pcs}} pcs for reach the promotion discount",
      CART_VALUE: "Cart value {{value}}",
      ADD_VALUE_FOR_REACH_PROMO_DISCOUNT:
        "Add {{value}} for reach the promotion discount",
      PROMOTION: "Promotion",
    },
    BULK_OPERATIONS: {
      STATUS: {
        AWAITINGPROCESSING: "Awaiting processing",
        PROCESSING: "Processing",
        PROCESSEDWITHOUTISSUES: "Processed",
        PROCESSINGFAILURE: "Processing failure",
        PROCESSEDWITHISSUES: "Processed with issues",
      },
      TYPES: {
        ADDNEWITEMS: "Add New Items",
        REMOVEITEMS: "Remove Items",
        REPLACEITEMS: "Replace Items",
        EDITQUANTITY: "Change Quantity",
        CHANGEITEMSDELIVERYDATE: "Change Delivery Date",
        EDITWHOLESALEPRICE: "Change net price",
        CHANGERETAILPRICE: "Change retail price",
        UPDATEERPSERVICEITEMS: "Extra costs updated",
        CHANGECUSTOMERANDSHIPPINGADDRESS: "Change Customer and Point of Sale",
        CANCELORDER: "Cancel Orders",
        UPDATEFROMTEMPLATE: "Update from Template",
        UPDATEORDERHEADER: "Update Order Header",
      },
      SCOPES: {
        SINGLEORDER: "Single Order",
        MULTIPLEORDERS: "Multiple Orders",
      },
      MODAL: {
        TITLE: "Operation Details",
        TAB1_TITLE: "ERP Log",
        TAB2_TITLE: "Issues",
      },
      FILTER: {
        ALL: 'All bulk operations',
        ONLY_MINE: 'Your bulk operations',
      },
      BACK_TO_BULK_OPERATIONS: "Operations",
      PROCESSED_ORDER_ITEMS_COUNT: "Items Processed",
      PROCESSED_WITH_ISSUES_COUNT: "Issues",
      PENDING_OPERATIONS: "Pending Bulk Operations",
      LOADING_OPERATIONS: "Loading operations...",
      NO_PENDING_OPERATIONS: "No Pending Operations",
      NO_PENDING_OPERATIONS_DESC:
        "All bulk operations for this order have been processed.",
      TOTAL_OPERATIONS: "Total {{count}} operations in queue",
      VIEW_DETAILS: "View Details",
      VIEW_PENDING_OPERATIONS: "View pending operations",
      CREATED_BY: "Created by",
      AFFECTED_ITEMS: "Affected Items",
      ADD_NEW_ITEMS: "Add New Items",
      REMOVE_ITEMS: "Remove Items",
      REPLACE_ITEMS: "Replace Items",
      CHANGE_QUANTITY: "Change Quantity",
      CHANGE_DELIVERY_DATE: "Change Delivery Date",
      ADD_DELIVERIES: "Add deliveries",
      DELIVERIES_TO_ADD: "Deliveries to add",
      CHANGE_WHOLESALE_PRICE: "Change net price",
      CHANGE_RETAIL_PRICE: "Change retail price",
      UPDATE_SERVICE_ITEMS: "Extra costs updated",
      CHANGE_CUSTOMER_AND_POS: "Change Customer and Point of Sale",
      CANCEL_ORDERS: "Cancel Orders",
      UPDATEFROMTEMPLATE: "Update Order from template",
      UPDATE_ORDER_HEADER: "Update Order Header",
      SINGLE_ORDER: "Single Order",
      MULTIPLE_ORDERS: "Multiple Orders",
      UPDATE_FROM_TEMPLATE: "Update from Template",
      PRODUCT: "SKU Code-EAN",
      DELIVERY_DATE: "Delivery Date",
      UNKNOWN: "Unknown",
      UNKNOWN_SCOPE: "Unknown Scope",
      ITEMS_TO_ADD: "Items to Add",
      ITEMS_TO_REMOVE: "Items to Remove",
      ITEMS_TO_REPLACE: "Items to Replace",
      QUANTITY_CHANGES: "Quantity Changes",
      DELIVERY_DATE_CHANGES: "Delivery Date Changes",
      PRICE_CHANGES: "Price Changes",
      CUSTOMER_AND_POS_CHANGES: "Customer and Point of Sale Changes",
      CUSTOMER: "Customer",
      POINT_OF_SALE: "Point of Sale",
      ORDER_CANCELLATION: "Order Cancellation",
      OLD_PRODUCT: "Old SKU Code-EAN",
      NEW_PRODUCT: "New SKU Code-EAN",
      NEW_PRICE: "New Price",
      OLD_QUANTITY: "Old Quantity",
      NEW_QUANTITY: "New Quantity",
      OLD_DATE: "Old Date",
      NEW_DATE: "New Date",
      OLD_PRICE: "Old Price",
      FROM: "From",
      TO: "To",
      CANCELLATION_REASON_ID: "Cancellation Reason ID",
      QUANTITY: "Quantity",
      DELIVERY: "Delivery",
      REASON: "Reason",
      PRICE: "Price",
      TYPE: "Type",
    },
    REPORTS: {
      STORE_VARIANTS: "Store variants",
      STORE_ORDERS: "Store orders",
      STORE_ORDERS_ITEMS: "Store orders items",
    },
    GRID: {
      RESET_COLUMN_ORDER: "Reset column order",
    },
    ORDER_GRID: {
      BULK_EDIT: {
        SYNC_LATER_SUCCESS:
          "{{count}} order(s) saved: bulk edit queued and will be synced later.",
        SYNC_NOW_SUCCESS:
          "{{count}} order(s) saved: bulk edit is being synced now.",
      },
      BULK_DELETE: {
        SYNC_LATER_SUCCESS: "{{count}} order(s) queued for cancellation and will be synced later.",
        SYNC_NOW_SUCCESS: "{{count}} order(s) queued for cancellation and sync is being processed now.",
      },
    },
    PENDING_BULK: {
      SYNC_SELECTED: "Sync selected operations ({{count}})",
      SYNC_ALL: "Sync all pending operations",
      INFO_MESSAGE: "You are viewing all your pending bulks.",
      ONLY_YOU: "Only you",
      YOU_AND_OTHERS: "You and other users",
      SYNC: "Sync",
      GO_TO_ORDER: "Go to order",
      VIEW_ALL_BULK_OPERATIONS: "View all bulk operations",
      PENDING: "Pending",
      SYNCED: "Synced",
      TAB: {
        EDIT_ORDERS: "Edit orders",
        VIEW_PENDING_BULK: "View pending bulk operations",
      },
      MINES: "Mine",
      OTHERS: "Others",
      OTHER_USERS: "Other users",
      FILTER: {
        VISIBILITY: "Show",
        ALL_USERS: "All users",
        ONLY_MINE: "Only mine",
      },
      SYNC_SUCCESS: "Sync started successfully",
      SYNC_ALL_SUCCESS: "Sync started for all pending operations",
      COLUMNS: {
        PENDING_OPERATIONS: "N pending operations",
        HANDLED_BY: "Pending operations handled by",
      },
      CONFIRM_MODAL: {
        SINGLE_TITLE: "Sync pending operations?",
        ONLY_YOU_MESSAGE:
          "You are about to sync the pending operations for the selected order(s). Remember: you will not be able to do other operations until the sync is completed.",
        WITH_OTHERS_MESSAGE:
          "This order is currently being modified by other team members. Syncing will also sync other users's pending operations in the selected orders. How would you like to proceed? Remember: you will not be able to do other operations regarding this order until the sync is completed.",
        SYNC_ALL_MESSAGE:
          "You are about to sync all pending operations for this order. No one will be able to do other operations until the sync is completed.",
        MIXED_SELECTION_MESSAGE:
          "Some orders in your selection are currently being modified by other team members. Syncing will also sync other users's pending operations in the selected orders. How would you like to proceed? Remember: no one will be able to do other operations regarding these orders until the sync is completed.",
        EXCLUDE_IN_USE_BTN: "Exclude orders in use",
        SYNC_ALL_BTN: "Sync all",
      },
    },
    POWER_BI: {
      LOAD_ERROR: "Unable to load Power BI reports. Please try again later.",
      FILTERS_TITLE: "Filters",
      FILTER_PLACEHOLDER: "Select...",
      CANCEL: "Cancel",
      APPLY: "Apply",
      MONTH: "Month",
      CAMPAIGN: "Campaign",
      SEASON: "Season",
      POINT_OF_SALE: "Point of sale",
      CUSTOMER: "Customer",
      AGENCY: "Agency",
    },
  },
};
